import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type ApiKey = {
  __typename?: 'APIKey';
  createdAt?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type Analytics = {
  __typename?: 'Analytics';
  analyticsId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dataset: Scalars['String']['output'];
  datasetId: Scalars['String']['output'];
  /** @deprecated Support for member ends at the 1.1.0 release, please upgrade your client or use createdBy instead. */
  member?: Maybe<Scalars['String']['output']>;
  /** @deprecated Support for range has ended, please upgrade your client. */
  range?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  result?: Maybe<Scalars['String']['output']>;
  /** @deprecated Support for returnImages has ended, please upgrade your client. */
  returnImages?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type AnalyticsFilter = {
  datasets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  status?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type AnalyticsLog = {
  __typename?: 'AnalyticsLog';
  analyticsId: Scalars['String']['output'];
  datasetId: Scalars['String']['output'];
  log?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type AnalyticsSearchDetail = {
  __typename?: 'AnalyticsSearchDetail';
  status?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type Annotation = {
  __typename?: 'Annotation';
  annotationId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datasetId: Scalars['String']['output'];
  format: Scalars['String']['output'];
  map?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type AnnotationFilter = {
  datasets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  status?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type AnnotationLog = {
  __typename?: 'AnnotationLog';
  annotationId: Scalars['String']['output'];
  datasetId: Scalars['String']['output'];
  log?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type AnnotationMap = {
  __typename?: 'AnnotationMap';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  mapId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AnnotationMapFilter = {
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type AnnotationMapSearchDetail = {
  __typename?: 'AnnotationMapSearchDetail';
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type AnnotationSearchDetail = {
  __typename?: 'AnnotationSearchDetail';
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type Banner = {
  __typename?: 'Banner';
  bannerColor?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
};

export type Channel = {
  __typename?: 'Channel';
  channelId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  documentation?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt: Scalars['String']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

export type ChannelDeployment = {
  __typename?: 'ChannelDeployment';
  channelId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  deploymentId: Scalars['String']['output'];
  status: ChannelDeploymentStatus;
  updatedAt: Scalars['String']['output'];
};

export type ChannelDeploymentStatus = {
  __typename?: 'ChannelDeploymentStatus';
  message: Scalars['String']['output'];
  state: Scalars['String']['output'];
  step: Scalars['String']['output'];
};

export type ChannelDocumentationUpload = {
  __typename?: 'ChannelDocumentationUpload';
  fields?: Maybe<ChannelUploadFields>;
  key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ChannelFilter = {
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type ChannelOrganization = {
  __typename?: 'ChannelOrganization';
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type ChannelSearchDetail = {
  __typename?: 'ChannelSearchDetail';
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type ChannelUploadFields = {
  __typename?: 'ChannelUploadFields';
  algorithm?: Maybe<Scalars['String']['output']>;
  bucket?: Maybe<Scalars['String']['output']>;
  credential?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type Charge = {
  __typename?: 'Charge';
  billing_details?: Maybe<CustomerPaymentInformationBillingDetails>;
  id?: Maybe<Scalars['String']['output']>;
  payment_method_details?: Maybe<ChargePaymentMethodDetails>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ChargePaymentMethodDetails = {
  __typename?: 'ChargePaymentMethodDetails';
  card?: Maybe<ChargePaymentMethodDetailsCard>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ChargePaymentMethodDetailsCard = {
  __typename?: 'ChargePaymentMethodDetailsCard';
  brand?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  exp_month?: Maybe<Scalars['String']['output']>;
  exp_year?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

export type ContentCode = {
  __typename?: 'ContentCode';
  code: Scalars['String']['output'];
  contactUs: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  featured: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type CustomerInformation = {
  __typename?: 'CustomerInformation';
  address?: Maybe<CustomerInformationAddress>;
  email?: Maybe<Scalars['String']['output']>;
  invoice_settings?: Maybe<CustomerInformationInvoiceSettings>;
  name?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type CustomerInformationAddress = {
  __typename?: 'CustomerInformationAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type CustomerInformationInvoiceSettings = {
  __typename?: 'CustomerInformationInvoiceSettings';
  default_payment_method?: Maybe<Scalars['String']['output']>;
};

export type CustomerPaymentInformation = {
  __typename?: 'CustomerPaymentInformation';
  billing_details?: Maybe<CustomerPaymentInformationBillingDetails>;
  card?: Maybe<CustomerPaymentInformationCardDetails>;
  created?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<CustomerPaymentInformationMetadata>;
  object?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CustomerPaymentInformationBillingDetails = {
  __typename?: 'CustomerPaymentInformationBillingDetails';
  address?: Maybe<CustomerPaymentInformationBillingDetailsAddress>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type CustomerPaymentInformationBillingDetailsAddress = {
  __typename?: 'CustomerPaymentInformationBillingDetailsAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type CustomerPaymentInformationCardDetails = {
  __typename?: 'CustomerPaymentInformationCardDetails';
  brand?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  exp_month?: Maybe<Scalars['Int']['output']>;
  exp_year?: Maybe<Scalars['Int']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  funding?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

export type CustomerPaymentInformationMetadata = {
  __typename?: 'CustomerPaymentInformationMetadata';
  organization?: Maybe<Scalars['String']['output']>;
};

export type Dataset = {
  __typename?: 'Dataset';
  annotations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  channel?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['String']['output']>;
  classes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Support ends at the 1.1.0 release, please upgrade your client. */
  count?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Support ends at the 1.1.0 release, please upgrade your client or use datasetId instead. */
  datasetid?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Scalars['Int']['output']>;
  graph?: Maybe<Scalars['String']['output']>;
  graphId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  runs?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Support ends at the 1.1.0 release, please upgrade your client or use runs instead. */
  scenarios?: Maybe<Scalars['String']['output']>;
  seed?: Maybe<Scalars['String']['output']>;
  services?: Maybe<MicroserviceSupport>;
  size?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** @deprecated Support ends at the 1.1.0 release, please upgrade your client or use createdBy instead. */
  user?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type DatasetFilter = {
  channels?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  graphs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  runs?: InputMaybe<Array<InputMaybe<IntComparator>>>;
  size?: InputMaybe<Array<InputMaybe<FloatComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type DatasetJob = {
  __typename?: 'DatasetJob';
  averageRuntime?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
  estimatedEndAt?: Maybe<Scalars['String']['output']>;
  graph?: Maybe<Scalars['String']['output']>;
  graphId?: Maybe<Scalars['String']['output']>;
  instancesQueued?: Maybe<Scalars['Int']['output']>;
  instancesRunning?: Maybe<Scalars['Int']['output']>;
  instancesStarting?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  runs?: Maybe<Scalars['Int']['output']>;
  runsCancelled?: Maybe<Scalars['Int']['output']>;
  runsFailed?: Maybe<Scalars['Int']['output']>;
  runsQueued?: Maybe<Scalars['Int']['output']>;
  runsRunning?: Maybe<Scalars['Int']['output']>;
  runsStarting?: Maybe<Scalars['Int']['output']>;
  runsSuccess?: Maybe<Scalars['Int']['output']>;
  runsTimeout?: Maybe<Scalars['Int']['output']>;
  seed?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type DatasetJobFilter = {
  channels?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  graphs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  runs?: InputMaybe<Array<InputMaybe<IntComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type DatasetJobSearchDetail = {
  __typename?: 'DatasetJobSearchDetail';
  channels?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  type?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type DatasetLog = {
  __typename?: 'DatasetLog';
  channelId?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Support ends at the 1.1.0 release, please upgrade your client or use createdBy instead. */
  email?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  log?: Maybe<Scalars['String']['output']>;
  run?: Maybe<Scalars['Int']['output']>;
  runId?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type DatasetMetrics = {
  __typename?: 'DatasetMetrics';
  channelId?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  metrics?: Maybe<Scalars['String']['output']>;
  run?: Maybe<Scalars['Int']['output']>;
  runId?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type DatasetRun = {
  __typename?: 'DatasetRun';
  channelId?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  run?: Maybe<Scalars['Int']['output']>;
  runId?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type DatasetSearchDetail = {
  __typename?: 'DatasetSearchDetail';
  channels?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  type?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type DatasetUpload = {
  __typename?: 'DatasetUpload';
  fields?: Maybe<DatasetUploadFields>;
  key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DatasetUploadFields = {
  __typename?: 'DatasetUploadFields';
  algorithm?: Maybe<Scalars['String']['output']>;
  bucket?: Maybe<Scalars['String']['output']>;
  credential?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type DateComparator = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteEditorSessionOutput = {
  __typename?: 'DeleteEditorSessionOutput';
  editorSessionId: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<RemoteDevelopmentStatus>;
};

export type EcrDeployment = {
  __typename?: 'ECRDeployment';
  deploymentId: Scalars['String']['output'];
  ecrEndpoint: Scalars['String']['output'];
  ecrPassword: Scalars['String']['output'];
};

export type ExactComparator = {
  eq?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
};

export type Feedback = {
  __typename?: 'Feedback';
  feedbackId: Scalars['String']['output'];
  uploads?: Maybe<Array<Maybe<FeedbackUpload>>>;
};

export type FeedbackUpload = {
  __typename?: 'FeedbackUpload';
  fields?: Maybe<FeedbackUploadFields>;
  key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FeedbackUploadFields = {
  __typename?: 'FeedbackUploadFields';
  algorithm?: Maybe<Scalars['String']['output']>;
  bucket?: Maybe<Scalars['String']['output']>;
  credential?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type FloatComparator = {
  gte?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};

export type GanData = {
  __typename?: 'GANData';
  fields?: Maybe<UploadFields>;
  modelId: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type GanDataset = {
  __typename?: 'GANDataset';
  /** @deprecated Support for channelId is ending at 1.1.0, please remove from your client. */
  channelId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  datasetId: Scalars['String']['output'];
  /** @deprecated Support for datasetid is ending at 1.1.0, please use datasetId. */
  datasetid?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated Support for files is ending at 1.1.0, please remove from your client. */
  files?: Maybe<Scalars['String']['output']>;
  /** @deprecated Support for ganmodelId is ending at 1.1.0, please use modelId. */
  ganmodelId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Support for ganparent is ending at 1.1.0, please use parentId. */
  ganparent?: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parentId: Scalars['String']['output'];
  /** @deprecated Support for scenarios is ending at 1.1.0, please remove from your client. */
  scenarios?: Maybe<Scalars['String']['output']>;
  /** @deprecated Support for size is ending at 1.1.0, please remove from your client. */
  size?: Maybe<Scalars['String']['output']>;
  /** @deprecated Support for source is ending at 1.1.0, please remove from your client. */
  source?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt: Scalars['String']['output'];
  updatedBy: Scalars['String']['output'];
  /** @deprecated Support for user is ending at 1.1.0, please use createdBy. */
  user?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type GanDatasetLog = {
  __typename?: 'GANDatasetLog';
  datasetId: Scalars['String']['output'];
  log?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type GanModel = {
  __typename?: 'GANModel';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type GanModelFilter = {
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type GanModelSearchDetail = {
  __typename?: 'GANModelSearchDetail';
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type GanOrganization = {
  __typename?: 'GANOrganization';
  organization: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type Graph = {
  __typename?: 'Graph';
  channel: Scalars['String']['output'];
  channelId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  graphId: Scalars['String']['output'];
  /** @deprecated Support ends at the 1.1.0 release, please upgrade your client or use graphId instead. */
  graphid?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  previewId?: Maybe<Scalars['String']['output']>;
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  showPreview?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** @deprecated Support ends at the 1.1.0 release, please upgrade your client or use createdBy instead. */
  user?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type GraphFilter = {
  channels?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type GraphSearchDetail = {
  __typename?: 'GraphSearchDetail';
  channels?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type GraphUpdateReponse = {
  __typename?: 'GraphUpdateReponse';
  description?: Maybe<Scalars['String']['output']>;
  graph?: Maybe<Scalars['String']['output']>;
  graphId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  showPreview?: Maybe<Scalars['Boolean']['output']>;
  uid?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type GraphValidationError = {
  __typename?: 'GraphValidationError';
  errorMessage?: Maybe<Scalars['String']['output']>;
  input?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Hyperparameter = {
  __typename?: 'Hyperparameter';
  default?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  step?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type ImageInference = {
  __typename?: 'ImageInference';
  dataset?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  inferenceId?: Maybe<Scalars['String']['output']>;
  inferences?: Maybe<Array<Maybe<Inference>>>;
  model?: Maybe<Scalars['String']['output']>;
  modelId?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type Inference = {
  __typename?: 'Inference';
  bbox?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  class?: Maybe<Scalars['Int']['output']>;
  className?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['String']['output']>;
};

export type Inpaint = {
  __typename?: 'Inpaint';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<Scalars['String']['output']>;
  dilation?: Maybe<Scalars['Int']['output']>;
  inpaintId: Scalars['String']['output'];
  inputType?: Maybe<InpaintInputType>;
  location: Scalars['String']['output'];
  outputType?: Maybe<InpaintOutputType>;
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  volumeId: Scalars['String']['output'];
};

export type InpaintFormat = {
  __typename?: 'InpaintFormat';
  info?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum InpaintInputType {
  Coco = 'COCO',
  Geojson = 'GEOJSON',
  Kitti = 'KITTI',
  Mask = 'MASK',
  Pascal = 'PASCAL',
  Yolo = 'YOLO'
}

export type InpaintLog = {
  __typename?: 'InpaintLog';
  inpaintId: Scalars['String']['output'];
  log?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  volumeId: Scalars['String']['output'];
};

export enum InpaintOutputType {
  Jpg = 'JPG',
  Png = 'PNG',
  SatrgbBackground = 'SATRGB_BACKGROUND'
}

export type IntComparator = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
};

export type Invitation = {
  __typename?: 'Invitation';
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated with 1.0.0 release, please upgrade your client. */
  invitationId?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  role?: Maybe<RoleType>;
  /** @deprecated Deprecated with 1.1.0 release, please upgrade your client or use createdAt instead. */
  timestamp?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated with 1.0.0 release, please upgrade your client. */
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type LlmChannelNodeTypes = {
  __typename?: 'LLMChannelNodeTypes';
  baseChannel: Scalars['String']['output'];
  nodeTypes?: Maybe<Array<Scalars['String']['output']>>;
};

export type LlmResponse = {
  __typename?: 'LLMResponse';
  baseChannel: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  nodeName: Scalars['String']['output'];
  nodeResponse?: Maybe<Scalars['String']['output']>;
  nodeType: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  promptId: Scalars['String']['output'];
  schemaResponse?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type LinkedApp = {
  __typename?: 'LinkedApp';
  appId: Scalars['String']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  linked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type MlArchitecture = {
  __typename?: 'MLArchitecture';
  annotations?: Maybe<Scalars['String']['output']>;
  architectureId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hyperparameters?: Maybe<Array<Maybe<Hyperparameter>>>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MlInference = {
  __typename?: 'MLInference';
  architecture?: Maybe<Scalars['String']['output']>;
  architectureId?: Maybe<Scalars['String']['output']>;
  architectureType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dataset: Scalars['String']['output'];
  datasetId: Scalars['String']['output'];
  inferenceId: Scalars['String']['output'];
  map?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  metrics?: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type MlInferenceFilter = {
  architectures?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type MlInferenceLog = {
  __typename?: 'MLInferenceLog';
  inferenceId: Scalars['String']['output'];
  log?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type MlInferenceSearchDetail = {
  __typename?: 'MLInferenceSearchDetail';
  architectures?: Maybe<Array<Maybe<SearchDetail>>>;
  status?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type MlModel = {
  __typename?: 'MLModel';
  architecture: Scalars['String']['output'];
  architectureId: Scalars['String']['output'];
  architectureType?: Maybe<Scalars['String']['output']>;
  checkpoints?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  classes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dataset: Scalars['String']['output'];
  datasetId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  map?: Maybe<Scalars['String']['output']>;
  mapId?: Maybe<Scalars['String']['output']>;
  metrics?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parameters?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type MlModelFilter = {
  architectures?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type MlModelLog = {
  __typename?: 'MLModelLog';
  log?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type MlModelSearchDetail = {
  __typename?: 'MLModelSearchDetail';
  architectures?: Maybe<Array<Maybe<SearchDetail>>>;
  status?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type ManagedChannel = {
  __typename?: 'ManagedChannel';
  channelId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  instanceType: Scalars['String']['output'];
  interfaceVersion?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  organizations?: Maybe<Array<Maybe<ChannelOrganization>>>;
  preview?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timeavg?: Maybe<Scalars['Int']['output']>;
  timeout?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  volumes: Array<Maybe<Scalars['String']['output']>>;
};

export type ManagedGan = {
  __typename?: 'ManagedGAN';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Scalars['String']['output']>;
  modelId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  organizations?: Maybe<Array<Maybe<GanOrganization>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ManagedMap = {
  __typename?: 'ManagedMap';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  mapId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  organizations?: Maybe<Array<Maybe<MapOrganization>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ManagedVolume = {
  __typename?: 'ManagedVolume';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  organizations?: Maybe<Array<Maybe<VolumeOrganization>>>;
  permission?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  volumeId: Scalars['String']['output'];
};

export type MapData = {
  __typename?: 'MapData';
  fields?: Maybe<UploadFields>;
  key?: Maybe<Scalars['String']['output']>;
  mapId: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type MapOrganization = {
  __typename?: 'MapOrganization';
  organization: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type Member = {
  __typename?: 'Member';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  role: RoleType;
  userId: Scalars['String']['output'];
};

export type MicroserviceSupport = {
  __typename?: 'MicroserviceSupport';
  analytics?: Maybe<Scalars['Boolean']['output']>;
  annotations?: Maybe<Scalars['Boolean']['output']>;
  gan?: Maybe<Scalars['Boolean']['output']>;
  inference?: Maybe<Scalars['Boolean']['output']>;
  training?: Maybe<Scalars['Boolean']['output']>;
  umap?: Maybe<Scalars['Boolean']['output']>;
};

export type MultipartInput = {
  eTag: Scalars['String']['input'];
  partNumber: Scalars['Int']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** @deprecated Support for addChannelOrganization has ended, please upgrade your client. */
  addChannelOrganization?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for addGANOrganization has ended, please upgrade your client. */
  addGANOrganization?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for addMapOrganization has ended, please upgrade your client. */
  addMapOrganization?: Maybe<Scalars['Boolean']['output']>;
  addMember?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for addVolumeOrganization has ended, please upgrade your client. */
  addVolumeOrganization?: Maybe<Scalars['Boolean']['output']>;
  attachPaymentMethodToCustomer: Scalars['String']['output'];
  clearDatasetJobs?: Maybe<Scalars['Boolean']['output']>;
  createAPIKey: Scalars['String']['output'];
  createAnalytics: Scalars['String']['output'];
  createAnnotation: Scalars['String']['output'];
  createDataset?: Maybe<Scalars['String']['output']>;
  createFeedback: Feedback;
  createGANDataset: Scalars['String']['output'];
  createGraph: Scalars['String']['output'];
  createInpaint: Scalars['String']['output'];
  createLLMPrompt: Scalars['String']['output'];
  createLinkedApp?: Maybe<Scalars['Boolean']['output']>;
  createMLInference: Scalars['String']['output'];
  createMLModel: Scalars['String']['output'];
  createManagedChannel: Scalars['String']['output'];
  /** @deprecated Support for createManagedGAN has ended, please upgrade your client. */
  createManagedGAN: GanData;
  createManagedGANV2: UploadGanResponse;
  createManagedGANV2Finalizer?: Maybe<Scalars['Boolean']['output']>;
  createManagedMap: MapData;
  createManagedVolume: Scalars['String']['output'];
  createMixedDataset: Scalars['String']['output'];
  createPaymentIntent: Scalars['String']['output'];
  createPreview: Scalars['String']['output'];
  createRemoteDevelopment: RemoteDevelopmentApiOutput;
  createSSHKey: Scalars['Boolean']['output'];
  createSubscriptionForUser: Scalars['String']['output'];
  createUMAP: Scalars['String']['output'];
  createWorkspace: Scalars['String']['output'];
  deleteAPIKey?: Maybe<Scalars['Boolean']['output']>;
  deleteAnalytics: Scalars['Boolean']['output'];
  deleteAnnotation: Scalars['Boolean']['output'];
  deleteDataset?: Maybe<Scalars['Boolean']['output']>;
  deleteGANDataset?: Maybe<Scalars['Boolean']['output']>;
  deleteGraph?: Maybe<Scalars['Boolean']['output']>;
  deleteInpaint: Scalars['Boolean']['output'];
  deleteLLMPrompt: Scalars['Boolean']['output'];
  deleteLinkedApp?: Maybe<Scalars['Boolean']['output']>;
  deleteMLInference: Scalars['Boolean']['output'];
  deleteMLModel: Scalars['Boolean']['output'];
  deleteManagedChannel?: Maybe<Scalars['Boolean']['output']>;
  deleteManagedGAN?: Maybe<Scalars['Boolean']['output']>;
  deleteManagedMap: Scalars['Boolean']['output'];
  deleteManagedVolume?: Maybe<Scalars['Boolean']['output']>;
  deleteOrganization?: Maybe<Scalars['Boolean']['output']>;
  deletePreview?: Maybe<Scalars['Boolean']['output']>;
  deleteRemoteDevelopment: DeleteEditorSessionOutput;
  deleteSSHKey: Scalars['Boolean']['output'];
  deleteUMAP: Scalars['Boolean']['output'];
  deleteUser?: Maybe<Array<Maybe<OrganizationAdmin>>>;
  deleteVolumeData: Array<Maybe<Scalars['String']['output']>>;
  deleteWorkspace: Scalars['String']['output'];
  deployManagedChannel: EcrDeployment;
  downloadAnnotation: Scalars['String']['output'];
  downloadDataset?: Maybe<Scalars['String']['output']>;
  downloadGraph?: Maybe<Scalars['String']['output']>;
  downloadMLInference: Scalars['String']['output'];
  downloadMLModel: Scalars['String']['output'];
  downloadManagedGAN: Scalars['String']['output'];
  downloadManagedMap: Scalars['String']['output'];
  duplicateGraph?: Maybe<Scalars['String']['output']>;
  editAnalytics: Scalars['Boolean']['output'];
  editAnnotation: Scalars['Boolean']['output'];
  editDataset?: Maybe<Scalars['Boolean']['output']>;
  editDefaultGraph?: Maybe<Scalars['Boolean']['output']>;
  editGraph?: Maybe<Scalars['Boolean']['output']>;
  editMLInference: Scalars['Boolean']['output'];
  editMLModel: Scalars['Boolean']['output'];
  editManagedChannel?: Maybe<Scalars['Boolean']['output']>;
  editManagedGAN?: Maybe<Scalars['Boolean']['output']>;
  editManagedMap: Scalars['Boolean']['output'];
  editManagedVolume?: Maybe<Scalars['Boolean']['output']>;
  editMember?: Maybe<Scalars['Boolean']['output']>;
  editOrganization?: Maybe<Scalars['Boolean']['output']>;
  editUMAP: Scalars['Boolean']['output'];
  editVolumeData?: Maybe<Scalars['Boolean']['output']>;
  editWorkspace: Scalars['String']['output'];
  editWorkspaceThumbnail: Scalars['String']['output'];
  initializeUser?: Maybe<Scalars['Boolean']['output']>;
  mountVolumes?: Maybe<VolumeCredentials>;
  pingPreview?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for putVolumeData has ended, please upgrade your client. */
  putVolumeData: Array<Maybe<VolumeData>>;
  putVolumeDataThumbnail: UploadVolumeDataThumbnailResponse;
  putVolumeDataV2: UploadVolumeDataResponse;
  putVolumeDataV2Finalizer?: Maybe<Scalars['Boolean']['output']>;
  removeChannelOrganization?: Maybe<Scalars['Boolean']['output']>;
  removeGANOrganization?: Maybe<Scalars['Boolean']['output']>;
  removeMapOrganization?: Maybe<Scalars['Boolean']['output']>;
  removeMember?: Maybe<Scalars['Boolean']['output']>;
  removeVolumeOrganization?: Maybe<Scalars['Boolean']['output']>;
  saveDefaultPaymentMethod: Scalars['String']['output'];
  setChannelGraph?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for setOrganizationLimit has ended, please upgrade your client. */
  setOrganizationLimit?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for setPlatformLimit has ended, please upgrade your client. */
  setPlatformLimit?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Support for setWorkspaceLimit has ended, please upgrade your client. */
  setWorkspaceLimit?: Maybe<Scalars['Boolean']['output']>;
  signIn?: Maybe<UserCredentials>;
  startRemoteDevelopment: RemoteDevelopmentStartStopApiOutput;
  stopRemoteDevelopment: RemoteDevelopmentStartStopApiOutput;
  updateOrganizationPlan: Scalars['String']['output'];
  uploadChannelDocumentation?: Maybe<Array<Maybe<ChannelDocumentationUpload>>>;
  /** @deprecated Support for uploadDataset has ended, please upgrade your client. */
  uploadDataset?: Maybe<DatasetUpload>;
  uploadDatasetV2: UploadDatasetResponse;
  uploadDatasetV2Finalizer?: Maybe<Scalars['Boolean']['output']>;
  uploadMLModel: UploadMlModelResponse;
  uploadMLModelFinalizer?: Maybe<Scalars['Boolean']['output']>;
  validateGraph?: Maybe<Array<Maybe<GraphValidationError>>>;
};


export type MutationAddChannelOrganizationArgs = {
  channelId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationAddGanOrganizationArgs = {
  modelId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationAddMapOrganizationArgs = {
  mapId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationAddMemberArgs = {
  email: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddVolumeOrganizationArgs = {
  organizationId: Scalars['String']['input'];
  permission: Scalars['String']['input'];
  volumeId: Scalars['String']['input'];
};


export type MutationAttachPaymentMethodToCustomerArgs = {
  organizationId: Scalars['String']['input'];
  paymentMethodId: Scalars['String']['input'];
};


export type MutationClearDatasetJobsArgs = {
  datasetId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateApiKeyArgs = {
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateAnalyticsArgs = {
  datasetId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationCreateAnnotationArgs = {
  datasetId: Scalars['String']['input'];
  format: Scalars['String']['input'];
  mapId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationCreateDatasetArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  graphId: Scalars['String']['input'];
  instanceType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  runs?: InputMaybe<Scalars['Int']['input']>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationCreateFeedbackArgs = {
  description: Scalars['String']['input'];
  files: Array<InputMaybe<Scalars['String']['input']>>;
  summary: Scalars['String']['input'];
};


export type MutationCreateGanDatasetArgs = {
  datasetId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationCreateGraphArgs = {
  channelId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  graph: Scalars['String']['input'];
  name: Scalars['String']['input'];
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationCreateInpaintArgs = {
  destination?: InputMaybe<Scalars['String']['input']>;
  dilation?: InputMaybe<Scalars['Int']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inputType?: InputMaybe<InpaintInputType>;
  location: Scalars['String']['input'];
  outputType?: InputMaybe<InpaintOutputType>;
  volumeId: Scalars['String']['input'];
};


export type MutationCreateLlmPromptArgs = {
  baseChannel: Scalars['String']['input'];
  nodeName: Scalars['String']['input'];
  nodeType: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};


export type MutationCreateLinkedAppArgs = {
  appId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationCreateMlInferenceArgs = {
  datasetId: Scalars['String']['input'];
  mapId?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationCreateMlModelArgs = {
  architectureId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationCreateManagedChannelArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  instance?: InputMaybe<Scalars['String']['input']>;
  interfaceVersion?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreateManagedGanArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreateManagedGanv2Args = {
  description?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreateManagedGanv2FinalizerArgs = {
  key: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateManagedMapArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreateManagedVolumeArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  permission?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreateMixedDatasetArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parameters: Scalars['String']['input'];
  seed?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationCreatePaymentIntentArgs = {
  amount: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationCreatePreviewArgs = {
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationCreateRemoteDevelopmentArgs = {
  channelId: Scalars['String']['input'];
  channelVersion?: InputMaybe<Scalars['String']['input']>;
  instanceType?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateSshKeyArgs = {
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateSubscriptionForUserArgs = {
  organizationId: Scalars['String']['input'];
  paymentId: Scalars['String']['input'];
  priceId: Scalars['String']['input'];
};


export type MutationCreateUmapArgs = {
  datasetIds: Array<InputMaybe<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  samples: Array<InputMaybe<Scalars['Int']['input']>>;
  seed?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationCreateWorkspaceArgs = {
  channelIds: Array<InputMaybe<Scalars['String']['input']>>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationDeleteApiKeyArgs = {
  name: Scalars['String']['input'];
};


export type MutationDeleteAnalyticsArgs = {
  analyticsId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationDeleteAnnotationArgs = {
  annotationId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationDeleteDatasetArgs = {
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationDeleteGanDatasetArgs = {
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationDeleteGraphArgs = {
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationDeleteInpaintArgs = {
  inpaintId: Scalars['String']['input'];
  volumeId: Scalars['String']['input'];
};


export type MutationDeleteLlmPromptArgs = {
  promptId: Scalars['String']['input'];
};


export type MutationDeleteLinkedAppArgs = {
  appId: Scalars['String']['input'];
};


export type MutationDeleteMlInferenceArgs = {
  inferenceId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationDeleteMlModelArgs = {
  modelId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationDeleteManagedChannelArgs = {
  channelId: Scalars['String']['input'];
};


export type MutationDeleteManagedGanArgs = {
  modelId: Scalars['String']['input'];
};


export type MutationDeleteManagedMapArgs = {
  mapId: Scalars['String']['input'];
};


export type MutationDeleteManagedVolumeArgs = {
  volumeId: Scalars['String']['input'];
};


export type MutationDeleteOrganizationArgs = {
  organizationId: Scalars['String']['input'];
};


export type MutationDeletePreviewArgs = {
  previewId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationDeleteRemoteDevelopmentArgs = {
  editorSessionId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteSshKeyArgs = {
  name: Scalars['String']['input'];
};


export type MutationDeleteUmapArgs = {
  umapId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  isDeleting?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteVolumeDataArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId: Scalars['String']['input'];
};


export type MutationDeleteWorkspaceArgs = {
  workspaceId: Scalars['String']['input'];
};


export type MutationDeployManagedChannelArgs = {
  alias?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['String']['input'];
  interface?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationDownloadAnnotationArgs = {
  annotationId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationDownloadDatasetArgs = {
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationDownloadGraphArgs = {
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationDownloadMlInferenceArgs = {
  inferenceId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationDownloadMlModelArgs = {
  checkpoint?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationDownloadManagedGanArgs = {
  modelId: Scalars['String']['input'];
};


export type MutationDownloadManagedMapArgs = {
  mapId: Scalars['String']['input'];
};


export type MutationDuplicateGraphArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  graphId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationEditAnalyticsArgs = {
  analyticsId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationEditAnnotationArgs = {
  annotationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationEditDatasetArgs = {
  datasetId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  showJob?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationEditDefaultGraphArgs = {
  channelId: Scalars['String']['input'];
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationEditGraphArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  graph?: InputMaybe<Scalars['String']['input']>;
  graphId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationEditMlInferenceArgs = {
  inferenceId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationEditMlModelArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationEditManagedChannelArgs = {
  channelId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  instance?: InputMaybe<Scalars['String']['input']>;
  interfaceVersion?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationEditManagedGanArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['String']['input']>;
  modelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationEditManagedMapArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  mapId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationEditManagedVolumeArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId: Scalars['String']['input'];
};


export type MutationEditMemberArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditOrganizationArgs = {
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationEditUmapArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  umapId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationEditVolumeDataArgs = {
  key: Scalars['String']['input'];
  source: Scalars['String']['input'];
  volumeId: Scalars['String']['input'];
};


export type MutationEditWorkspaceArgs = {
  channelIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  ganIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mapIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationEditWorkspaceThumbnailArgs = {
  thumbnail: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationInitializeUserArgs = {
  email: Scalars['String']['input'];
};


export type MutationMountVolumesArgs = {
  volumes: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationPingPreviewArgs = {
  channelId: Scalars['String']['input'];
};


export type MutationPutVolumeDataArgs = {
  keys: Array<InputMaybe<Scalars['String']['input']>>;
  volumeId: Scalars['String']['input'];
};


export type MutationPutVolumeDataThumbnailArgs = {
  key: Scalars['String']['input'];
  volumeId: Scalars['String']['input'];
};


export type MutationPutVolumeDataV2Args = {
  key: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  volumeId: Scalars['String']['input'];
};


export type MutationPutVolumeDataV2FinalizerArgs = {
  key: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
  volumeId: Scalars['String']['input'];
};


export type MutationRemoveChannelOrganizationArgs = {
  channelId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationRemoveGanOrganizationArgs = {
  modelId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationRemoveMapOrganizationArgs = {
  mapId: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};


export type MutationRemoveMemberArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveVolumeOrganizationArgs = {
  organizationId: Scalars['String']['input'];
  volumeId: Scalars['String']['input'];
};


export type MutationSaveDefaultPaymentMethodArgs = {
  organizationId: Scalars['String']['input'];
  paymentMethodId: Scalars['String']['input'];
};


export type MutationSetChannelGraphArgs = {
  channelId: Scalars['String']['input'];
  graphId?: InputMaybe<Scalars['String']['input']>;
  stagedGraphId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type MutationSetOrganizationLimitArgs = {
  limit: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  setting: Scalars['String']['input'];
};


export type MutationSetPlatformLimitArgs = {
  limit: Scalars['Int']['input'];
  setting: Scalars['String']['input'];
  tier: Scalars['String']['input'];
};


export type MutationSetWorkspaceLimitArgs = {
  limit: Scalars['Int']['input'];
  setting: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type MutationSignInArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationStartRemoteDevelopmentArgs = {
  editorSessionId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStopRemoteDevelopmentArgs = {
  editorSessionId: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateOrganizationPlanArgs = {
  organizationId: Scalars['String']['input'];
  tier: Scalars['String']['input'];
};


export type MutationUploadChannelDocumentationArgs = {
  channelId: Scalars['String']['input'];
  keys: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationUploadDatasetArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationUploadDatasetV2Args = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationUploadDatasetV2FinalizerArgs = {
  key: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type MutationUploadMlModelArgs = {
  architectureId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parameters?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Float']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workspaceId: Scalars['String']['input'];
};


export type MutationUploadMlModelFinalizerArgs = {
  key: Scalars['String']['input'];
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>>>;
  uploadId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type MutationValidateGraphArgs = {
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type NodeDocumentation = {
  __typename?: 'NodeDocumentation';
  documentation: Scalars['String']['output'];
  nodeClass: Scalars['String']['output'];
  preview?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type OldUmap = {
  __typename?: 'OldUMAP';
  datasets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  results?: Maybe<OldUmapResult>;
  samples?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  seed?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type OldUmapDatasets = {
  __typename?: 'OldUMAPDatasets';
  datasetId?: Maybe<Scalars['String']['output']>;
  datasetName?: Maybe<Scalars['String']['output']>;
  points?: Maybe<OldUmapPoints>;
};

export type OldUmapPoints = {
  __typename?: 'OldUMAPPoints';
  image?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['String']['output']>;
  y?: Maybe<Scalars['String']['output']>;
  z?: Maybe<Scalars['String']['output']>;
};

export type OldUmapResult = {
  __typename?: 'OldUMAPResult';
  datasets?: Maybe<OldUmapDatasets>;
  featureSize?: Maybe<Scalars['String']['output']>;
  featuresize?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type Organization = {
  __typename?: 'Organization';
  expirationDate?: Maybe<Scalars['String']['output']>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  plan?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field has been deprecated for release 1.0.0, please upgrade your client or use plan instead.  */
  tier?: Maybe<Scalars['String']['output']>;
};

export type OrganizationAdmin = {
  __typename?: 'OrganizationAdmin';
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
};

export type OrganizationSetting = {
  __typename?: 'OrganizationSetting';
  limit: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  setting: Scalars['String']['output'];
  units: Scalars['String']['output'];
  usage: Scalars['Float']['output'];
};

export type OrganizationUsage = {
  __typename?: 'OrganizationUsage';
  channel?: Maybe<Scalars['String']['output']>;
  instanceType?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  totalItems: Scalars['Int']['output'];
};

export type PlatformPlan = {
  __typename?: 'PlatformPlan';
  editable: Scalars['Boolean']['output'];
  limit: Scalars['String']['output'];
  organization: Scalars['Boolean']['output'];
  plan: Scalars['String']['output'];
  setting: Scalars['String']['output'];
  threshold: Scalars['Boolean']['output'];
  track: Scalars['Boolean']['output'];
  units: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
  workspace: Scalars['Boolean']['output'];
};

export type PlatformSetting = {
  __typename?: 'PlatformSetting';
  setting?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Preview = {
  __typename?: 'Preview';
  channelId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  graphId: Scalars['String']['output'];
  previewId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type PreviewLog = {
  __typename?: 'PreviewLog';
  channelId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  graphId: Scalars['String']['output'];
  log?: Maybe<Scalars['String']['output']>;
  previewId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  getAPIKeyContext: ApiKey;
  getAPIKeyData: ApiKey;
  getAPIKeys: Array<Maybe<ApiKey>>;
  getAllUserCharges?: Maybe<Array<Maybe<Charge>>>;
  getAnalytics: Array<Maybe<Analytics>>;
  getAnalyticsLog: AnalyticsLog;
  getAnalyticsSearchDetail: AnalyticsSearchDetail;
  getAnalyticsTypes: Array<Maybe<Scalars['String']['output']>>;
  getAnnotationFormats?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getAnnotationLog: AnnotationLog;
  getAnnotationMaps: Array<Maybe<AnnotationMap>>;
  getAnnotationMapsSearchDetail: AnnotationMapSearchDetail;
  getAnnotations: Array<Maybe<Annotation>>;
  getAnnotationsSearchDetail: AnnotationSearchDetail;
  getBanner: Banner;
  getBillingHistory?: Maybe<Array<Maybe<StripePaymentIntentInfo>>>;
  getChannelDeployment?: Maybe<ChannelDeployment>;
  getChannelDocumentation: Scalars['String']['output'];
  getChannelSchema: Scalars['String']['output'];
  getChannels?: Maybe<Array<Maybe<Channel>>>;
  getChannelsSearchDetail?: Maybe<ChannelSearchDetail>;
  getContentCodes?: Maybe<Array<Maybe<ContentCode>>>;
  getCurrentUser?: Maybe<User>;
  getCustomerInformation?: Maybe<CustomerInformation>;
  getCustomerPaymentMethods?: Maybe<Array<Maybe<CustomerPaymentInformation>>>;
  getDatasetDirectories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getDatasetFiles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  getDatasetImage?: Maybe<RunData>;
  getDatasetJobs?: Maybe<Array<Maybe<DatasetJob>>>;
  getDatasetJobsSearchDetail?: Maybe<DatasetJobSearchDetail>;
  getDatasetLog?: Maybe<DatasetLog>;
  getDatasetMetrics?: Maybe<DatasetMetrics>;
  getDatasetRuns?: Maybe<Array<Maybe<DatasetRun>>>;
  getDatasetThumbnails: Array<Maybe<Scalars['String']['output']>>;
  getDatasets?: Maybe<Array<Maybe<Dataset>>>;
  getDatasetsSearchDetail?: Maybe<DatasetSearchDetail>;
  getDefaultGraph: Scalars['String']['output'];
  /** @deprecated Support for getGANDataset has ended, please upgrade your client. */
  getGANDataset?: Maybe<GanDataset>;
  getGANDatasetLog: GanDatasetLog;
  getGANDatasets: Array<Maybe<GanDataset>>;
  getGANModels: Array<Maybe<GanModel>>;
  getGANModelsSearchDetail: GanModelSearchDetail;
  getGraphs?: Maybe<Array<Maybe<Graph>>>;
  getGraphsSearchDetail?: Maybe<GraphSearchDetail>;
  getImageAnnotation?: Maybe<RunData>;
  getImageInference: ImageInference;
  getImageMask?: Maybe<RunData>;
  getImageMetadata?: Maybe<RunData>;
  getInpaintFormats?: Maybe<Array<Maybe<InpaintFormat>>>;
  getInpaintLog: InpaintLog;
  getInpaints: Array<Maybe<Inpaint>>;
  getInvitations?: Maybe<Array<Maybe<Invitation>>>;
  getLLMBaseChannels: Array<Maybe<Scalars['String']['output']>>;
  getLLMChannelNodeTypes: Array<Maybe<LlmChannelNodeTypes>>;
  getLLMResponse: LlmResponse;
  getLinkedApps?: Maybe<Array<Maybe<LinkedApp>>>;
  getMLArchitectures?: Maybe<Array<Maybe<MlArchitecture>>>;
  getMLInferenceLog: MlInferenceLog;
  getMLInferenceMetrics: Scalars['String']['output'];
  getMLInferences: Array<Maybe<MlInference>>;
  getMLInferencesSearchDetail: MlInferenceSearchDetail;
  getMLModelLog: MlModelLog;
  getMLModels: Array<Maybe<MlModel>>;
  getMLModelsSearchDetail: MlModelSearchDetail;
  getManagedChannels: Array<Maybe<ManagedChannel>>;
  getManagedGANs: Array<Maybe<ManagedGan>>;
  getManagedMaps: Array<Maybe<ManagedMap>>;
  getManagedVolumes: Array<Maybe<ManagedVolume>>;
  getMembers?: Maybe<Array<Maybe<Member>>>;
  getNodeDocumentation: NodeDocumentation;
  /** @deprecated Support for getOrganizationLimits has ended, please upgrade your client. */
  getOrganizationLimits?: Maybe<Array<Maybe<OrganizationSetting>>>;
  getOrganizationSettings?: Maybe<Array<Maybe<OrganizationSetting>>>;
  /** @deprecated Support for getOrganizationUsage has ended, please upgrade your client. */
  getOrganizationUsage?: Maybe<Array<Maybe<OrganizationUsage>>>;
  getOrganizations: Array<Maybe<Organization>>;
  /** @deprecated Support for getPlatformLimits has ended, please upgrade your client. */
  getPlatformLimits?: Maybe<Array<Maybe<PlatformSetting>>>;
  getPlatformSettings: Array<Maybe<PlatformSetting>>;
  getPreview?: Maybe<Preview>;
  getPreviewLog?: Maybe<PreviewLog>;
  getSSHKeys: Array<Maybe<SshKey>>;
  getStripeProductsList?: Maybe<Array<Maybe<StripeProduct>>>;
  /** @deprecated Support for getUMAP has ended, please upgrade your client. */
  getUMAP?: Maybe<Array<Maybe<OldUmap>>>;
  getUMAPLog?: Maybe<UmapLog>;
  getUMAPPoint: UmapImages;
  getUMAPs: Array<Maybe<Umap>>;
  getUMAPsSearchDetail: UmapSearchDetail;
  getVolumeData: GetVolumeData;
  getVolumes?: Maybe<Array<Maybe<Volume>>>;
  getVolumesSearchDetail?: Maybe<VolumeSearchDetail>;
  /** @deprecated Support for getWorkspaceLimits has ended, please upgrade your client. */
  getWorkspaceLimits?: Maybe<Array<Maybe<WorkspaceSetting>>>;
  getWorkspaceSettings?: Maybe<Array<Maybe<WorkspaceSetting>>>;
  getWorkspaces?: Maybe<Array<Maybe<Workspace>>>;
  getWorkspacesSearchDetail?: Maybe<WorkspaceSearchDetail>;
  helloAnalytics: Scalars['String']['output'];
  helloAnnotations: Scalars['String']['output'];
  helloCore: Scalars['String']['output'];
  helloGAN: Scalars['String']['output'];
  helloInpaint: Scalars['String']['output'];
  helloLLM: Scalars['String']['output'];
  helloUMAP: Scalars['String']['output'];
  listRemoteDevelopment: Array<Maybe<RemoteDevelopmentApiOutput>>;
  validateContentCode?: Maybe<Scalars['Boolean']['output']>;
};


export type QueryGetApiKeyContextArgs = {
  apiKey: Scalars['String']['input'];
};


export type QueryGetApiKeyDataArgs = {
  name: Scalars['String']['input'];
};


export type QueryGetAllUserChargesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};


export type QueryGetAnalyticsArgs = {
  analyticsId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AnalyticsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetAnalyticsLogArgs = {
  analyticsId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryGetAnalyticsSearchDetailArgs = {
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AnalyticsFilter>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetAnnotationLogArgs = {
  annotationId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryGetAnnotationMapsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AnnotationMapFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mapId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAnnotationMapsSearchDetailArgs = {
  filters?: InputMaybe<AnnotationMapFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAnnotationsArgs = {
  annotationId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AnnotationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetAnnotationsSearchDetailArgs = {
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AnnotationFilter>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetBillingHistoryArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetChannelDeploymentArgs = {
  deploymentId: Scalars['String']['input'];
};


export type QueryGetChannelDocumentationArgs = {
  channelId: Scalars['String']['input'];
};


export type QueryGetChannelSchemaArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetChannelsArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ChannelFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetChannelsSearchDetailArgs = {
  filters?: InputMaybe<ChannelFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCustomerInformationArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCustomerPaymentMethodsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetDatasetDirectoriesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetDatasetFilesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetDatasetImageArgs = {
  datasetId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryGetDatasetJobsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<DatasetJobFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDatasetJobsSearchDetailArgs = {
  filters?: InputMaybe<DatasetJobFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDatasetLogArgs = {
  datasetId: Scalars['String']['input'];
  runId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetDatasetMetricsArgs = {
  datasetId: Scalars['String']['input'];
  runId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetDatasetRunsArgs = {
  datasetId: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetDatasetThumbnailsArgs = {
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryGetDatasetsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<DatasetFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetDatasetsSearchDetailArgs = {
  filters?: InputMaybe<DatasetFilter>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetDefaultGraphArgs = {
  channelId: Scalars['String']['input'];
};


export type QueryGetGanDatasetArgs = {
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryGetGanDatasetLogArgs = {
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryGetGanDatasetsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  gandatasetId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetGanModelsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<GanModelFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGanModelsSearchDetailArgs = {
  filters?: InputMaybe<GanModelFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetGraphsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<GraphFilter>;
  graphId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetGraphsSearchDetailArgs = {
  filters?: InputMaybe<GraphFilter>;
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetImageAnnotationArgs = {
  datasetId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryGetImageInferenceArgs = {
  filename: Scalars['String']['input'];
  inferenceId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryGetImageMaskArgs = {
  datasetId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryGetImageMetadataArgs = {
  datasetId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryGetInpaintLogArgs = {
  inpaintId: Scalars['String']['input'];
  volumeId: Scalars['String']['input'];
};


export type QueryGetInpaintsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  inpaintId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  volumeId: Scalars['String']['input'];
};


export type QueryGetInvitationsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLlmResponseArgs = {
  promptId: Scalars['String']['input'];
};


export type QueryGetMlInferenceLogArgs = {
  inferenceId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryGetMlInferenceMetricsArgs = {
  inferenceId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryGetMlInferencesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MlInferenceFilter>;
  inferenceId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetMlInferencesSearchDetailArgs = {
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MlInferenceFilter>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetMlModelLogArgs = {
  modelId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryGetMlModelsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MlModelFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetMlModelsSearchDetailArgs = {
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MlModelFilter>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetManagedChannelsArgs = {
  channelId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['String']['input'];
};


export type QueryGetManagedGaNsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type QueryGetManagedMapsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  mapId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['String']['input'];
};


export type QueryGetManagedVolumesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  volumeId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMembersArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetNodeDocumentationArgs = {
  channelId: Scalars['String']['input'];
  nodeClass: Scalars['String']['input'];
};


export type QueryGetOrganizationLimitsArgs = {
  organizationId: Scalars['String']['input'];
  setting?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOrganizationSettingsArgs = {
  organizationId: Scalars['String']['input'];
  setting?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOrganizationUsageArgs = {
  member?: InputMaybe<Scalars['String']['input']>;
  month: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['String']['input'];
};


export type QueryGetOrganizationsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPlatformLimitsArgs = {
  setting?: InputMaybe<Scalars['String']['input']>;
  tier?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPreviewArgs = {
  previewId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryGetPreviewLogArgs = {
  previewId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryGetStripeProductsListArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUmapArgs = {
  umapId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetUmapLogArgs = {
  umapId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryGetUmapPointArgs = {
  datasetId: Scalars['String']['input'];
  image: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type QueryGetUmaPsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UmapFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  umapId?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetUmaPsSearchDetailArgs = {
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UmapFilter>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetVolumeDataArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  dir?: InputMaybe<Scalars['String']['input']>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  recursive?: InputMaybe<Scalars['Boolean']['input']>;
  volumeId: Scalars['String']['input'];
};


export type QueryGetVolumesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<VolumeFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  volumeId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetVolumesSearchDetailArgs = {
  filters?: InputMaybe<VolumeFilter>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetWorkspaceLimitsArgs = {
  setting?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetWorkspaceSettingsArgs = {
  setting?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};


export type QueryGetWorkspacesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<WorkspaceFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetWorkspacesSearchDetailArgs = {
  filters?: InputMaybe<WorkspaceFilter>;
  organizationId: Scalars['String']['input'];
};


export type QueryListRemoteDevelopmentArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryValidateContentCodeArgs = {
  code: Scalars['String']['input'];
};

export type RemoteDevelopmentApiOutput = {
  __typename?: 'RemoteDevelopmentAPIOutput';
  channel: Scalars['String']['output'];
  channelId: Scalars['String']['output'];
  editorSessionId: Scalars['String']['output'];
  editorUrl: Scalars['String']['output'];
  instanceType?: Maybe<Scalars['String']['output']>;
  nodePortResponse?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  sshPort?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<RemoteDevelopmentStatus>;
};

export type RemoteDevelopmentStartStopApiOutput = {
  __typename?: 'RemoteDevelopmentStartStopAPIOutput';
  editorSessionId: Scalars['String']['output'];
  editorUrl: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<RemoteDevelopmentStatus>;
};

export type RemoteDevelopmentStatus = {
  __typename?: 'RemoteDevelopmentStatus';
  message?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  step?: Maybe<Scalars['Int']['output']>;
};

export enum RoleType {
  Admin = 'admin',
  Guest = 'guest',
  Member = 'member'
}

export type RunData = {
  __typename?: 'RunData';
  data?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  datasetId?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type SshKey = {
  __typename?: 'SSHKey';
  createdAt?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SearchDetail = {
  __typename?: 'SearchDetail';
  display?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SessionCredentials = {
  __typename?: 'SessionCredentials';
  accesskey: Scalars['String']['output'];
  accesskeyid: Scalars['String']['output'];
  sessiontoken: Scalars['String']['output'];
};

export type StripePaymentIntentInfo = {
  __typename?: 'StripePaymentIntentInfo';
  amount?: Maybe<Scalars['Int']['output']>;
  amount_capturable?: Maybe<Scalars['Int']['output']>;
  amount_received?: Maybe<Scalars['Int']['output']>;
  confirmation_method?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type StripeProduct = {
  __typename?: 'StripeProduct';
  active?: Maybe<Scalars['Boolean']['output']>;
  billing_scheme?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  livemode?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<StripeProductMetadata>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  priceId?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  recurring?: Maybe<StripeProductRecurring>;
  type?: Maybe<Scalars['String']['output']>;
  unit_amount?: Maybe<Scalars['Int']['output']>;
  unit_amount_decimal?: Maybe<Scalars['String']['output']>;
};

export type StripeProductMetadata = {
  __typename?: 'StripeProductMetadata';
  UMAP?: Maybe<Scalars['String']['output']>;
  analytics?: Maybe<Scalars['String']['output']>;
  annotation?: Maybe<Scalars['String']['output']>;
  channelsPerOrganization?: Maybe<Scalars['String']['output']>;
  dataVolumeGBLimit?: Maybe<Scalars['String']['output']>;
  dataVolumes?: Maybe<Scalars['String']['output']>;
  datasetGBPerOrganization?: Maybe<Scalars['String']['output']>;
  datasetsPerWorkspace?: Maybe<Scalars['String']['output']>;
  domainAdaptation?: Maybe<Scalars['String']['output']>;
  downloadBandwidth?: Maybe<Scalars['String']['output']>;
  graphsPerWorkspace?: Maybe<Scalars['String']['output']>;
  limitsOnHours?: Maybe<Scalars['String']['output']>;
  maxConcurrentComputerInstances?: Maybe<Scalars['String']['output']>;
  membersPerOrganization?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationSeat?: Maybe<Scalars['String']['output']>;
  stagedGraphsPerWorkspace?: Maybe<Scalars['String']['output']>;
  typeOfAWSInstance?: Maybe<Scalars['String']['output']>;
  workspaceGuestsWithReadAndWrite?: Maybe<Scalars['String']['output']>;
  workspacesPerOrganization?: Maybe<Scalars['String']['output']>;
};

export type StripeProductRecurring = {
  __typename?: 'StripeProductRecurring';
  interval?: Maybe<Scalars['String']['output']>;
  interval_count?: Maybe<Scalars['Int']['output']>;
  usage_type?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  graphDeleted?: Maybe<Scalars['Boolean']['output']>;
  graphUpdates?: Maybe<GraphUpdateReponse>;
};


export type SubscriptionGraphDeletedArgs = {
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};


export type SubscriptionGraphUpdatesArgs = {
  graphId: Scalars['String']['input'];
  uid?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['String']['input'];
};

export type Umap = {
  __typename?: 'UMAP';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datasets: Array<Maybe<UmapDataset>>;
  name: Scalars['String']['output'];
  results?: Maybe<Scalars['String']['output']>;
  samples: Array<Maybe<Scalars['Int']['output']>>;
  seed: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  umapId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type UmapDataset = {
  __typename?: 'UMAPDataset';
  dataset?: Maybe<Scalars['String']['output']>;
  datasetId?: Maybe<Scalars['String']['output']>;
};

export type UmapFilter = {
  datasets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  status?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type UmapImages = {
  __typename?: 'UMAPImages';
  heatmap4?: Maybe<Scalars['String']['output']>;
  heatmap8?: Maybe<Scalars['String']['output']>;
  heatmap16?: Maybe<Scalars['String']['output']>;
  heatmap32?: Maybe<Scalars['String']['output']>;
  heatmap64?: Maybe<Scalars['String']['output']>;
  image: Scalars['String']['output'];
};

export type UmapLog = {
  __typename?: 'UMAPLog';
  log?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  umapId: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type UmapPoints = {
  __typename?: 'UMAPPoints';
  image?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
  z?: Maybe<Scalars['Float']['output']>;
};

export type UmapSearchDetail = {
  __typename?: 'UMAPSearchDetail';
  status?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type UploadDatasetResponse = {
  __typename?: 'UploadDatasetResponse';
  datasetId: Scalars['String']['output'];
  key: Scalars['String']['output'];
  partSize?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
  urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UploadFields = {
  __typename?: 'UploadFields';
  algorithm?: Maybe<Scalars['String']['output']>;
  bucket?: Maybe<Scalars['String']['output']>;
  credential?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type UploadGanResponse = {
  __typename?: 'UploadGANResponse';
  key: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  partSize?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
  urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UploadMlModelResponse = {
  __typename?: 'UploadMLModelResponse';
  key: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  partSize?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
  urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UploadVolumeDataResponse = {
  __typename?: 'UploadVolumeDataResponse';
  key: Scalars['String']['output'];
  partSize?: Maybe<Scalars['Float']['output']>;
  uploadId?: Maybe<Scalars['String']['output']>;
  urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  volumeId: Scalars['String']['output'];
};

export type UploadVolumeDataThumbnailResponse = {
  __typename?: 'UploadVolumeDataThumbnailResponse';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type UserCredentials = {
  __typename?: 'UserCredentials';
  expires: Scalars['Int']['output'];
  idtoken: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type Volume = {
  __typename?: 'Volume';
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  permission: Scalars['String']['output'];
  size?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt: Scalars['String']['output'];
  volumeId: Scalars['String']['output'];
};

export type VolumeCredentials = {
  __typename?: 'VolumeCredentials';
  credentials: SessionCredentials;
  keys: Array<Maybe<Scalars['String']['output']>>;
  rw: Array<Maybe<Scalars['String']['output']>>;
};

export type VolumeData = {
  __typename?: 'VolumeData';
  fields?: Maybe<VolumeUploadFields>;
  hash?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type VolumeFilter = {
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type VolumeOrganization = {
  __typename?: 'VolumeOrganization';
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  permission?: Maybe<Scalars['String']['output']>;
};

export type VolumeSearchDetail = {
  __typename?: 'VolumeSearchDetail';
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type VolumeUploadFields = {
  __typename?: 'VolumeUploadFields';
  algorithm?: Maybe<Scalars['String']['output']>;
  bucket?: Maybe<Scalars['String']['output']>;
  credential?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<Scalars['String']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type Workspace = {
  __typename?: 'Workspace';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organization?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['String']['output'];
  previewThumbnail?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  workspaceId: Scalars['String']['output'];
};

export type WorkspaceFilter = {
  channels?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
  dates?: InputMaybe<Array<InputMaybe<DateComparator>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  texts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<ExactComparator>>>;
};

export type WorkspaceSearchDetail = {
  __typename?: 'WorkspaceSearchDetail';
  channels?: Maybe<Array<Maybe<SearchDetail>>>;
  tags?: Maybe<Array<Maybe<SearchDetail>>>;
  users?: Maybe<Array<Maybe<SearchDetail>>>;
};

export type WorkspaceSetting = {
  __typename?: 'WorkspaceSetting';
  limit: Scalars['String']['output'];
  setting: Scalars['String']['output'];
  units: Scalars['String']['output'];
  usage: Scalars['Float']['output'];
  workspaceId: Scalars['String']['output'];
};

export type GetVolumeData = {
  __typename?: 'getVolumeData';
  keys: Array<Maybe<VolumeData>>;
  pageInfo: PageInfo;
};

export type UploadDatasetV2MutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UploadDatasetV2Mutation = { __typename?: 'Mutation', uploadDatasetV2: { __typename?: 'UploadDatasetResponse', datasetId: string, key: string, partSize?: number | null, uploadId?: string | null, urls?: Array<string | null> | null } };

export type UploadDatasetV2FinalizerMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  uploadId?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>> | InputMaybe<MultipartInput>>;
}>;


export type UploadDatasetV2FinalizerMutation = { __typename?: 'Mutation', uploadDatasetV2Finalizer?: boolean | null };

export type CreateManagedGanv2MutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateManagedGanv2Mutation = { __typename?: 'Mutation', createManagedGANV2: { __typename?: 'UploadGANResponse', key: string, modelId: string, uploadId?: string | null, partSize?: number | null, urls?: Array<string | null> | null } };

export type CreateManagedGanv2FinalizerMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  uploadId?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>> | InputMaybe<MultipartInput>>;
}>;


export type CreateManagedGanv2FinalizerMutation = { __typename?: 'Mutation', createManagedGANV2Finalizer?: boolean | null };

export type PutVolumeDataV2MutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  size: Scalars['Float']['input'];
}>;


export type PutVolumeDataV2Mutation = { __typename?: 'Mutation', putVolumeDataV2: { __typename?: 'UploadVolumeDataResponse', key: string, volumeId: string, uploadId?: string | null, partSize?: number | null, urls?: Array<string | null> | null } };

export type PutVolumeDataV2FinalizerMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  uploadId?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>> | InputMaybe<MultipartInput>>;
}>;


export type PutVolumeDataV2FinalizerMutation = { __typename?: 'Mutation', putVolumeDataV2Finalizer?: boolean | null };

export type CreateAnalyticsMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  type: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateAnalyticsMutation = { __typename?: 'Mutation', createAnalytics: string };

export type DeleteAnalyticsMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  analyticsId: Scalars['String']['input'];
}>;


export type DeleteAnalyticsMutation = { __typename?: 'Mutation', deleteAnalytics: boolean };

export type GetAnalyticsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  analyticsId: Scalars['String']['input'];
}>;


export type GetAnalyticsQuery = { __typename?: 'Query', getAnalytics: Array<{ __typename?: 'Analytics', result?: string | null } | null> };

export type GetAnalyticsTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnalyticsTypesQuery = { __typename?: 'Query', getAnalyticsTypes: Array<string | null> };

export type GetAnalyticsLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  analyticsId: Scalars['String']['input'];
}>;


export type GetAnalyticsLogQuery = { __typename?: 'Query', getAnalyticsLog: { __typename?: 'AnalyticsLog', log?: string | null } };

export type CreateAnnotationMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  format: Scalars['String']['input'];
  mapId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateAnnotationMutation = { __typename?: 'Mutation', createAnnotation: string };

export type DownloadAnnotationMutationVariables = Exact<{
  annotationId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}>;


export type DownloadAnnotationMutation = { __typename?: 'Mutation', downloadAnnotation: string };

export type DeleteAnnotationMutationVariables = Exact<{
  annotationId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}>;


export type DeleteAnnotationMutation = { __typename?: 'Mutation', deleteAnnotation: boolean };

export type GetAnnotationFormatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnnotationFormatsQuery = { __typename?: 'Query', getAnnotationFormats?: Array<string | null> | null };

export type GetAnnotationMapsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  mapId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<AnnotationMapFilter>;
}>;


export type GetAnnotationMapsQuery = { __typename?: 'Query', getAnnotationMaps: Array<{ __typename?: 'AnnotationMap', description?: string | null, mapId: string, name: string, organization: string, createdAt?: string | null, organizationId: string, updatedAt?: string | null, tags?: Array<string | null> | null } | null> };

export type GetAnnotationLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  annotationId: Scalars['String']['input'];
}>;


export type GetAnnotationLogQuery = { __typename?: 'Query', getAnnotationLog: { __typename?: 'AnnotationLog', log?: string | null } };

export type CreateManagedMapMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateManagedMapMutation = { __typename?: 'Mutation', createManagedMap: { __typename?: 'MapData', mapId: string, url?: string | null, fields?: { __typename?: 'UploadFields', algorithm?: string | null, bucket?: string | null, credential?: string | null, date?: string | null, key?: string | null, policy?: string | null, signature?: string | null, token?: string | null } | null } };

export type DeleteManagedMapMutationVariables = Exact<{
  mapId: Scalars['String']['input'];
}>;


export type DeleteManagedMapMutation = { __typename?: 'Mutation', deleteManagedMap: boolean };

export type EditManagedMapMutationVariables = Exact<{
  mapId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditManagedMapMutation = { __typename?: 'Mutation', editManagedMap: boolean };

export type GetChannelsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<ChannelFilter>;
}>;


export type GetChannelsQuery = { __typename?: 'Query', getChannels?: Array<{ __typename?: 'Channel', channelId: string, createdAt: string, description: string, documentation?: boolean | null, organization: string, name: string, organizationId: string, state?: string | null, tags?: Array<string | null> | null, updatedAt: string, version?: string | null } | null> | null };

export type CreateFeedbackMutationVariables = Exact<{
  summary: Scalars['String']['input'];
  description: Scalars['String']['input'];
  files: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type CreateFeedbackMutation = { __typename?: 'Mutation', createFeedback: { __typename?: 'Feedback', feedbackId: string, uploads?: Array<{ __typename?: 'FeedbackUpload', key?: string | null, url?: string | null, fields?: { __typename?: 'FeedbackUploadFields', key?: string | null, bucket?: string | null, algorithm?: string | null, credential?: string | null, date?: string | null, token?: string | null, policy?: string | null, signature?: string | null } | null } | null> | null } };

export type GetChannelDocumentationQueryVariables = Exact<{
  channelId: Scalars['String']['input'];
}>;


export type GetChannelDocumentationQuery = { __typename?: 'Query', getChannelDocumentation: string };

export type GetChannelNodeDocumentationQueryVariables = Exact<{
  channelId: Scalars['String']['input'];
  nodeClass: Scalars['String']['input'];
}>;


export type GetChannelNodeDocumentationQuery = { __typename?: 'Query', getNodeDocumentation: { __typename?: 'NodeDocumentation', documentation: string, preview?: string | null, thumbnail?: string | null } };

export type GetManagedChannelsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  channelId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetManagedChannelsQuery = { __typename?: 'Query', getManagedChannels: Array<{ __typename?: 'ManagedChannel', channelId: string, createdAt?: string | null, createdBy?: string | null, description?: string | null, instanceType: string, interfaceVersion?: number | null, name: string, organizationId: string, timeout?: number | null, updatedAt?: string | null, updatedBy?: string | null, volumes: Array<string | null>, organizations?: Array<{ __typename?: 'ChannelOrganization', name: string, organizationId: string } | null> | null } | null> };

export type CreateManagedChannelMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  instance?: InputMaybe<Scalars['String']['input']>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  interfaceVersion?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateManagedChannelMutation = { __typename?: 'Mutation', createManagedChannel: string };

export type DeleteManagedChannelMutationVariables = Exact<{
  channelId: Scalars['String']['input'];
}>;


export type DeleteManagedChannelMutation = { __typename?: 'Mutation', deleteManagedChannel?: boolean | null };

export type RemoveChannelOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
}>;


export type RemoveChannelOrganizationMutation = { __typename?: 'Mutation', removeChannelOrganization?: boolean | null };

export type EditManagedChannelMutationVariables = Exact<{
  channelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  volumes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  instance?: InputMaybe<Scalars['String']['input']>;
  timeout?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  interfaceVersion?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditManagedChannelMutation = { __typename?: 'Mutation', editManagedChannel?: boolean | null };

export type UploadDatasetMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UploadDatasetMutation = { __typename?: 'Mutation', uploadDataset?: { __typename?: 'DatasetUpload', key?: string | null, url?: string | null, fields?: { __typename?: 'DatasetUploadFields', key?: string | null, bucket?: string | null, algorithm?: string | null, credential?: string | null, date?: string | null, token?: string | null, policy?: string | null, signature?: string | null } | null } | null };

export type DownloadDatasetMutationVariables = Exact<{
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}>;


export type DownloadDatasetMutation = { __typename?: 'Mutation', downloadDataset?: string | null };

export type DeleteDatasetMutationVariables = Exact<{
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}>;


export type DeleteDatasetMutation = { __typename?: 'Mutation', deleteDataset?: boolean | null };

export type GetDatasetRunsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetRunsQuery = { __typename?: 'Query', getDatasetRuns?: Array<{ __typename?: 'DatasetRun', runId?: string | null, workspaceId?: string | null, datasetId?: string | null, channelId?: string | null, startTime?: string | null, endTime?: string | null, state?: string | null, run?: number | null } | null> | null, getDatasetJobs?: Array<{ __typename?: 'DatasetJob', datasetId?: string | null, name?: string | null } | null> | null };

export type GetDatasetLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  runId: Scalars['String']['input'];
}>;


export type GetDatasetLogQuery = { __typename?: 'Query', getDatasetLog?: { __typename?: 'DatasetLog', runId?: string | null, workspaceId?: string | null, datasetId?: string | null, channelId?: string | null, email?: string | null, startTime?: string | null, endTime?: string | null, state?: string | null, run?: number | null, log?: string | null } | null };

export type GetDatasetImageQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
}>;


export type GetDatasetImageQuery = { __typename?: 'Query', getDatasetImage?: { __typename?: 'RunData', data?: Array<string | null> | null } | null };

export type GetDatasetQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetQuery = { __typename?: 'Query', getDatasets?: Array<{ __typename?: 'Dataset', datasetId?: string | null, files?: number | null, name: string, runs?: number | null } | null> | null };

export type GetGanModelsQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<GanModelFilter>;
}>;


export type GetGanModelsQuery = { __typename?: 'Query', getGANModels: Array<{ __typename?: 'GANModel', organizationId: string, modelId: string, description?: string | null, flags?: string | null, name: string, organization: string, createdAt?: string | null, updatedAt?: string | null, tags?: Array<string | null> | null } | null> };

export type CreateGanDatasetMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateGanDatasetMutation = { __typename?: 'Mutation', createGANDataset: string };

export type DeleteGanDatasetMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
}>;


export type DeleteGanDatasetMutation = { __typename?: 'Mutation', deleteGANDataset?: boolean | null };

export type GetGanDatasetLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
}>;


export type GetGanDatasetLogQuery = { __typename?: 'Query', getGANDatasetLog: { __typename?: 'GANDatasetLog', log?: string | null } };

export type EditManagedGanMutationVariables = Exact<{
  modelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditManagedGanMutation = { __typename?: 'Mutation', editManagedGAN?: boolean | null };

export type DeleteManagedGanMutationVariables = Exact<{
  modelId: Scalars['String']['input'];
}>;


export type DeleteManagedGanMutation = { __typename?: 'Mutation', deleteManagedGAN?: boolean | null };

export type RemoveGanOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
}>;


export type RemoveGanOrganizationMutation = { __typename?: 'Mutation', removeGANOrganization?: boolean | null };

export type GetInpaintFormatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInpaintFormatsQuery = { __typename?: 'Query', getInpaintFormats?: Array<{ __typename?: 'InpaintFormat', name: string, value: string, info?: string | null } | null> | null };

export type GetInpaintsQueryVariables = Exact<{
  volumeId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetInpaintsQuery = { __typename?: 'Query', getInpaints: Array<{ __typename?: 'Inpaint', volumeId: string, inpaintId: string, status: string, location: string, destination?: string | null, inputType?: InpaintInputType | null, outputType?: InpaintOutputType | null, dilation?: number | null, createdBy?: string | null, createdAt?: string | null, updatedBy?: string | null, updatedAt?: string | null } | null> };

export type GetInpaintLogQueryVariables = Exact<{
  volumeId: Scalars['String']['input'];
  inpaintId: Scalars['String']['input'];
}>;


export type GetInpaintLogQuery = { __typename?: 'Query', getInpaintLog: { __typename?: 'InpaintLog', log?: string | null } };

export type CreateInpaintMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  location: Scalars['String']['input'];
  destination?: InputMaybe<Scalars['String']['input']>;
  inputType?: InputMaybe<InpaintInputType>;
  outputType?: InputMaybe<InpaintOutputType>;
  dilation?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateInpaintMutation = { __typename?: 'Mutation', createInpaint: string };

export type DeleteInpaintMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  inpaintId: Scalars['String']['input'];
}>;


export type DeleteInpaintMutation = { __typename?: 'Mutation', deleteInpaint: boolean };

export type GetInvitationsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetInvitationsQuery = { __typename?: 'Query', getInvitations?: Array<{ __typename?: 'Invitation', email?: string | null, organizationId?: string | null, role?: RoleType | null, updatedAt?: string | null } | null> | null };

export type GetMembersQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMembersQuery = { __typename?: 'Query', getMembers?: Array<{ __typename?: 'Member', userId: string, email: string, name: string, role: RoleType } | null> | null };

export type EditMemberMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditMemberMutation = { __typename?: 'Mutation', editMember?: boolean | null };

export type AddMemberMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  role: Scalars['String']['input'];
}>;


export type AddMemberMutation = { __typename?: 'Mutation', addMember?: boolean | null };

export type RemoveMemberMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type RemoveMemberMutation = { __typename?: 'Mutation', removeMember?: boolean | null };

export type EditMemberByRoleMutationVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  role: Scalars['String']['input'];
}>;


export type EditMemberByRoleMutation = { __typename?: 'Mutation', editMember?: boolean | null };

export type GetMlInferenceLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  inferenceId: Scalars['String']['input'];
}>;


export type GetMlInferenceLogQuery = { __typename?: 'Query', getMLInferenceLog: { __typename?: 'MLInferenceLog', workspaceId: string, inferenceId: string, status: string, log?: string | null } };

export type GetMlInferenceMetricsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  inferenceId: Scalars['String']['input'];
}>;


export type GetMlInferenceMetricsQuery = { __typename?: 'Query', getMLInferenceMetrics: string };

export type CreateMlInferenceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  mapId?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateMlInferenceMutation = { __typename?: 'Mutation', createMLInference: string };

export type DeleteMlInferenceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  inferenceId: Scalars['String']['input'];
}>;


export type DeleteMlInferenceMutation = { __typename?: 'Mutation', deleteMLInference: boolean };

export type DownloadMlInferenceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  inferenceId: Scalars['String']['input'];
}>;


export type DownloadMlInferenceMutation = { __typename?: 'Mutation', downloadMLInference: string };

export type GetMlArchitecturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMlArchitecturesQuery = { __typename?: 'Query', getMLArchitectures?: Array<{ __typename?: 'MLArchitecture', architectureId?: string | null, name?: string | null, description?: string | null, annotations?: string | null, hyperparameters?: Array<{ __typename?: 'Hyperparameter', name: string, field: string, type: string, description?: string | null, default?: string | null, min?: number | null, max?: number | null, step?: number | null, options?: Array<string | null> | null } | null> | null } | null> | null };

export type GetMlModelQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
}>;


export type GetMlModelQuery = { __typename?: 'Query', getMLModels: Array<{ __typename?: 'MLModel', architecture: string, architectureId: string, checkpoints?: Array<string | null> | null, dataset: string, datasetId: string, description?: string | null, metrics?: string | null, modelId: string, name: string, parameters?: string | null, status?: string | null, tags?: Array<string | null> | null } | null> };

export type GetMlModelLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
}>;


export type GetMlModelLogQuery = { __typename?: 'Query', getMLModelLog: { __typename?: 'MLModelLog', log?: string | null } };

export type CreateMlModelMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  architectureId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateMlModelMutation = { __typename?: 'Mutation', createMLModel: string };

export type DeleteMlModelMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
}>;


export type DeleteMlModelMutation = { __typename?: 'Mutation', deleteMLModel: boolean };

export type DownloadMlModelMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  checkpoint?: InputMaybe<Scalars['String']['input']>;
}>;


export type DownloadMlModelMutation = { __typename?: 'Mutation', downloadMLModel: string };

export type EditMlModelMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditMlModelMutation = { __typename?: 'Mutation', editMLModel: boolean };

export type UploadMlModelMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  architectureId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  size: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UploadMlModelMutation = { __typename?: 'Mutation', uploadMLModel: { __typename?: 'UploadMLModelResponse', key: string, modelId: string, uploadId?: string | null, partSize?: number | null, urls?: Array<string | null> | null } };

export type UploadMlModelFinalizerMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  key: Scalars['String']['input'];
  uploadId?: InputMaybe<Scalars['String']['input']>;
  parts?: InputMaybe<Array<InputMaybe<MultipartInput>> | InputMaybe<MultipartInput>>;
}>;


export type UploadMlModelFinalizerMutation = { __typename?: 'Mutation', uploadMLModelFinalizer?: boolean | null };

export type EditOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type EditOrganizationMutation = { __typename?: 'Mutation', editOrganization?: boolean | null };

export type DeleteOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteOrganization?: boolean | null };

export type GetOrganizationsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganizationsQuery = { __typename?: 'Query', getOrganizations: Array<{ __typename?: 'Organization', name: string, role?: string | null, organizationId: string, expirationDate?: string | null, expired?: boolean | null, plan?: string | null } | null> };

export type GetOrganizationSettingsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  setting?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganizationSettingsQuery = { __typename?: 'Query', getOrganizationSettings?: Array<{ __typename?: 'OrganizationSetting', organizationId: string, setting: string, limit: string, usage: number, units: string } | null> | null };

export type GetDatasetThumbnailsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
}>;


export type GetDatasetThumbnailsQuery = { __typename?: 'Query', getDatasetThumbnails: Array<string | null> };

export type PingPreviewMutationVariables = Exact<{
  channelId: Scalars['String']['input'];
}>;


export type PingPreviewMutation = { __typename?: 'Mutation', pingPreview?: boolean | null };

export type CreateLinkedAppMutationVariables = Exact<{
  appId: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type CreateLinkedAppMutation = { __typename?: 'Mutation', createLinkedApp?: boolean | null };

export type DeleteLinkedAppMutationVariables = Exact<{
  appId: Scalars['String']['input'];
}>;


export type DeleteLinkedAppMutation = { __typename?: 'Mutation', deleteLinkedApp?: boolean | null };

export type GetLinkedAppsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLinkedAppsQuery = { __typename?: 'Query', getLinkedApps?: Array<{ __typename?: 'LinkedApp', appId: string, name: string, linked: boolean, thumbnail?: string | null, description?: string | null, clientId?: string | null, clientSecret?: string | null } | null> | null };

export type ValidateContentCodeQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type ValidateContentCodeQuery = { __typename?: 'Query', validateContentCode?: boolean | null };

export type CreateUmapMutationVariables = Exact<{
  datasetIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  samples: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  seed?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  workspaceId: Scalars['String']['input'];
}>;


export type CreateUmapMutation = { __typename?: 'Mutation', createUMAP: string };

export type DeleteUmapMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  umapId: Scalars['String']['input'];
}>;


export type DeleteUmapMutation = { __typename?: 'Mutation', deleteUMAP: boolean };

export type EditUmapMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  umapId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditUmapMutation = { __typename?: 'Mutation', editUMAP: boolean };

export type GetUmapLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  umapId: Scalars['String']['input'];
}>;


export type GetUmapLogQuery = { __typename?: 'Query', getUMAPLog?: { __typename?: 'UMAPLog', umapId: string, workspaceId: string, state: string, log?: string | null } | null };

export type GetUmapQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  umapId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUmapQuery = { __typename?: 'Query', getUMAPs: Array<{ __typename?: 'UMAP', name: string, results?: string | null, samples: Array<number | null>, seed: string, status: string, tags?: Array<string | null> | null, umapId: string, workspaceId: string, datasets: Array<{ __typename?: 'UMAPDataset', datasetId?: string | null, dataset?: string | null } | null> } | null> };

export type RemoveMapOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  mapId: Scalars['String']['input'];
}>;


export type RemoveMapOrganizationMutation = { __typename?: 'Mutation', removeMapOrganization?: boolean | null };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', getCurrentUser?: { __typename?: 'User', userId: string, email: string, name: string } | null };

export type DeleteUserMutationVariables = Exact<{
  isDeleting?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: Array<{ __typename?: 'OrganizationAdmin', organizationId?: string | null, name?: string | null } | null> | null };

export type GetVolumesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  volumeId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<VolumeFilter>;
}>;


export type GetVolumesQuery = { __typename?: 'Query', getVolumes?: Array<{ __typename?: 'Volume', name: string, size?: string | null, volumeId: string, updatedAt: string, createdAt: string, permission: string, description: string, organization: string, organizationId: string, tags?: Array<string | null> | null } | null> | null };

export type CreateManagedVolumeMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateManagedVolumeMutation = { __typename?: 'Mutation', createManagedVolume: string };

export type DeleteManagedVolumeMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
}>;


export type DeleteManagedVolumeMutation = { __typename?: 'Mutation', deleteManagedVolume?: boolean | null };

export type GetVolumeDataQueryVariables = Exact<{
  volumeId: Scalars['String']['input'];
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  dir?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetVolumeDataQuery = { __typename?: 'Query', getVolumeData: { __typename?: 'getVolumeData', keys: Array<{ __typename?: 'VolumeData', url?: string | null, updatedAt?: string | null, thumbnailUrl?: string | null, previewUrl?: string | null, size?: number | null, key?: string | null, hash?: string | null, fields?: { __typename?: 'VolumeUploadFields', algorithm?: string | null, bucket?: string | null, credential?: string | null, date?: string | null, key?: string | null, policy?: string | null, signature?: string | null, token?: string | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', totalItems: number, offset?: number | null, limit?: number | null } } };

export type DeleteVolumeDataMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DeleteVolumeDataMutation = { __typename?: 'Mutation', deleteVolumeData: Array<string | null> };

export type PutVolumeDataMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  keys: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type PutVolumeDataMutation = { __typename?: 'Mutation', putVolumeData: Array<{ __typename?: 'VolumeData', hash?: string | null, key?: string | null, updatedAt?: string | null, url?: string | null, fields?: { __typename?: 'VolumeUploadFields', algorithm?: string | null, bucket?: string | null, credential?: string | null, date?: string | null, key?: string | null, policy?: string | null, signature?: string | null, token?: string | null } | null } | null> };

export type PutVolumeDataThumbnailMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  key: Scalars['String']['input'];
}>;


export type PutVolumeDataThumbnailMutation = { __typename?: 'Mutation', putVolumeDataThumbnail: { __typename?: 'UploadVolumeDataThumbnailResponse', key: string, url: string } };

export type EditVolumeDataMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  source: Scalars['String']['input'];
  key: Scalars['String']['input'];
}>;


export type EditVolumeDataMutation = { __typename?: 'Mutation', editVolumeData?: boolean | null };

export type RemoveVolumeOrganizationMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  volumeId: Scalars['String']['input'];
}>;


export type RemoveVolumeOrganizationMutation = { __typename?: 'Mutation', removeVolumeOrganization?: boolean | null };

export type EditManagedVolumeMutationVariables = Exact<{
  volumeId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditManagedVolumeMutation = { __typename?: 'Mutation', editManagedVolume?: boolean | null };

export type EditWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  channelIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  volumeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  ganIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  mapIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditWorkspaceMutation = { __typename?: 'Mutation', editWorkspace: string };

export type EditWorkspaceThumbnailMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  thumbnail: Scalars['String']['input'];
}>;


export type EditWorkspaceThumbnailMutation = { __typename?: 'Mutation', editWorkspaceThumbnail: string };

export type CreateWorkspaceMutationVariables = Exact<{
  organizationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  channelIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  volumeIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateWorkspaceMutation = { __typename?: 'Mutation', createWorkspace: string };

export type DeleteWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type DeleteWorkspaceMutation = { __typename?: 'Mutation', deleteWorkspace: string };

export type GetWorkspacesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<WorkspaceFilter>;
}>;


export type GetWorkspacesQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', workspaceId: string, organizationId: string, organization?: string | null, name: string, createdAt?: string | null, updatedAt?: string | null, previewThumbnail?: string | null, status?: string | null, description?: string | null, tags?: Array<string | null> | null } | null> | null };

export type GetWorkspaceSettingsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  setting?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceSettingsQuery = { __typename?: 'Query', getWorkspaceSettings?: Array<{ __typename?: 'WorkspaceSetting', workspaceId: string, setting: string, limit: string, usage: number, units: string } | null> | null };

export type GetRemoteDevelopmentSessionsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRemoteDevelopmentSessionsQuery = { __typename?: 'Query', listRemoteDevelopment: Array<{ __typename?: 'RemoteDevelopmentAPIOutput', channel: string, channelId: string, editorSessionId: string, editorUrl: string, sshPort?: number | null, status?: { __typename?: 'RemoteDevelopmentStatus', state?: string | null } | null } | null> };

export type CreateRemoteDevelopmentMutationVariables = Exact<{
  channelId: Scalars['String']['input'];
}>;


export type CreateRemoteDevelopmentMutation = { __typename?: 'Mutation', createRemoteDevelopment: { __typename?: 'RemoteDevelopmentAPIOutput', editorSessionId: string, editorUrl: string } };

export type DeleteRemoteDevelopmentMutationVariables = Exact<{
  editorSessionId: Scalars['String']['input'];
}>;


export type DeleteRemoteDevelopmentMutation = { __typename?: 'Mutation', deleteRemoteDevelopment: { __typename?: 'DeleteEditorSessionOutput', editorSessionId: string } };

export type StartRemoteDevelopmentMutationVariables = Exact<{
  editorSessionId: Scalars['String']['input'];
}>;


export type StartRemoteDevelopmentMutation = { __typename?: 'Mutation', startRemoteDevelopment: { __typename?: 'RemoteDevelopmentStartStopAPIOutput', editorSessionId: string, editorUrl: string } };

export type StopRemoteDevelopmentMutationVariables = Exact<{
  editorSessionId: Scalars['String']['input'];
}>;


export type StopRemoteDevelopmentMutation = { __typename?: 'Mutation', stopRemoteDevelopment: { __typename?: 'RemoteDevelopmentStartStopAPIOutput', editorSessionId: string, editorUrl: string } };

export type GetOrganizationJobsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganizationJobsQuery = { __typename?: 'Query', getDatasetJobs?: Array<{ __typename?: 'DatasetJob', datasetId?: string | null, workspaceId?: string | null, name?: string | null, runs?: number | null, status?: string | null, createdAt?: string | null, estimatedEndAt?: string | null } | null> | null };

export type GetWorkspaceNameQueryVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetWorkspaceNameQuery = { __typename?: 'Query', getWorkspaces?: Array<{ __typename?: 'Workspace', name: string, workspaceId: string } | null> | null };

export type GetWorkspacesSearchDetailQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  filters?: InputMaybe<WorkspaceFilter>;
}>;


export type GetWorkspacesSearchDetailQuery = { __typename?: 'Query', getWorkspacesSearchDetail?: { __typename?: 'WorkspaceSearchDetail', channels?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } | null };

export type GetChannelsSearchDetailQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ChannelFilter>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetChannelsSearchDetailQuery = { __typename?: 'Query', getChannelsSearchDetail?: { __typename?: 'ChannelSearchDetail', users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } | null };

export type GetVolumesSearchDetailQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<VolumeFilter>;
}>;


export type GetVolumesSearchDetailQuery = { __typename?: 'Query', getVolumesSearchDetail?: { __typename?: 'VolumeSearchDetail', tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } | null };

export type GetAnnotationMapsSearchDetailQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<AnnotationMapFilter>;
}>;


export type GetAnnotationMapsSearchDetailQuery = { __typename?: 'Query', getAnnotationMapsSearchDetail: { __typename?: 'AnnotationMapSearchDetail', users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } };

export type GetGanModelsSearchDetailQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<GanModelFilter>;
}>;


export type GetGanModelsSearchDetailQuery = { __typename?: 'Query', getGANModelsSearchDetail: { __typename?: 'GANModelSearchDetail', users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } };

export type GetContentCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContentCodesQuery = { __typename?: 'Query', getContentCodes?: Array<{ __typename?: 'ContentCode', code: string, name: string, description: string, thumbnail?: string | null, link?: string | null, featured: boolean, contactUs: boolean, expiresAt?: string | null } | null> | null };

export type CreateApiKeyMutationVariables = Exact<{
  name: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createAPIKey: string };

export type DeleteApiKeyMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type DeleteApiKeyMutation = { __typename?: 'Mutation', deleteAPIKey?: boolean | null };

export type GetApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApiKeysQuery = { __typename?: 'Query', getAPIKeys: Array<{ __typename?: 'APIKey', createdAt?: string | null, expiresAt?: string | null, name: string, organizationId?: string | null, scope?: string | null, workspaceId?: string | null } | null> };

export type CreateSshKeyMutationVariables = Exact<{
  name: Scalars['String']['input'];
  key: Scalars['String']['input'];
}>;


export type CreateSshKeyMutation = { __typename?: 'Mutation', createSSHKey: boolean };

export type DeleteSshKeyMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type DeleteSshKeyMutation = { __typename?: 'Mutation', deleteSSHKey: boolean };

export type GetSshKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSshKeysQuery = { __typename?: 'Query', getSSHKeys: Array<{ __typename?: 'SSHKey', name?: string | null, key?: string | null, createdAt?: string | null } | null> };

export type GetWorkspaceAnalyticsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<AnalyticsFilter>;
}>;


export type GetWorkspaceAnalyticsQuery = { __typename?: 'Query', getAnalytics: Array<{ __typename?: 'Analytics', analyticsId: string, createdAt?: string | null, createdBy?: string | null, dataset: string, datasetId: string, result?: string | null, status: string, tags?: Array<string | null> | null, type: string, workspaceId: string } | null> };

export type GetAnalyticsSearchDetailQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  filters?: InputMaybe<AnalyticsFilter>;
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAnalyticsSearchDetailQuery = { __typename?: 'Query', getAnalyticsSearchDetail: { __typename?: 'AnalyticsSearchDetail', status?: Array<{ __typename?: 'SearchDetail', display?: string | null, value?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } };

export type GetWorkspaceUmapsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<UmapFilter>;
}>;


export type GetWorkspaceUmapsQuery = { __typename?: 'Query', getUMAPs: Array<{ __typename?: 'UMAP', createdAt?: string | null, createdBy?: string | null, name: string, results?: string | null, samples: Array<number | null>, seed: string, status: string, tags?: Array<string | null> | null, umapId: string, workspaceId: string, datasets: Array<{ __typename?: 'UMAPDataset', dataset?: string | null, datasetId?: string | null } | null> } | null> };

export type GetUmapsSearchDetailQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<UmapFilter>;
}>;


export type GetUmapsSearchDetailQuery = { __typename?: 'Query', getUMAPsSearchDetail: { __typename?: 'UMAPSearchDetail', users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, status?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } };

export type GetWorkspaceMlModelsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<MlModelFilter>;
}>;


export type GetWorkspaceMlModelsQuery = { __typename?: 'Query', getMLModels: Array<{ __typename?: 'MLModel', architecture: string, architectureId: string, checkpoints?: Array<string | null> | null, classes?: Array<string | null> | null, createdBy?: string | null, createdAt?: string | null, dataset: string, datasetId: string, description?: string | null, map?: string | null, mapId?: string | null, metrics?: string | null, modelId: string, name: string, parameters?: string | null, status?: string | null, tags?: Array<string | null> | null } | null> };

export type GetMlModelsSearchDetailQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MlModelFilter>;
}>;


export type GetMlModelsSearchDetailQuery = { __typename?: 'Query', getMLModelsSearchDetail: { __typename?: 'MLModelSearchDetail', users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, status?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, architectures?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } };

export type GetWorkspaceMlInferencesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<MlInferenceFilter>;
}>;


export type GetWorkspaceMlInferencesQuery = { __typename?: 'Query', getMLInferences: Array<{ __typename?: 'MLInference', datasetId: string, dataset: string, map?: string | null, mapId?: string | null, metrics?: string | null, model: string, modelId: string, status?: string | null, inferenceId: string, workspaceId: string, createdBy?: string | null, createdAt?: string | null, tags?: Array<string | null> | null } | null> };

export type GetMlInferencesSearchDetailQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<MlInferenceFilter>;
}>;


export type GetMlInferencesSearchDetailQuery = { __typename?: 'Query', getMLInferencesSearchDetail: { __typename?: 'MLInferenceSearchDetail', users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, status?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, architectures?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } };

export type GetMlModelInferencesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  modelId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMlModelInferencesQuery = { __typename?: 'Query', getMLInferences: Array<{ __typename?: 'MLInference', datasetId: string, dataset: string, model: string, modelId: string, status?: string | null, inferenceId: string, tags?: Array<string | null> | null, workspaceId: string } | null> };

export type GetGraphsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetGraphsQuery = { __typename?: 'Query', getGraphs?: Array<{ __typename?: 'Graph', channel: string, createdAt?: string | null, createdBy?: string | null, description?: string | null, graphId: string, name: string, tags?: Array<string | null> | null, thumbnail?: string | null, updatedAt?: string | null, workspaceId: string } | null> | null };

export type GetGraphMetadataQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGraphMetadataQuery = { __typename?: 'Query', getGraphs?: Array<{ __typename?: 'Graph', channel: string, channelId: string, description?: string | null, graphId: string, name: string, previewId?: string | null, readOnly?: boolean | null, showPreview?: boolean | null, tags?: Array<string | null> | null, workspaceId: string, updatedAt?: string | null } | null> | null };

export type GetGraphDataMutationVariables = Exact<{
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}>;


export type GetGraphDataMutation = { __typename?: 'Mutation', downloadGraph?: string | null };

export type EditGraphMutationVariables = Exact<{
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditGraphMutation = { __typename?: 'Mutation', editGraph?: boolean | null };

export type DeleteGraphMutationVariables = Exact<{
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}>;


export type DeleteGraphMutation = { __typename?: 'Mutation', deleteGraph?: boolean | null };

export type DownloadGraphMutationVariables = Exact<{
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
}>;


export type DownloadGraphMutation = { __typename?: 'Mutation', downloadGraph?: string | null };

export type DuplicateGraphMutationVariables = Exact<{
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type DuplicateGraphMutation = { __typename?: 'Mutation', duplicateGraph?: string | null };

export type ValidateGraphMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId: Scalars['String']['input'];
}>;


export type ValidateGraphMutation = { __typename?: 'Mutation', validateGraph?: Array<{ __typename?: 'GraphValidationError', node?: string | null, input?: string | null, errorMessage?: string | null, type?: string | null } | null> | null };

export type SaveGraphMutationVariables = Exact<{
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
  graph?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaveGraphMutation = { __typename?: 'Mutation', editGraph?: boolean | null };

export type CreateGraphMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  channelId: Scalars['String']['input'];
  graph: Scalars['String']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateGraphMutation = { __typename?: 'Mutation', createGraph: string };

export type CreatePreviewMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId: Scalars['String']['input'];
}>;


export type CreatePreviewMutation = { __typename?: 'Mutation', createPreview: string };

export type DeletePreviewMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  previewId: Scalars['String']['input'];
}>;


export type DeletePreviewMutation = { __typename?: 'Mutation', deletePreview?: boolean | null };

export type GetPreviewQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  previewId: Scalars['String']['input'];
}>;


export type GetPreviewQuery = { __typename?: 'Query', getPreview?: { __typename?: 'Preview', status?: string | null, previewId: string, thumbnail?: string | null, updatedAt?: string | null, workspaceId: string } | null };

export type GetGraphLastUpdatedQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  graphId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetGraphLastUpdatedQuery = { __typename?: 'Query', getGraphs?: Array<{ __typename?: 'Graph', updatedAt?: string | null } | null> | null };

export type GetChannelSchemaQueryVariables = Exact<{
  channelId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetChannelSchemaQuery = { __typename?: 'Query', getChannelSchema: string };

export type GetPreviewLogQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  previewId: Scalars['String']['input'];
}>;


export type GetPreviewLogQuery = { __typename?: 'Query', getPreviewLog?: { __typename?: 'PreviewLog', log?: string | null, previewId: string, status?: string | null } | null };

export type GetGraphsWithFiltersQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  filters?: InputMaybe<GraphFilter>;
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetGraphsWithFiltersQuery = { __typename?: 'Query', getGraphs?: Array<{ __typename?: 'Graph', channel: string, createdAt?: string | null, createdBy?: string | null, description?: string | null, graphId: string, name: string, tags?: Array<string | null> | null, thumbnail?: string | null, updatedAt?: string | null, workspaceId: string } | null> | null };

export type GetGraphsSearchDetailQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<GraphFilter>;
}>;


export type GetGraphsSearchDetailQuery = { __typename?: 'Query', getGraphsSearchDetail?: { __typename?: 'GraphSearchDetail', tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, channels?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } | null };

export type EditStagedGraphMutationVariables = Exact<{
  graphId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditStagedGraphMutation = { __typename?: 'Mutation', editGraph?: boolean | null };

export type GetJobsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<DatasetJobFilter>;
}>;


export type GetJobsQuery = { __typename?: 'Query', getDatasetJobs?: Array<{ __typename?: 'DatasetJob', name?: string | null, datasetId?: string | null, status?: string | null, priority?: number | null, graphId?: string | null, channelId?: string | null, workspaceId?: string | null, averageRuntime?: string | null, instancesQueued?: number | null, instancesRunning?: number | null, instancesStarting?: number | null, runsSuccess?: number | null, runsTimeout?: number | null, seed?: number | null, runsRunning?: number | null, runsFailed?: number | null, runsCancelled?: number | null, runs?: number | null, runsStarting?: number | null, runsQueued?: number | null, updatedAt?: string | null, estimatedEndAt?: string | null, createdBy?: string | null, createdAt?: string | null, channel?: string | null } | null> | null };

export type GetStagedGraphsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  staged?: InputMaybe<Scalars['Boolean']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<GraphFilter>;
}>;


export type GetStagedGraphsQuery = { __typename?: 'Query', getGraphs?: Array<{ __typename?: 'Graph', channel: string, channelId: string, createdAt?: string | null, createdBy?: string | null, description?: string | null, graphId: string, name: string, tags?: Array<string | null> | null, thumbnail?: string | null, workspaceId: string, updatedAt?: string | null } | null> | null };

export type CreateDatasetMutationVariables = Exact<{
  graphId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  runs?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['String']['input'];
  seed?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateDatasetMutation = { __typename?: 'Mutation', createDataset?: string | null };

export type ClearWorkspaceJobsMutationVariables = Exact<{
  workspaceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ClearWorkspaceJobsMutation = { __typename?: 'Mutation', clearDatasetJobs?: boolean | null };

export type HideDatasetMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  showJob?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type HideDatasetMutation = { __typename?: 'Mutation', editDataset?: boolean | null };

export type GetDatasetJobsSearchDetailQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<DatasetJobFilter>;
}>;


export type GetDatasetJobsSearchDetailQuery = { __typename?: 'Query', getDatasetJobsSearchDetail?: { __typename?: 'DatasetJobSearchDetail', tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, channels?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, type?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } | null };

export type GetRecentJobsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetRecentJobsQuery = { __typename?: 'Query', getDatasetJobs?: Array<{ __typename?: 'DatasetJob', createdAt?: string | null, datasetId?: string | null, estimatedEndAt?: string | null, name?: string | null, status?: string | null } | null> | null };

export type GetRecentGraphsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  staged?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRecentGraphsQuery = { __typename?: 'Query', getGraphs?: Array<{ __typename?: 'Graph', channel: string, channelId: string, createdAt?: string | null, createdBy?: string | null, description?: string | null, graphId: string, name: string, tags?: Array<string | null> | null, thumbnail?: string | null, updatedAt?: string | null, workspaceId: string } | null> | null };

export type GetRecentDatasetsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
}>;


export type GetRecentDatasetsQuery = { __typename?: 'Query', getDatasets?: Array<{ __typename?: 'Dataset', createdAt?: string | null, datasetId?: string | null, name: string, runs?: number | null } | null> | null };

export type GetDatasetImageFilenamesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDatasetImageFilenamesQuery = { __typename?: 'Query', getDatasetFiles?: Array<string | null> | null };

export type GetImageInferenceQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  inferenceId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
}>;


export type GetImageInferenceQuery = { __typename?: 'Query', getImageInference: { __typename?: 'ImageInference', image?: string | null, inferences?: Array<{ __typename?: 'Inference', bbox?: Array<number | null> | null, class?: number | null, className?: string | null, confidence?: string | null } | null> | null } };

export type GetImageAnnotationQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
}>;


export type GetImageAnnotationQuery = { __typename?: 'Query', getImageAnnotation?: { __typename?: 'RunData', data?: Array<string | null> | null, datasetId?: string | null, filename?: string | null } | null };

export type EditGanDatasetMutationVariables = Exact<{
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditGanDatasetMutation = { __typename?: 'Mutation', editDataset?: boolean | null };

export type EditDatasetMutationVariables = Exact<{
  datasetId: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EditDatasetMutation = { __typename?: 'Mutation', editDataset?: boolean | null };

export type GetDatasetDetailsAnalyticsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetDetailsAnalyticsQuery = { __typename?: 'Query', getAnalytics: Array<{ __typename?: 'Analytics', analyticsId: string, datasetId: string, status: string, tags?: Array<string | null> | null, type: string, workspaceId: string } | null> };

export type GetAnnotationsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAnnotationsQuery = { __typename?: 'Query', getAnnotations: Array<{ __typename?: 'Annotation', annotationId: string, datasetId: string, format: string, map?: string | null, status?: string | null, tags?: Array<string | null> | null, updatedAt?: string | null, workspaceId: string } | null> };

export type GetDatasetDetailsGanDatasetsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetDetailsGanDatasetsQuery = { __typename?: 'Query', getGANDatasets: Array<{ __typename?: 'GANDataset', datasetId: string, description?: string | null, model: string, name?: string | null, status: string, tags?: Array<string | null> | null, updatedAt: string, workspaceId: string } | null> };

export type GetDatasetDetailsUmapsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetDetailsUmapsQuery = { __typename?: 'Query', getUMAPs: Array<{ __typename?: 'UMAP', name: string, status: string, tags?: Array<string | null> | null, umapId: string } | null> };

export type GetDatasetsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDatasetsQuery = { __typename?: 'Query', getDatasets?: Array<{ __typename?: 'Dataset', channel?: string | null, classes?: Array<string | null> | null, createdAt?: string | null, createdBy?: string | null, datasetId?: string | null, description?: string | null, files?: number | null, graphId?: string | null, name: string, runs?: number | null, seed?: string | null, size?: number | null, status?: string | null, tags?: Array<string | null> | null } | null> | null };

export type GetDatasetInferencesQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetInferencesQuery = { __typename?: 'Query', getMLInferences: Array<{ __typename?: 'MLInference', inferenceId: string, dataset: string, datasetId: string, modelId: string, model: string, status?: string | null, tags?: Array<string | null> | null, workspaceId: string } | null> };

export type GetDatasetModelsQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  datasetId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDatasetModelsQuery = { __typename?: 'Query', getMLModels: Array<{ __typename?: 'MLModel', modelId: string, name: string, status?: string | null, tags?: Array<string | null> | null, workspaceId: string } | null> };

export type GetDatasetsWithFilterQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<DatasetFilter>;
}>;


export type GetDatasetsWithFilterQuery = { __typename?: 'Query', getDatasets?: Array<{ __typename?: 'Dataset', channel?: string | null, channelId?: string | null, classes?: Array<string | null> | null, createdAt?: string | null, createdBy?: string | null, datasetId?: string | null, description?: string | null, files?: number | null, graphId?: string | null, name: string, runs?: number | null, seed?: string | null, size?: number | null, source?: string | null, status?: string | null, tags?: Array<string | null> | null, type?: string | null } | null> | null };

export type GetDatasetsSearchDetailQueryVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  filters?: InputMaybe<DatasetFilter>;
}>;


export type GetDatasetsSearchDetailQuery = { __typename?: 'Query', getDatasetsSearchDetail?: { __typename?: 'DatasetSearchDetail', channels?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, tags?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, type?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null, users?: Array<{ __typename?: 'SearchDetail', value?: string | null, display?: string | null } | null> | null } | null };

export type CreateMixedDatasetMutationVariables = Exact<{
  workspaceId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parameters: Scalars['String']['input'];
  seed?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateMixedDatasetMutation = { __typename?: 'Mutation', createMixedDataset: string };


export const UploadDatasetV2Document = gql`
    mutation UploadDatasetV2($workspaceId: String!, $name: String!, $size: Float!, $description: String) {
  uploadDatasetV2(
    workspaceId: $workspaceId
    name: $name
    size: $size
    description: $description
  ) {
    datasetId
    key
    partSize
    uploadId
    urls
  }
}
    `;
export type UploadDatasetV2MutationFn = Apollo.MutationFunction<UploadDatasetV2Mutation, UploadDatasetV2MutationVariables>;

/**
 * __useUploadDatasetV2Mutation__
 *
 * To run a mutation, you first call `useUploadDatasetV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDatasetV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDatasetV2Mutation, { data, loading, error }] = useUploadDatasetV2Mutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      name: // value for 'name'
 *      size: // value for 'size'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUploadDatasetV2Mutation(baseOptions?: Apollo.MutationHookOptions<UploadDatasetV2Mutation, UploadDatasetV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDatasetV2Mutation, UploadDatasetV2MutationVariables>(UploadDatasetV2Document, options);
      }
export type UploadDatasetV2MutationHookResult = ReturnType<typeof useUploadDatasetV2Mutation>;
export type UploadDatasetV2MutationResult = Apollo.MutationResult<UploadDatasetV2Mutation>;
export type UploadDatasetV2MutationOptions = Apollo.BaseMutationOptions<UploadDatasetV2Mutation, UploadDatasetV2MutationVariables>;
export const UploadDatasetV2FinalizerDocument = gql`
    mutation UploadDatasetV2Finalizer($workspaceId: String!, $key: String!, $uploadId: String, $parts: [MultipartInput]) {
  uploadDatasetV2Finalizer(
    workspaceId: $workspaceId
    uploadId: $uploadId
    key: $key
    parts: $parts
  )
}
    `;
export type UploadDatasetV2FinalizerMutationFn = Apollo.MutationFunction<UploadDatasetV2FinalizerMutation, UploadDatasetV2FinalizerMutationVariables>;

/**
 * __useUploadDatasetV2FinalizerMutation__
 *
 * To run a mutation, you first call `useUploadDatasetV2FinalizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDatasetV2FinalizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDatasetV2FinalizerMutation, { data, loading, error }] = useUploadDatasetV2FinalizerMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      key: // value for 'key'
 *      uploadId: // value for 'uploadId'
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useUploadDatasetV2FinalizerMutation(baseOptions?: Apollo.MutationHookOptions<UploadDatasetV2FinalizerMutation, UploadDatasetV2FinalizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDatasetV2FinalizerMutation, UploadDatasetV2FinalizerMutationVariables>(UploadDatasetV2FinalizerDocument, options);
      }
export type UploadDatasetV2FinalizerMutationHookResult = ReturnType<typeof useUploadDatasetV2FinalizerMutation>;
export type UploadDatasetV2FinalizerMutationResult = Apollo.MutationResult<UploadDatasetV2FinalizerMutation>;
export type UploadDatasetV2FinalizerMutationOptions = Apollo.BaseMutationOptions<UploadDatasetV2FinalizerMutation, UploadDatasetV2FinalizerMutationVariables>;
export const CreateManagedGanv2Document = gql`
    mutation CreateManagedGANV2($organizationId: String!, $name: String!, $size: Float!, $description: String, $flags: String, $tags: [String]) {
  createManagedGANV2(
    organizationId: $organizationId
    name: $name
    size: $size
    description: $description
    flags: $flags
    tags: $tags
  ) {
    key
    modelId
    uploadId
    partSize
    urls
  }
}
    `;
export type CreateManagedGanv2MutationFn = Apollo.MutationFunction<CreateManagedGanv2Mutation, CreateManagedGanv2MutationVariables>;

/**
 * __useCreateManagedGanv2Mutation__
 *
 * To run a mutation, you first call `useCreateManagedGanv2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManagedGanv2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManagedGanv2Mutation, { data, loading, error }] = useCreateManagedGanv2Mutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      size: // value for 'size'
 *      description: // value for 'description'
 *      flags: // value for 'flags'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateManagedGanv2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateManagedGanv2Mutation, CreateManagedGanv2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManagedGanv2Mutation, CreateManagedGanv2MutationVariables>(CreateManagedGanv2Document, options);
      }
export type CreateManagedGanv2MutationHookResult = ReturnType<typeof useCreateManagedGanv2Mutation>;
export type CreateManagedGanv2MutationResult = Apollo.MutationResult<CreateManagedGanv2Mutation>;
export type CreateManagedGanv2MutationOptions = Apollo.BaseMutationOptions<CreateManagedGanv2Mutation, CreateManagedGanv2MutationVariables>;
export const CreateManagedGanv2FinalizerDocument = gql`
    mutation CreateManagedGANV2Finalizer($organizationId: String!, $key: String!, $uploadId: String, $parts: [MultipartInput]) {
  createManagedGANV2Finalizer(
    organizationId: $organizationId
    key: $key
    uploadId: $uploadId
    parts: $parts
  )
}
    `;
export type CreateManagedGanv2FinalizerMutationFn = Apollo.MutationFunction<CreateManagedGanv2FinalizerMutation, CreateManagedGanv2FinalizerMutationVariables>;

/**
 * __useCreateManagedGanv2FinalizerMutation__
 *
 * To run a mutation, you first call `useCreateManagedGanv2FinalizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManagedGanv2FinalizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManagedGanv2FinalizerMutation, { data, loading, error }] = useCreateManagedGanv2FinalizerMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      key: // value for 'key'
 *      uploadId: // value for 'uploadId'
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useCreateManagedGanv2FinalizerMutation(baseOptions?: Apollo.MutationHookOptions<CreateManagedGanv2FinalizerMutation, CreateManagedGanv2FinalizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManagedGanv2FinalizerMutation, CreateManagedGanv2FinalizerMutationVariables>(CreateManagedGanv2FinalizerDocument, options);
      }
export type CreateManagedGanv2FinalizerMutationHookResult = ReturnType<typeof useCreateManagedGanv2FinalizerMutation>;
export type CreateManagedGanv2FinalizerMutationResult = Apollo.MutationResult<CreateManagedGanv2FinalizerMutation>;
export type CreateManagedGanv2FinalizerMutationOptions = Apollo.BaseMutationOptions<CreateManagedGanv2FinalizerMutation, CreateManagedGanv2FinalizerMutationVariables>;
export const PutVolumeDataV2Document = gql`
    mutation PutVolumeDataV2($volumeId: String!, $key: String!, $size: Float!) {
  putVolumeDataV2(volumeId: $volumeId, key: $key, size: $size) {
    key
    volumeId
    uploadId
    partSize
    urls
  }
}
    `;
export type PutVolumeDataV2MutationFn = Apollo.MutationFunction<PutVolumeDataV2Mutation, PutVolumeDataV2MutationVariables>;

/**
 * __usePutVolumeDataV2Mutation__
 *
 * To run a mutation, you first call `usePutVolumeDataV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePutVolumeDataV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [putVolumeDataV2Mutation, { data, loading, error }] = usePutVolumeDataV2Mutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      key: // value for 'key'
 *      size: // value for 'size'
 *   },
 * });
 */
export function usePutVolumeDataV2Mutation(baseOptions?: Apollo.MutationHookOptions<PutVolumeDataV2Mutation, PutVolumeDataV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PutVolumeDataV2Mutation, PutVolumeDataV2MutationVariables>(PutVolumeDataV2Document, options);
      }
export type PutVolumeDataV2MutationHookResult = ReturnType<typeof usePutVolumeDataV2Mutation>;
export type PutVolumeDataV2MutationResult = Apollo.MutationResult<PutVolumeDataV2Mutation>;
export type PutVolumeDataV2MutationOptions = Apollo.BaseMutationOptions<PutVolumeDataV2Mutation, PutVolumeDataV2MutationVariables>;
export const PutVolumeDataV2FinalizerDocument = gql`
    mutation PutVolumeDataV2Finalizer($volumeId: String!, $key: String!, $uploadId: String, $parts: [MultipartInput]) {
  putVolumeDataV2Finalizer(
    volumeId: $volumeId
    key: $key
    uploadId: $uploadId
    parts: $parts
  )
}
    `;
export type PutVolumeDataV2FinalizerMutationFn = Apollo.MutationFunction<PutVolumeDataV2FinalizerMutation, PutVolumeDataV2FinalizerMutationVariables>;

/**
 * __usePutVolumeDataV2FinalizerMutation__
 *
 * To run a mutation, you first call `usePutVolumeDataV2FinalizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePutVolumeDataV2FinalizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [putVolumeDataV2FinalizerMutation, { data, loading, error }] = usePutVolumeDataV2FinalizerMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      key: // value for 'key'
 *      uploadId: // value for 'uploadId'
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function usePutVolumeDataV2FinalizerMutation(baseOptions?: Apollo.MutationHookOptions<PutVolumeDataV2FinalizerMutation, PutVolumeDataV2FinalizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PutVolumeDataV2FinalizerMutation, PutVolumeDataV2FinalizerMutationVariables>(PutVolumeDataV2FinalizerDocument, options);
      }
export type PutVolumeDataV2FinalizerMutationHookResult = ReturnType<typeof usePutVolumeDataV2FinalizerMutation>;
export type PutVolumeDataV2FinalizerMutationResult = Apollo.MutationResult<PutVolumeDataV2FinalizerMutation>;
export type PutVolumeDataV2FinalizerMutationOptions = Apollo.BaseMutationOptions<PutVolumeDataV2FinalizerMutation, PutVolumeDataV2FinalizerMutationVariables>;
export const CreateAnalyticsDocument = gql`
    mutation createAnalytics($workspaceId: String!, $type: String!, $datasetId: String!, $tags: [String]) {
  createAnalytics(
    workspaceId: $workspaceId
    datasetId: $datasetId
    type: $type
    tags: $tags
  )
}
    `;
export type CreateAnalyticsMutationFn = Apollo.MutationFunction<CreateAnalyticsMutation, CreateAnalyticsMutationVariables>;

/**
 * __useCreateAnalyticsMutation__
 *
 * To run a mutation, you first call `useCreateAnalyticsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnalyticsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnalyticsMutation, { data, loading, error }] = useCreateAnalyticsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      type: // value for 'type'
 *      datasetId: // value for 'datasetId'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateAnalyticsMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnalyticsMutation, CreateAnalyticsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnalyticsMutation, CreateAnalyticsMutationVariables>(CreateAnalyticsDocument, options);
      }
export type CreateAnalyticsMutationHookResult = ReturnType<typeof useCreateAnalyticsMutation>;
export type CreateAnalyticsMutationResult = Apollo.MutationResult<CreateAnalyticsMutation>;
export type CreateAnalyticsMutationOptions = Apollo.BaseMutationOptions<CreateAnalyticsMutation, CreateAnalyticsMutationVariables>;
export const DeleteAnalyticsDocument = gql`
    mutation deleteAnalytics($workspaceId: String!, $analyticsId: String!) {
  deleteAnalytics(workspaceId: $workspaceId, analyticsId: $analyticsId)
}
    `;
export type DeleteAnalyticsMutationFn = Apollo.MutationFunction<DeleteAnalyticsMutation, DeleteAnalyticsMutationVariables>;

/**
 * __useDeleteAnalyticsMutation__
 *
 * To run a mutation, you first call `useDeleteAnalyticsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnalyticsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnalyticsMutation, { data, loading, error }] = useDeleteAnalyticsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      analyticsId: // value for 'analyticsId'
 *   },
 * });
 */
export function useDeleteAnalyticsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnalyticsMutation, DeleteAnalyticsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnalyticsMutation, DeleteAnalyticsMutationVariables>(DeleteAnalyticsDocument, options);
      }
export type DeleteAnalyticsMutationHookResult = ReturnType<typeof useDeleteAnalyticsMutation>;
export type DeleteAnalyticsMutationResult = Apollo.MutationResult<DeleteAnalyticsMutation>;
export type DeleteAnalyticsMutationOptions = Apollo.BaseMutationOptions<DeleteAnalyticsMutation, DeleteAnalyticsMutationVariables>;
export const GetAnalyticsDocument = gql`
    query getAnalytics($workspaceId: String!, $analyticsId: String!) {
  getAnalytics(workspaceId: $workspaceId, analyticsId: $analyticsId) {
    result
  }
}
    `;

/**
 * __useGetAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      analyticsId: // value for 'analyticsId'
 *   },
 * });
 */
export function useGetAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsQuery, GetAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsQuery, GetAnalyticsQueryVariables>(GetAnalyticsDocument, options);
      }
export function useGetAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsQuery, GetAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsQuery, GetAnalyticsQueryVariables>(GetAnalyticsDocument, options);
        }
export type GetAnalyticsQueryHookResult = ReturnType<typeof useGetAnalyticsQuery>;
export type GetAnalyticsLazyQueryHookResult = ReturnType<typeof useGetAnalyticsLazyQuery>;
export type GetAnalyticsQueryResult = Apollo.QueryResult<GetAnalyticsQuery, GetAnalyticsQueryVariables>;
export const GetAnalyticsTypesDocument = gql`
    query getAnalyticsTypes {
  getAnalyticsTypes
}
    `;

/**
 * __useGetAnalyticsTypesQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAnalyticsTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetAnalyticsTypesQuery, GetAnalyticsTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsTypesQuery, GetAnalyticsTypesQueryVariables>(GetAnalyticsTypesDocument, options);
      }
export function useGetAnalyticsTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsTypesQuery, GetAnalyticsTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsTypesQuery, GetAnalyticsTypesQueryVariables>(GetAnalyticsTypesDocument, options);
        }
export type GetAnalyticsTypesQueryHookResult = ReturnType<typeof useGetAnalyticsTypesQuery>;
export type GetAnalyticsTypesLazyQueryHookResult = ReturnType<typeof useGetAnalyticsTypesLazyQuery>;
export type GetAnalyticsTypesQueryResult = Apollo.QueryResult<GetAnalyticsTypesQuery, GetAnalyticsTypesQueryVariables>;
export const GetAnalyticsLogDocument = gql`
    query getAnalyticsLog($workspaceId: String!, $analyticsId: String!) {
  getAnalyticsLog(workspaceId: $workspaceId, analyticsId: $analyticsId) {
    log
  }
}
    `;

/**
 * __useGetAnalyticsLogQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      analyticsId: // value for 'analyticsId'
 *   },
 * });
 */
export function useGetAnalyticsLogQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsLogQuery, GetAnalyticsLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsLogQuery, GetAnalyticsLogQueryVariables>(GetAnalyticsLogDocument, options);
      }
export function useGetAnalyticsLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsLogQuery, GetAnalyticsLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsLogQuery, GetAnalyticsLogQueryVariables>(GetAnalyticsLogDocument, options);
        }
export type GetAnalyticsLogQueryHookResult = ReturnType<typeof useGetAnalyticsLogQuery>;
export type GetAnalyticsLogLazyQueryHookResult = ReturnType<typeof useGetAnalyticsLogLazyQuery>;
export type GetAnalyticsLogQueryResult = Apollo.QueryResult<GetAnalyticsLogQuery, GetAnalyticsLogQueryVariables>;
export const CreateAnnotationDocument = gql`
    mutation createAnnotation($workspaceId: String!, $datasetId: String!, $format: String!, $mapId: String, $tags: [String]) {
  createAnnotation(
    workspaceId: $workspaceId
    datasetId: $datasetId
    format: $format
    mapId: $mapId
    tags: $tags
  )
}
    `;
export type CreateAnnotationMutationFn = Apollo.MutationFunction<CreateAnnotationMutation, CreateAnnotationMutationVariables>;

/**
 * __useCreateAnnotationMutation__
 *
 * To run a mutation, you first call `useCreateAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnnotationMutation, { data, loading, error }] = useCreateAnnotationMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      format: // value for 'format'
 *      mapId: // value for 'mapId'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateAnnotationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnnotationMutation, CreateAnnotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnnotationMutation, CreateAnnotationMutationVariables>(CreateAnnotationDocument, options);
      }
export type CreateAnnotationMutationHookResult = ReturnType<typeof useCreateAnnotationMutation>;
export type CreateAnnotationMutationResult = Apollo.MutationResult<CreateAnnotationMutation>;
export type CreateAnnotationMutationOptions = Apollo.BaseMutationOptions<CreateAnnotationMutation, CreateAnnotationMutationVariables>;
export const DownloadAnnotationDocument = gql`
    mutation downloadAnnotation($annotationId: String!, $workspaceId: String!) {
  downloadAnnotation(annotationId: $annotationId, workspaceId: $workspaceId)
}
    `;
export type DownloadAnnotationMutationFn = Apollo.MutationFunction<DownloadAnnotationMutation, DownloadAnnotationMutationVariables>;

/**
 * __useDownloadAnnotationMutation__
 *
 * To run a mutation, you first call `useDownloadAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAnnotationMutation, { data, loading, error }] = useDownloadAnnotationMutation({
 *   variables: {
 *      annotationId: // value for 'annotationId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDownloadAnnotationMutation(baseOptions?: Apollo.MutationHookOptions<DownloadAnnotationMutation, DownloadAnnotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadAnnotationMutation, DownloadAnnotationMutationVariables>(DownloadAnnotationDocument, options);
      }
export type DownloadAnnotationMutationHookResult = ReturnType<typeof useDownloadAnnotationMutation>;
export type DownloadAnnotationMutationResult = Apollo.MutationResult<DownloadAnnotationMutation>;
export type DownloadAnnotationMutationOptions = Apollo.BaseMutationOptions<DownloadAnnotationMutation, DownloadAnnotationMutationVariables>;
export const DeleteAnnotationDocument = gql`
    mutation deleteAnnotation($annotationId: String!, $workspaceId: String!) {
  deleteAnnotation(annotationId: $annotationId, workspaceId: $workspaceId)
}
    `;
export type DeleteAnnotationMutationFn = Apollo.MutationFunction<DeleteAnnotationMutation, DeleteAnnotationMutationVariables>;

/**
 * __useDeleteAnnotationMutation__
 *
 * To run a mutation, you first call `useDeleteAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnnotationMutation, { data, loading, error }] = useDeleteAnnotationMutation({
 *   variables: {
 *      annotationId: // value for 'annotationId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteAnnotationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnnotationMutation, DeleteAnnotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnnotationMutation, DeleteAnnotationMutationVariables>(DeleteAnnotationDocument, options);
      }
export type DeleteAnnotationMutationHookResult = ReturnType<typeof useDeleteAnnotationMutation>;
export type DeleteAnnotationMutationResult = Apollo.MutationResult<DeleteAnnotationMutation>;
export type DeleteAnnotationMutationOptions = Apollo.BaseMutationOptions<DeleteAnnotationMutation, DeleteAnnotationMutationVariables>;
export const GetAnnotationFormatsDocument = gql`
    query getAnnotationFormats {
  getAnnotationFormats
}
    `;

/**
 * __useGetAnnotationFormatsQuery__
 *
 * To run a query within a React component, call `useGetAnnotationFormatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationFormatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationFormatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAnnotationFormatsQuery(baseOptions?: Apollo.QueryHookOptions<GetAnnotationFormatsQuery, GetAnnotationFormatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnotationFormatsQuery, GetAnnotationFormatsQueryVariables>(GetAnnotationFormatsDocument, options);
      }
export function useGetAnnotationFormatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnotationFormatsQuery, GetAnnotationFormatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnotationFormatsQuery, GetAnnotationFormatsQueryVariables>(GetAnnotationFormatsDocument, options);
        }
export type GetAnnotationFormatsQueryHookResult = ReturnType<typeof useGetAnnotationFormatsQuery>;
export type GetAnnotationFormatsLazyQueryHookResult = ReturnType<typeof useGetAnnotationFormatsLazyQuery>;
export type GetAnnotationFormatsQueryResult = Apollo.QueryResult<GetAnnotationFormatsQuery, GetAnnotationFormatsQueryVariables>;
export const GetAnnotationMapsDocument = gql`
    query getAnnotationMaps($organizationId: String, $workspaceId: String, $mapId: String, $cursor: String, $limit: Int, $filters: AnnotationMapFilter) {
  getAnnotationMaps(
    organizationId: $organizationId
    workspaceId: $workspaceId
    mapId: $mapId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    description
    mapId
    name
    organization
    createdAt
    organizationId
    updatedAt
    tags
  }
}
    `;

/**
 * __useGetAnnotationMapsQuery__
 *
 * To run a query within a React component, call `useGetAnnotationMapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationMapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationMapsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      mapId: // value for 'mapId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAnnotationMapsQuery(baseOptions?: Apollo.QueryHookOptions<GetAnnotationMapsQuery, GetAnnotationMapsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnotationMapsQuery, GetAnnotationMapsQueryVariables>(GetAnnotationMapsDocument, options);
      }
export function useGetAnnotationMapsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnotationMapsQuery, GetAnnotationMapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnotationMapsQuery, GetAnnotationMapsQueryVariables>(GetAnnotationMapsDocument, options);
        }
export type GetAnnotationMapsQueryHookResult = ReturnType<typeof useGetAnnotationMapsQuery>;
export type GetAnnotationMapsLazyQueryHookResult = ReturnType<typeof useGetAnnotationMapsLazyQuery>;
export type GetAnnotationMapsQueryResult = Apollo.QueryResult<GetAnnotationMapsQuery, GetAnnotationMapsQueryVariables>;
export const GetAnnotationLogDocument = gql`
    query getAnnotationLog($workspaceId: String!, $annotationId: String!) {
  getAnnotationLog(workspaceId: $workspaceId, annotationId: $annotationId) {
    log
  }
}
    `;

/**
 * __useGetAnnotationLogQuery__
 *
 * To run a query within a React component, call `useGetAnnotationLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      annotationId: // value for 'annotationId'
 *   },
 * });
 */
export function useGetAnnotationLogQuery(baseOptions: Apollo.QueryHookOptions<GetAnnotationLogQuery, GetAnnotationLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnotationLogQuery, GetAnnotationLogQueryVariables>(GetAnnotationLogDocument, options);
      }
export function useGetAnnotationLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnotationLogQuery, GetAnnotationLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnotationLogQuery, GetAnnotationLogQueryVariables>(GetAnnotationLogDocument, options);
        }
export type GetAnnotationLogQueryHookResult = ReturnType<typeof useGetAnnotationLogQuery>;
export type GetAnnotationLogLazyQueryHookResult = ReturnType<typeof useGetAnnotationLogLazyQuery>;
export type GetAnnotationLogQueryResult = Apollo.QueryResult<GetAnnotationLogQuery, GetAnnotationLogQueryVariables>;
export const CreateManagedMapDocument = gql`
    mutation createManagedMap($organizationId: String!, $name: String!, $description: String, $tags: [String]) {
  createManagedMap(
    organizationId: $organizationId
    name: $name
    description: $description
    tags: $tags
  ) {
    mapId
    url
    fields {
      algorithm
      bucket
      credential
      date
      key
      policy
      signature
      token
    }
  }
}
    `;
export type CreateManagedMapMutationFn = Apollo.MutationFunction<CreateManagedMapMutation, CreateManagedMapMutationVariables>;

/**
 * __useCreateManagedMapMutation__
 *
 * To run a mutation, you first call `useCreateManagedMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManagedMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManagedMapMutation, { data, loading, error }] = useCreateManagedMapMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateManagedMapMutation(baseOptions?: Apollo.MutationHookOptions<CreateManagedMapMutation, CreateManagedMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManagedMapMutation, CreateManagedMapMutationVariables>(CreateManagedMapDocument, options);
      }
export type CreateManagedMapMutationHookResult = ReturnType<typeof useCreateManagedMapMutation>;
export type CreateManagedMapMutationResult = Apollo.MutationResult<CreateManagedMapMutation>;
export type CreateManagedMapMutationOptions = Apollo.BaseMutationOptions<CreateManagedMapMutation, CreateManagedMapMutationVariables>;
export const DeleteManagedMapDocument = gql`
    mutation deleteManagedMap($mapId: String!) {
  deleteManagedMap(mapId: $mapId)
}
    `;
export type DeleteManagedMapMutationFn = Apollo.MutationFunction<DeleteManagedMapMutation, DeleteManagedMapMutationVariables>;

/**
 * __useDeleteManagedMapMutation__
 *
 * To run a mutation, you first call `useDeleteManagedMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManagedMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManagedMapMutation, { data, loading, error }] = useDeleteManagedMapMutation({
 *   variables: {
 *      mapId: // value for 'mapId'
 *   },
 * });
 */
export function useDeleteManagedMapMutation(baseOptions?: Apollo.MutationHookOptions<DeleteManagedMapMutation, DeleteManagedMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteManagedMapMutation, DeleteManagedMapMutationVariables>(DeleteManagedMapDocument, options);
      }
export type DeleteManagedMapMutationHookResult = ReturnType<typeof useDeleteManagedMapMutation>;
export type DeleteManagedMapMutationResult = Apollo.MutationResult<DeleteManagedMapMutation>;
export type DeleteManagedMapMutationOptions = Apollo.BaseMutationOptions<DeleteManagedMapMutation, DeleteManagedMapMutationVariables>;
export const EditManagedMapDocument = gql`
    mutation editManagedMap($mapId: String!, $name: String!, $description: String, $tags: [String]) {
  editManagedMap(
    mapId: $mapId
    name: $name
    description: $description
    tags: $tags
  )
}
    `;
export type EditManagedMapMutationFn = Apollo.MutationFunction<EditManagedMapMutation, EditManagedMapMutationVariables>;

/**
 * __useEditManagedMapMutation__
 *
 * To run a mutation, you first call `useEditManagedMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditManagedMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editManagedMapMutation, { data, loading, error }] = useEditManagedMapMutation({
 *   variables: {
 *      mapId: // value for 'mapId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditManagedMapMutation(baseOptions?: Apollo.MutationHookOptions<EditManagedMapMutation, EditManagedMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditManagedMapMutation, EditManagedMapMutationVariables>(EditManagedMapDocument, options);
      }
export type EditManagedMapMutationHookResult = ReturnType<typeof useEditManagedMapMutation>;
export type EditManagedMapMutationResult = Apollo.MutationResult<EditManagedMapMutation>;
export type EditManagedMapMutationOptions = Apollo.BaseMutationOptions<EditManagedMapMutation, EditManagedMapMutationVariables>;
export const GetChannelsDocument = gql`
    query getChannels($organizationId: String, $channelId: String, $workspaceId: String, $cursor: String, $limit: Int, $filters: ChannelFilter) {
  getChannels(
    organizationId: $organizationId
    channelId: $channelId
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    channelId
    createdAt
    description
    documentation
    organization
    name
    organizationId
    state
    tags
    updatedAt
    version
  }
}
    `;

/**
 * __useGetChannelsQuery__
 *
 * To run a query within a React component, call `useGetChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      channelId: // value for 'channelId'
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetChannelsQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelsQuery, GetChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelsQuery, GetChannelsQueryVariables>(GetChannelsDocument, options);
      }
export function useGetChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelsQuery, GetChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelsQuery, GetChannelsQueryVariables>(GetChannelsDocument, options);
        }
export type GetChannelsQueryHookResult = ReturnType<typeof useGetChannelsQuery>;
export type GetChannelsLazyQueryHookResult = ReturnType<typeof useGetChannelsLazyQuery>;
export type GetChannelsQueryResult = Apollo.QueryResult<GetChannelsQuery, GetChannelsQueryVariables>;
export const CreateFeedbackDocument = gql`
    mutation createFeedback($summary: String!, $description: String!, $files: [String]!) {
  createFeedback(summary: $summary, description: $description, files: $files) {
    feedbackId
    uploads {
      key
      url
      fields {
        key
        bucket
        algorithm
        credential
        date
        token
        policy
        signature
      }
    }
  }
}
    `;
export type CreateFeedbackMutationFn = Apollo.MutationFunction<CreateFeedbackMutation, CreateFeedbackMutationVariables>;

/**
 * __useCreateFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackMutation, { data, loading, error }] = useCreateFeedbackMutation({
 *   variables: {
 *      summary: // value for 'summary'
 *      description: // value for 'description'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useCreateFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeedbackMutation, CreateFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeedbackMutation, CreateFeedbackMutationVariables>(CreateFeedbackDocument, options);
      }
export type CreateFeedbackMutationHookResult = ReturnType<typeof useCreateFeedbackMutation>;
export type CreateFeedbackMutationResult = Apollo.MutationResult<CreateFeedbackMutation>;
export type CreateFeedbackMutationOptions = Apollo.BaseMutationOptions<CreateFeedbackMutation, CreateFeedbackMutationVariables>;
export const GetChannelDocumentationDocument = gql`
    query getChannelDocumentation($channelId: String!) {
  getChannelDocumentation(channelId: $channelId)
}
    `;

/**
 * __useGetChannelDocumentationQuery__
 *
 * To run a query within a React component, call `useGetChannelDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelDocumentationQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetChannelDocumentationQuery(baseOptions: Apollo.QueryHookOptions<GetChannelDocumentationQuery, GetChannelDocumentationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelDocumentationQuery, GetChannelDocumentationQueryVariables>(GetChannelDocumentationDocument, options);
      }
export function useGetChannelDocumentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelDocumentationQuery, GetChannelDocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelDocumentationQuery, GetChannelDocumentationQueryVariables>(GetChannelDocumentationDocument, options);
        }
export type GetChannelDocumentationQueryHookResult = ReturnType<typeof useGetChannelDocumentationQuery>;
export type GetChannelDocumentationLazyQueryHookResult = ReturnType<typeof useGetChannelDocumentationLazyQuery>;
export type GetChannelDocumentationQueryResult = Apollo.QueryResult<GetChannelDocumentationQuery, GetChannelDocumentationQueryVariables>;
export const GetChannelNodeDocumentationDocument = gql`
    query getChannelNodeDocumentation($channelId: String!, $nodeClass: String!) {
  getNodeDocumentation(channelId: $channelId, nodeClass: $nodeClass) {
    documentation
    preview
    thumbnail
  }
}
    `;

/**
 * __useGetChannelNodeDocumentationQuery__
 *
 * To run a query within a React component, call `useGetChannelNodeDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelNodeDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelNodeDocumentationQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      nodeClass: // value for 'nodeClass'
 *   },
 * });
 */
export function useGetChannelNodeDocumentationQuery(baseOptions: Apollo.QueryHookOptions<GetChannelNodeDocumentationQuery, GetChannelNodeDocumentationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelNodeDocumentationQuery, GetChannelNodeDocumentationQueryVariables>(GetChannelNodeDocumentationDocument, options);
      }
export function useGetChannelNodeDocumentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelNodeDocumentationQuery, GetChannelNodeDocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelNodeDocumentationQuery, GetChannelNodeDocumentationQueryVariables>(GetChannelNodeDocumentationDocument, options);
        }
export type GetChannelNodeDocumentationQueryHookResult = ReturnType<typeof useGetChannelNodeDocumentationQuery>;
export type GetChannelNodeDocumentationLazyQueryHookResult = ReturnType<typeof useGetChannelNodeDocumentationLazyQuery>;
export type GetChannelNodeDocumentationQueryResult = Apollo.QueryResult<GetChannelNodeDocumentationQuery, GetChannelNodeDocumentationQueryVariables>;
export const GetManagedChannelsDocument = gql`
    query getManagedChannels($organizationId: String!, $channelId: String) {
  getManagedChannels(organizationId: $organizationId, channelId: $channelId) {
    channelId
    createdAt
    createdBy
    description
    instanceType
    interfaceVersion
    name
    organizationId
    organizations {
      name
      organizationId
    }
    timeout
    updatedAt
    updatedBy
    volumes
  }
}
    `;

/**
 * __useGetManagedChannelsQuery__
 *
 * To run a query within a React component, call `useGetManagedChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagedChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagedChannelsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetManagedChannelsQuery(baseOptions: Apollo.QueryHookOptions<GetManagedChannelsQuery, GetManagedChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagedChannelsQuery, GetManagedChannelsQueryVariables>(GetManagedChannelsDocument, options);
      }
export function useGetManagedChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagedChannelsQuery, GetManagedChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagedChannelsQuery, GetManagedChannelsQueryVariables>(GetManagedChannelsDocument, options);
        }
export type GetManagedChannelsQueryHookResult = ReturnType<typeof useGetManagedChannelsQuery>;
export type GetManagedChannelsLazyQueryHookResult = ReturnType<typeof useGetManagedChannelsLazyQuery>;
export type GetManagedChannelsQueryResult = Apollo.QueryResult<GetManagedChannelsQuery, GetManagedChannelsQueryVariables>;
export const CreateManagedChannelDocument = gql`
    mutation createManagedChannel($organizationId: String!, $name: String!, $description: String, $volumes: [String], $instance: String, $timeout: Int, $interfaceVersion: Int, $tags: [String]) {
  createManagedChannel(
    organizationId: $organizationId
    name: $name
    description: $description
    volumes: $volumes
    instance: $instance
    timeout: $timeout
    interfaceVersion: $interfaceVersion
    tags: $tags
  )
}
    `;
export type CreateManagedChannelMutationFn = Apollo.MutationFunction<CreateManagedChannelMutation, CreateManagedChannelMutationVariables>;

/**
 * __useCreateManagedChannelMutation__
 *
 * To run a mutation, you first call `useCreateManagedChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManagedChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManagedChannelMutation, { data, loading, error }] = useCreateManagedChannelMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      volumes: // value for 'volumes'
 *      instance: // value for 'instance'
 *      timeout: // value for 'timeout'
 *      interfaceVersion: // value for 'interfaceVersion'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateManagedChannelMutation(baseOptions?: Apollo.MutationHookOptions<CreateManagedChannelMutation, CreateManagedChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManagedChannelMutation, CreateManagedChannelMutationVariables>(CreateManagedChannelDocument, options);
      }
export type CreateManagedChannelMutationHookResult = ReturnType<typeof useCreateManagedChannelMutation>;
export type CreateManagedChannelMutationResult = Apollo.MutationResult<CreateManagedChannelMutation>;
export type CreateManagedChannelMutationOptions = Apollo.BaseMutationOptions<CreateManagedChannelMutation, CreateManagedChannelMutationVariables>;
export const DeleteManagedChannelDocument = gql`
    mutation deleteManagedChannel($channelId: String!) {
  deleteManagedChannel(channelId: $channelId)
}
    `;
export type DeleteManagedChannelMutationFn = Apollo.MutationFunction<DeleteManagedChannelMutation, DeleteManagedChannelMutationVariables>;

/**
 * __useDeleteManagedChannelMutation__
 *
 * To run a mutation, you first call `useDeleteManagedChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManagedChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManagedChannelMutation, { data, loading, error }] = useDeleteManagedChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useDeleteManagedChannelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteManagedChannelMutation, DeleteManagedChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteManagedChannelMutation, DeleteManagedChannelMutationVariables>(DeleteManagedChannelDocument, options);
      }
export type DeleteManagedChannelMutationHookResult = ReturnType<typeof useDeleteManagedChannelMutation>;
export type DeleteManagedChannelMutationResult = Apollo.MutationResult<DeleteManagedChannelMutation>;
export type DeleteManagedChannelMutationOptions = Apollo.BaseMutationOptions<DeleteManagedChannelMutation, DeleteManagedChannelMutationVariables>;
export const RemoveChannelOrganizationDocument = gql`
    mutation removeChannelOrganization($organizationId: String!, $channelId: String!) {
  removeChannelOrganization(
    organizationId: $organizationId
    channelId: $channelId
  )
}
    `;
export type RemoveChannelOrganizationMutationFn = Apollo.MutationFunction<RemoveChannelOrganizationMutation, RemoveChannelOrganizationMutationVariables>;

/**
 * __useRemoveChannelOrganizationMutation__
 *
 * To run a mutation, you first call `useRemoveChannelOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveChannelOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeChannelOrganizationMutation, { data, loading, error }] = useRemoveChannelOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useRemoveChannelOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveChannelOrganizationMutation, RemoveChannelOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveChannelOrganizationMutation, RemoveChannelOrganizationMutationVariables>(RemoveChannelOrganizationDocument, options);
      }
export type RemoveChannelOrganizationMutationHookResult = ReturnType<typeof useRemoveChannelOrganizationMutation>;
export type RemoveChannelOrganizationMutationResult = Apollo.MutationResult<RemoveChannelOrganizationMutation>;
export type RemoveChannelOrganizationMutationOptions = Apollo.BaseMutationOptions<RemoveChannelOrganizationMutation, RemoveChannelOrganizationMutationVariables>;
export const EditManagedChannelDocument = gql`
    mutation editManagedChannel($channelId: String!, $name: String, $description: String, $volumes: [String], $instance: String, $timeout: Int, $status: String, $interfaceVersion: Int, $tags: [String]) {
  editManagedChannel(
    channelId: $channelId
    name: $name
    description: $description
    volumes: $volumes
    instance: $instance
    timeout: $timeout
    status: $status
    interfaceVersion: $interfaceVersion
    tags: $tags
  )
}
    `;
export type EditManagedChannelMutationFn = Apollo.MutationFunction<EditManagedChannelMutation, EditManagedChannelMutationVariables>;

/**
 * __useEditManagedChannelMutation__
 *
 * To run a mutation, you first call `useEditManagedChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditManagedChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editManagedChannelMutation, { data, loading, error }] = useEditManagedChannelMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      volumes: // value for 'volumes'
 *      instance: // value for 'instance'
 *      timeout: // value for 'timeout'
 *      status: // value for 'status'
 *      interfaceVersion: // value for 'interfaceVersion'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditManagedChannelMutation(baseOptions?: Apollo.MutationHookOptions<EditManagedChannelMutation, EditManagedChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditManagedChannelMutation, EditManagedChannelMutationVariables>(EditManagedChannelDocument, options);
      }
export type EditManagedChannelMutationHookResult = ReturnType<typeof useEditManagedChannelMutation>;
export type EditManagedChannelMutationResult = Apollo.MutationResult<EditManagedChannelMutation>;
export type EditManagedChannelMutationOptions = Apollo.BaseMutationOptions<EditManagedChannelMutation, EditManagedChannelMutationVariables>;
export const UploadDatasetDocument = gql`
    mutation uploadDataset($workspaceId: String!, $description: String!, $name: String!, $tags: [String]) {
  uploadDataset(
    workspaceId: $workspaceId
    name: $name
    description: $description
    tags: $tags
  ) {
    key
    url
    fields {
      key
      bucket
      algorithm
      credential
      date
      token
      policy
      signature
    }
  }
}
    `;
export type UploadDatasetMutationFn = Apollo.MutationFunction<UploadDatasetMutation, UploadDatasetMutationVariables>;

/**
 * __useUploadDatasetMutation__
 *
 * To run a mutation, you first call `useUploadDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDatasetMutation, { data, loading, error }] = useUploadDatasetMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      description: // value for 'description'
 *      name: // value for 'name'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUploadDatasetMutation(baseOptions?: Apollo.MutationHookOptions<UploadDatasetMutation, UploadDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDatasetMutation, UploadDatasetMutationVariables>(UploadDatasetDocument, options);
      }
export type UploadDatasetMutationHookResult = ReturnType<typeof useUploadDatasetMutation>;
export type UploadDatasetMutationResult = Apollo.MutationResult<UploadDatasetMutation>;
export type UploadDatasetMutationOptions = Apollo.BaseMutationOptions<UploadDatasetMutation, UploadDatasetMutationVariables>;
export const DownloadDatasetDocument = gql`
    mutation downloadDataset($datasetId: String!, $workspaceId: String!) {
  downloadDataset(datasetId: $datasetId, workspaceId: $workspaceId)
}
    `;
export type DownloadDatasetMutationFn = Apollo.MutationFunction<DownloadDatasetMutation, DownloadDatasetMutationVariables>;

/**
 * __useDownloadDatasetMutation__
 *
 * To run a mutation, you first call `useDownloadDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadDatasetMutation, { data, loading, error }] = useDownloadDatasetMutation({
 *   variables: {
 *      datasetId: // value for 'datasetId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDownloadDatasetMutation(baseOptions?: Apollo.MutationHookOptions<DownloadDatasetMutation, DownloadDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadDatasetMutation, DownloadDatasetMutationVariables>(DownloadDatasetDocument, options);
      }
export type DownloadDatasetMutationHookResult = ReturnType<typeof useDownloadDatasetMutation>;
export type DownloadDatasetMutationResult = Apollo.MutationResult<DownloadDatasetMutation>;
export type DownloadDatasetMutationOptions = Apollo.BaseMutationOptions<DownloadDatasetMutation, DownloadDatasetMutationVariables>;
export const DeleteDatasetDocument = gql`
    mutation deleteDataset($datasetId: String!, $workspaceId: String!) {
  deleteDataset(datasetId: $datasetId, workspaceId: $workspaceId)
}
    `;
export type DeleteDatasetMutationFn = Apollo.MutationFunction<DeleteDatasetMutation, DeleteDatasetMutationVariables>;

/**
 * __useDeleteDatasetMutation__
 *
 * To run a mutation, you first call `useDeleteDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDatasetMutation, { data, loading, error }] = useDeleteDatasetMutation({
 *   variables: {
 *      datasetId: // value for 'datasetId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteDatasetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDatasetMutation, DeleteDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDatasetMutation, DeleteDatasetMutationVariables>(DeleteDatasetDocument, options);
      }
export type DeleteDatasetMutationHookResult = ReturnType<typeof useDeleteDatasetMutation>;
export type DeleteDatasetMutationResult = Apollo.MutationResult<DeleteDatasetMutation>;
export type DeleteDatasetMutationOptions = Apollo.BaseMutationOptions<DeleteDatasetMutation, DeleteDatasetMutationVariables>;
export const GetDatasetRunsDocument = gql`
    query getDatasetRuns($workspaceId: String!, $datasetId: String!, $state: String) {
  getDatasetRuns(workspaceId: $workspaceId, datasetId: $datasetId, state: $state) {
    runId
    workspaceId
    datasetId
    channelId
    startTime
    endTime
    state
    run
  }
  getDatasetJobs(workspaceId: $workspaceId, datasetId: $datasetId) {
    datasetId
    name
  }
}
    `;

/**
 * __useGetDatasetRunsQuery__
 *
 * To run a query within a React component, call `useGetDatasetRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetRunsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetDatasetRunsQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetRunsQuery, GetDatasetRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetRunsQuery, GetDatasetRunsQueryVariables>(GetDatasetRunsDocument, options);
      }
export function useGetDatasetRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetRunsQuery, GetDatasetRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetRunsQuery, GetDatasetRunsQueryVariables>(GetDatasetRunsDocument, options);
        }
export type GetDatasetRunsQueryHookResult = ReturnType<typeof useGetDatasetRunsQuery>;
export type GetDatasetRunsLazyQueryHookResult = ReturnType<typeof useGetDatasetRunsLazyQuery>;
export type GetDatasetRunsQueryResult = Apollo.QueryResult<GetDatasetRunsQuery, GetDatasetRunsQueryVariables>;
export const GetDatasetLogDocument = gql`
    query getDatasetLog($workspaceId: String!, $datasetId: String!, $runId: String!) {
  getDatasetLog(workspaceId: $workspaceId, datasetId: $datasetId, runId: $runId) {
    runId
    workspaceId
    datasetId
    channelId
    email
    startTime
    endTime
    state
    run
    log
  }
}
    `;

/**
 * __useGetDatasetLogQuery__
 *
 * To run a query within a React component, call `useGetDatasetLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useGetDatasetLogQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetLogQuery, GetDatasetLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetLogQuery, GetDatasetLogQueryVariables>(GetDatasetLogDocument, options);
      }
export function useGetDatasetLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetLogQuery, GetDatasetLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetLogQuery, GetDatasetLogQueryVariables>(GetDatasetLogDocument, options);
        }
export type GetDatasetLogQueryHookResult = ReturnType<typeof useGetDatasetLogQuery>;
export type GetDatasetLogLazyQueryHookResult = ReturnType<typeof useGetDatasetLogLazyQuery>;
export type GetDatasetLogQueryResult = Apollo.QueryResult<GetDatasetLogQuery, GetDatasetLogQueryVariables>;
export const GetDatasetImageDocument = gql`
    query GetDatasetImage($workspaceId: String!, $datasetId: String!, $filename: String!) {
  getDatasetImage(
    workspaceId: $workspaceId
    datasetId: $datasetId
    filename: $filename
  ) {
    data
  }
}
    `;

/**
 * __useGetDatasetImageQuery__
 *
 * To run a query within a React component, call `useGetDatasetImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetImageQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGetDatasetImageQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetImageQuery, GetDatasetImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetImageQuery, GetDatasetImageQueryVariables>(GetDatasetImageDocument, options);
      }
export function useGetDatasetImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetImageQuery, GetDatasetImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetImageQuery, GetDatasetImageQueryVariables>(GetDatasetImageDocument, options);
        }
export type GetDatasetImageQueryHookResult = ReturnType<typeof useGetDatasetImageQuery>;
export type GetDatasetImageLazyQueryHookResult = ReturnType<typeof useGetDatasetImageLazyQuery>;
export type GetDatasetImageQueryResult = Apollo.QueryResult<GetDatasetImageQuery, GetDatasetImageQueryVariables>;
export const GetDatasetDocument = gql`
    query GetDataset($workspaceId: String!, $datasetId: String) {
  getDatasets(workspaceId: $workspaceId, datasetId: $datasetId) {
    datasetId
    files
    name
    runs
  }
}
    `;

/**
 * __useGetDatasetQuery__
 *
 * To run a query within a React component, call `useGetDatasetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetQuery, GetDatasetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetQuery, GetDatasetQueryVariables>(GetDatasetDocument, options);
      }
export function useGetDatasetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetQuery, GetDatasetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetQuery, GetDatasetQueryVariables>(GetDatasetDocument, options);
        }
export type GetDatasetQueryHookResult = ReturnType<typeof useGetDatasetQuery>;
export type GetDatasetLazyQueryHookResult = ReturnType<typeof useGetDatasetLazyQuery>;
export type GetDatasetQueryResult = Apollo.QueryResult<GetDatasetQuery, GetDatasetQueryVariables>;
export const GetGanModelsDocument = gql`
    query getGANModels($workspaceId: String, $modelId: String, $organizationId: String, $cursor: String, $limit: Int, $filters: GANModelFilter) {
  getGANModels(
    workspaceId: $workspaceId
    modelId: $modelId
    organizationId: $organizationId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    organizationId
    modelId
    description
    flags
    name
    organization
    createdAt
    updatedAt
    tags
  }
}
    `;

/**
 * __useGetGanModelsQuery__
 *
 * To run a query within a React component, call `useGetGanModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGanModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGanModelsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *      organizationId: // value for 'organizationId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetGanModelsQuery(baseOptions?: Apollo.QueryHookOptions<GetGanModelsQuery, GetGanModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGanModelsQuery, GetGanModelsQueryVariables>(GetGanModelsDocument, options);
      }
export function useGetGanModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGanModelsQuery, GetGanModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGanModelsQuery, GetGanModelsQueryVariables>(GetGanModelsDocument, options);
        }
export type GetGanModelsQueryHookResult = ReturnType<typeof useGetGanModelsQuery>;
export type GetGanModelsLazyQueryHookResult = ReturnType<typeof useGetGanModelsLazyQuery>;
export type GetGanModelsQueryResult = Apollo.QueryResult<GetGanModelsQuery, GetGanModelsQueryVariables>;
export const CreateGanDatasetDocument = gql`
    mutation createGANDataset($workspaceId: String!, $datasetId: String!, $modelId: String!, $name: String!, $description: String, $tags: [String]) {
  createGANDataset(
    workspaceId: $workspaceId
    datasetId: $datasetId
    modelId: $modelId
    name: $name
    description: $description
    tags: $tags
  )
}
    `;
export type CreateGanDatasetMutationFn = Apollo.MutationFunction<CreateGanDatasetMutation, CreateGanDatasetMutationVariables>;

/**
 * __useCreateGanDatasetMutation__
 *
 * To run a mutation, you first call `useCreateGanDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGanDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGanDatasetMutation, { data, loading, error }] = useCreateGanDatasetMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      modelId: // value for 'modelId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateGanDatasetMutation(baseOptions?: Apollo.MutationHookOptions<CreateGanDatasetMutation, CreateGanDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGanDatasetMutation, CreateGanDatasetMutationVariables>(CreateGanDatasetDocument, options);
      }
export type CreateGanDatasetMutationHookResult = ReturnType<typeof useCreateGanDatasetMutation>;
export type CreateGanDatasetMutationResult = Apollo.MutationResult<CreateGanDatasetMutation>;
export type CreateGanDatasetMutationOptions = Apollo.BaseMutationOptions<CreateGanDatasetMutation, CreateGanDatasetMutationVariables>;
export const DeleteGanDatasetDocument = gql`
    mutation deleteGANDataset($workspaceId: String!, $datasetId: String!) {
  deleteGANDataset(workspaceId: $workspaceId, datasetId: $datasetId)
}
    `;
export type DeleteGanDatasetMutationFn = Apollo.MutationFunction<DeleteGanDatasetMutation, DeleteGanDatasetMutationVariables>;

/**
 * __useDeleteGanDatasetMutation__
 *
 * To run a mutation, you first call `useDeleteGanDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGanDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGanDatasetMutation, { data, loading, error }] = useDeleteGanDatasetMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useDeleteGanDatasetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGanDatasetMutation, DeleteGanDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGanDatasetMutation, DeleteGanDatasetMutationVariables>(DeleteGanDatasetDocument, options);
      }
export type DeleteGanDatasetMutationHookResult = ReturnType<typeof useDeleteGanDatasetMutation>;
export type DeleteGanDatasetMutationResult = Apollo.MutationResult<DeleteGanDatasetMutation>;
export type DeleteGanDatasetMutationOptions = Apollo.BaseMutationOptions<DeleteGanDatasetMutation, DeleteGanDatasetMutationVariables>;
export const GetGanDatasetLogDocument = gql`
    query GetGANDatasetLog($workspaceId: String!, $datasetId: String!) {
  getGANDatasetLog(workspaceId: $workspaceId, datasetId: $datasetId) {
    log
  }
}
    `;

/**
 * __useGetGanDatasetLogQuery__
 *
 * To run a query within a React component, call `useGetGanDatasetLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGanDatasetLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGanDatasetLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetGanDatasetLogQuery(baseOptions: Apollo.QueryHookOptions<GetGanDatasetLogQuery, GetGanDatasetLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGanDatasetLogQuery, GetGanDatasetLogQueryVariables>(GetGanDatasetLogDocument, options);
      }
export function useGetGanDatasetLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGanDatasetLogQuery, GetGanDatasetLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGanDatasetLogQuery, GetGanDatasetLogQueryVariables>(GetGanDatasetLogDocument, options);
        }
export type GetGanDatasetLogQueryHookResult = ReturnType<typeof useGetGanDatasetLogQuery>;
export type GetGanDatasetLogLazyQueryHookResult = ReturnType<typeof useGetGanDatasetLogLazyQuery>;
export type GetGanDatasetLogQueryResult = Apollo.QueryResult<GetGanDatasetLogQuery, GetGanDatasetLogQueryVariables>;
export const EditManagedGanDocument = gql`
    mutation editManagedGAN($modelId: String!, $name: String, $description: String, $flags: String, $tags: [String]) {
  editManagedGAN(
    modelId: $modelId
    name: $name
    description: $description
    flags: $flags
    tags: $tags
  )
}
    `;
export type EditManagedGanMutationFn = Apollo.MutationFunction<EditManagedGanMutation, EditManagedGanMutationVariables>;

/**
 * __useEditManagedGanMutation__
 *
 * To run a mutation, you first call `useEditManagedGanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditManagedGanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editManagedGanMutation, { data, loading, error }] = useEditManagedGanMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      flags: // value for 'flags'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditManagedGanMutation(baseOptions?: Apollo.MutationHookOptions<EditManagedGanMutation, EditManagedGanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditManagedGanMutation, EditManagedGanMutationVariables>(EditManagedGanDocument, options);
      }
export type EditManagedGanMutationHookResult = ReturnType<typeof useEditManagedGanMutation>;
export type EditManagedGanMutationResult = Apollo.MutationResult<EditManagedGanMutation>;
export type EditManagedGanMutationOptions = Apollo.BaseMutationOptions<EditManagedGanMutation, EditManagedGanMutationVariables>;
export const DeleteManagedGanDocument = gql`
    mutation deleteManagedGAN($modelId: String!) {
  deleteManagedGAN(modelId: $modelId)
}
    `;
export type DeleteManagedGanMutationFn = Apollo.MutationFunction<DeleteManagedGanMutation, DeleteManagedGanMutationVariables>;

/**
 * __useDeleteManagedGanMutation__
 *
 * To run a mutation, you first call `useDeleteManagedGanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManagedGanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManagedGanMutation, { data, loading, error }] = useDeleteManagedGanMutation({
 *   variables: {
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useDeleteManagedGanMutation(baseOptions?: Apollo.MutationHookOptions<DeleteManagedGanMutation, DeleteManagedGanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteManagedGanMutation, DeleteManagedGanMutationVariables>(DeleteManagedGanDocument, options);
      }
export type DeleteManagedGanMutationHookResult = ReturnType<typeof useDeleteManagedGanMutation>;
export type DeleteManagedGanMutationResult = Apollo.MutationResult<DeleteManagedGanMutation>;
export type DeleteManagedGanMutationOptions = Apollo.BaseMutationOptions<DeleteManagedGanMutation, DeleteManagedGanMutationVariables>;
export const RemoveGanOrganizationDocument = gql`
    mutation removeGANOrganization($organizationId: String!, $modelId: String!) {
  removeGANOrganization(organizationId: $organizationId, modelId: $modelId)
}
    `;
export type RemoveGanOrganizationMutationFn = Apollo.MutationFunction<RemoveGanOrganizationMutation, RemoveGanOrganizationMutationVariables>;

/**
 * __useRemoveGanOrganizationMutation__
 *
 * To run a mutation, you first call `useRemoveGanOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGanOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGanOrganizationMutation, { data, loading, error }] = useRemoveGanOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useRemoveGanOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGanOrganizationMutation, RemoveGanOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGanOrganizationMutation, RemoveGanOrganizationMutationVariables>(RemoveGanOrganizationDocument, options);
      }
export type RemoveGanOrganizationMutationHookResult = ReturnType<typeof useRemoveGanOrganizationMutation>;
export type RemoveGanOrganizationMutationResult = Apollo.MutationResult<RemoveGanOrganizationMutation>;
export type RemoveGanOrganizationMutationOptions = Apollo.BaseMutationOptions<RemoveGanOrganizationMutation, RemoveGanOrganizationMutationVariables>;
export const GetInpaintFormatsDocument = gql`
    query GetInpaintFormats {
  getInpaintFormats {
    name
    value
    info
  }
}
    `;

/**
 * __useGetInpaintFormatsQuery__
 *
 * To run a query within a React component, call `useGetInpaintFormatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInpaintFormatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInpaintFormatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInpaintFormatsQuery(baseOptions?: Apollo.QueryHookOptions<GetInpaintFormatsQuery, GetInpaintFormatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInpaintFormatsQuery, GetInpaintFormatsQueryVariables>(GetInpaintFormatsDocument, options);
      }
export function useGetInpaintFormatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInpaintFormatsQuery, GetInpaintFormatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInpaintFormatsQuery, GetInpaintFormatsQueryVariables>(GetInpaintFormatsDocument, options);
        }
export type GetInpaintFormatsQueryHookResult = ReturnType<typeof useGetInpaintFormatsQuery>;
export type GetInpaintFormatsLazyQueryHookResult = ReturnType<typeof useGetInpaintFormatsLazyQuery>;
export type GetInpaintFormatsQueryResult = Apollo.QueryResult<GetInpaintFormatsQuery, GetInpaintFormatsQueryVariables>;
export const GetInpaintsDocument = gql`
    query GetInpaints($volumeId: String!, $cursor: String, $limit: Int) {
  getInpaints(volumeId: $volumeId, cursor: $cursor, limit: $limit) {
    volumeId
    inpaintId
    status
    location
    destination
    inputType
    outputType
    dilation
    createdBy
    createdAt
    updatedBy
    updatedAt
  }
}
    `;

/**
 * __useGetInpaintsQuery__
 *
 * To run a query within a React component, call `useGetInpaintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInpaintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInpaintsQuery({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetInpaintsQuery(baseOptions: Apollo.QueryHookOptions<GetInpaintsQuery, GetInpaintsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInpaintsQuery, GetInpaintsQueryVariables>(GetInpaintsDocument, options);
      }
export function useGetInpaintsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInpaintsQuery, GetInpaintsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInpaintsQuery, GetInpaintsQueryVariables>(GetInpaintsDocument, options);
        }
export type GetInpaintsQueryHookResult = ReturnType<typeof useGetInpaintsQuery>;
export type GetInpaintsLazyQueryHookResult = ReturnType<typeof useGetInpaintsLazyQuery>;
export type GetInpaintsQueryResult = Apollo.QueryResult<GetInpaintsQuery, GetInpaintsQueryVariables>;
export const GetInpaintLogDocument = gql`
    query GetInpaintLog($volumeId: String!, $inpaintId: String!) {
  getInpaintLog(volumeId: $volumeId, inpaintId: $inpaintId) {
    log
  }
}
    `;

/**
 * __useGetInpaintLogQuery__
 *
 * To run a query within a React component, call `useGetInpaintLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInpaintLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInpaintLogQuery({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      inpaintId: // value for 'inpaintId'
 *   },
 * });
 */
export function useGetInpaintLogQuery(baseOptions: Apollo.QueryHookOptions<GetInpaintLogQuery, GetInpaintLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInpaintLogQuery, GetInpaintLogQueryVariables>(GetInpaintLogDocument, options);
      }
export function useGetInpaintLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInpaintLogQuery, GetInpaintLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInpaintLogQuery, GetInpaintLogQueryVariables>(GetInpaintLogDocument, options);
        }
export type GetInpaintLogQueryHookResult = ReturnType<typeof useGetInpaintLogQuery>;
export type GetInpaintLogLazyQueryHookResult = ReturnType<typeof useGetInpaintLogLazyQuery>;
export type GetInpaintLogQueryResult = Apollo.QueryResult<GetInpaintLogQuery, GetInpaintLogQueryVariables>;
export const CreateInpaintDocument = gql`
    mutation CreateInpaint($volumeId: String!, $location: String!, $destination: String, $inputType: InpaintInputType, $outputType: InpaintOutputType, $dilation: Int) {
  createInpaint(
    volumeId: $volumeId
    location: $location
    destination: $destination
    inputType: $inputType
    outputType: $outputType
    dilation: $dilation
  )
}
    `;
export type CreateInpaintMutationFn = Apollo.MutationFunction<CreateInpaintMutation, CreateInpaintMutationVariables>;

/**
 * __useCreateInpaintMutation__
 *
 * To run a mutation, you first call `useCreateInpaintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInpaintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInpaintMutation, { data, loading, error }] = useCreateInpaintMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      location: // value for 'location'
 *      destination: // value for 'destination'
 *      inputType: // value for 'inputType'
 *      outputType: // value for 'outputType'
 *      dilation: // value for 'dilation'
 *   },
 * });
 */
export function useCreateInpaintMutation(baseOptions?: Apollo.MutationHookOptions<CreateInpaintMutation, CreateInpaintMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInpaintMutation, CreateInpaintMutationVariables>(CreateInpaintDocument, options);
      }
export type CreateInpaintMutationHookResult = ReturnType<typeof useCreateInpaintMutation>;
export type CreateInpaintMutationResult = Apollo.MutationResult<CreateInpaintMutation>;
export type CreateInpaintMutationOptions = Apollo.BaseMutationOptions<CreateInpaintMutation, CreateInpaintMutationVariables>;
export const DeleteInpaintDocument = gql`
    mutation DeleteInpaint($volumeId: String!, $inpaintId: String!) {
  deleteInpaint(volumeId: $volumeId, inpaintId: $inpaintId)
}
    `;
export type DeleteInpaintMutationFn = Apollo.MutationFunction<DeleteInpaintMutation, DeleteInpaintMutationVariables>;

/**
 * __useDeleteInpaintMutation__
 *
 * To run a mutation, you first call `useDeleteInpaintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInpaintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInpaintMutation, { data, loading, error }] = useDeleteInpaintMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      inpaintId: // value for 'inpaintId'
 *   },
 * });
 */
export function useDeleteInpaintMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInpaintMutation, DeleteInpaintMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInpaintMutation, DeleteInpaintMutationVariables>(DeleteInpaintDocument, options);
      }
export type DeleteInpaintMutationHookResult = ReturnType<typeof useDeleteInpaintMutation>;
export type DeleteInpaintMutationResult = Apollo.MutationResult<DeleteInpaintMutation>;
export type DeleteInpaintMutationOptions = Apollo.BaseMutationOptions<DeleteInpaintMutation, DeleteInpaintMutationVariables>;
export const GetInvitationsDocument = gql`
    query getInvitations($organizationId: String!) {
  getInvitations(organizationId: $organizationId) {
    email
    organizationId
    role
    updatedAt
  }
}
    `;

/**
 * __useGetInvitationsQuery__
 *
 * To run a query within a React component, call `useGetInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitationsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetInvitationsQuery(baseOptions: Apollo.QueryHookOptions<GetInvitationsQuery, GetInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvitationsQuery, GetInvitationsQueryVariables>(GetInvitationsDocument, options);
      }
export function useGetInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvitationsQuery, GetInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvitationsQuery, GetInvitationsQueryVariables>(GetInvitationsDocument, options);
        }
export type GetInvitationsQueryHookResult = ReturnType<typeof useGetInvitationsQuery>;
export type GetInvitationsLazyQueryHookResult = ReturnType<typeof useGetInvitationsLazyQuery>;
export type GetInvitationsQueryResult = Apollo.QueryResult<GetInvitationsQuery, GetInvitationsQueryVariables>;
export const GetMembersDocument = gql`
    query getMembers($organizationId: String!, $limit: Int, $cursor: String) {
  getMembers(organizationId: $organizationId, limit: $limit, cursor: $cursor) {
    userId
    email
    name
    role
  }
}
    `;

/**
 * __useGetMembersQuery__
 *
 * To run a query within a React component, call `useGetMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetMembersQuery(baseOptions: Apollo.QueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
      }
export function useGetMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
        }
export type GetMembersQueryHookResult = ReturnType<typeof useGetMembersQuery>;
export type GetMembersLazyQueryHookResult = ReturnType<typeof useGetMembersLazyQuery>;
export type GetMembersQueryResult = Apollo.QueryResult<GetMembersQuery, GetMembersQueryVariables>;
export const EditMemberDocument = gql`
    mutation editMember($email: String, $name: String) {
  editMember(email: $email, name: $name)
}
    `;
export type EditMemberMutationFn = Apollo.MutationFunction<EditMemberMutation, EditMemberMutationVariables>;

/**
 * __useEditMemberMutation__
 *
 * To run a mutation, you first call `useEditMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMemberMutation, { data, loading, error }] = useEditMemberMutation({
 *   variables: {
 *      email: // value for 'email'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEditMemberMutation(baseOptions?: Apollo.MutationHookOptions<EditMemberMutation, EditMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMemberMutation, EditMemberMutationVariables>(EditMemberDocument, options);
      }
export type EditMemberMutationHookResult = ReturnType<typeof useEditMemberMutation>;
export type EditMemberMutationResult = Apollo.MutationResult<EditMemberMutation>;
export type EditMemberMutationOptions = Apollo.BaseMutationOptions<EditMemberMutation, EditMemberMutationVariables>;
export const AddMemberDocument = gql`
    mutation addMember($organizationId: String!, $email: String!, $role: String!) {
  addMember(organizationId: $organizationId, email: $email, role: $role)
}
    `;
export type AddMemberMutationFn = Apollo.MutationFunction<AddMemberMutation, AddMemberMutationVariables>;

/**
 * __useAddMemberMutation__
 *
 * To run a mutation, you first call `useAddMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMemberMutation, { data, loading, error }] = useAddMemberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      email: // value for 'email'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAddMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddMemberMutation, AddMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMemberMutation, AddMemberMutationVariables>(AddMemberDocument, options);
      }
export type AddMemberMutationHookResult = ReturnType<typeof useAddMemberMutation>;
export type AddMemberMutationResult = Apollo.MutationResult<AddMemberMutation>;
export type AddMemberMutationOptions = Apollo.BaseMutationOptions<AddMemberMutation, AddMemberMutationVariables>;
export const RemoveMemberDocument = gql`
    mutation removeMember($organizationId: String!, $email: String!) {
  removeMember(organizationId: $organizationId, email: $email)
}
    `;
export type RemoveMemberMutationFn = Apollo.MutationFunction<RemoveMemberMutation, RemoveMemberMutationVariables>;

/**
 * __useRemoveMemberMutation__
 *
 * To run a mutation, you first call `useRemoveMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberMutation, { data, loading, error }] = useRemoveMemberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRemoveMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMemberMutation, RemoveMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMemberMutation, RemoveMemberMutationVariables>(RemoveMemberDocument, options);
      }
export type RemoveMemberMutationHookResult = ReturnType<typeof useRemoveMemberMutation>;
export type RemoveMemberMutationResult = Apollo.MutationResult<RemoveMemberMutation>;
export type RemoveMemberMutationOptions = Apollo.BaseMutationOptions<RemoveMemberMutation, RemoveMemberMutationVariables>;
export const EditMemberByRoleDocument = gql`
    mutation editMemberByRole($organizationId: String, $email: String!, $role: String!) {
  editMember(organizationId: $organizationId, email: $email, role: $role)
}
    `;
export type EditMemberByRoleMutationFn = Apollo.MutationFunction<EditMemberByRoleMutation, EditMemberByRoleMutationVariables>;

/**
 * __useEditMemberByRoleMutation__
 *
 * To run a mutation, you first call `useEditMemberByRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMemberByRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMemberByRoleMutation, { data, loading, error }] = useEditMemberByRoleMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      email: // value for 'email'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useEditMemberByRoleMutation(baseOptions?: Apollo.MutationHookOptions<EditMemberByRoleMutation, EditMemberByRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMemberByRoleMutation, EditMemberByRoleMutationVariables>(EditMemberByRoleDocument, options);
      }
export type EditMemberByRoleMutationHookResult = ReturnType<typeof useEditMemberByRoleMutation>;
export type EditMemberByRoleMutationResult = Apollo.MutationResult<EditMemberByRoleMutation>;
export type EditMemberByRoleMutationOptions = Apollo.BaseMutationOptions<EditMemberByRoleMutation, EditMemberByRoleMutationVariables>;
export const GetMlInferenceLogDocument = gql`
    query getMLInferenceLog($workspaceId: String!, $inferenceId: String!) {
  getMLInferenceLog(workspaceId: $workspaceId, inferenceId: $inferenceId) {
    workspaceId
    inferenceId
    status
    log
  }
}
    `;

/**
 * __useGetMlInferenceLogQuery__
 *
 * To run a query within a React component, call `useGetMlInferenceLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMlInferenceLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMlInferenceLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      inferenceId: // value for 'inferenceId'
 *   },
 * });
 */
export function useGetMlInferenceLogQuery(baseOptions: Apollo.QueryHookOptions<GetMlInferenceLogQuery, GetMlInferenceLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMlInferenceLogQuery, GetMlInferenceLogQueryVariables>(GetMlInferenceLogDocument, options);
      }
export function useGetMlInferenceLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMlInferenceLogQuery, GetMlInferenceLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMlInferenceLogQuery, GetMlInferenceLogQueryVariables>(GetMlInferenceLogDocument, options);
        }
export type GetMlInferenceLogQueryHookResult = ReturnType<typeof useGetMlInferenceLogQuery>;
export type GetMlInferenceLogLazyQueryHookResult = ReturnType<typeof useGetMlInferenceLogLazyQuery>;
export type GetMlInferenceLogQueryResult = Apollo.QueryResult<GetMlInferenceLogQuery, GetMlInferenceLogQueryVariables>;
export const GetMlInferenceMetricsDocument = gql`
    query getMLInferenceMetrics($workspaceId: String!, $inferenceId: String!) {
  getMLInferenceMetrics(workspaceId: $workspaceId, inferenceId: $inferenceId)
}
    `;

/**
 * __useGetMlInferenceMetricsQuery__
 *
 * To run a query within a React component, call `useGetMlInferenceMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMlInferenceMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMlInferenceMetricsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      inferenceId: // value for 'inferenceId'
 *   },
 * });
 */
export function useGetMlInferenceMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetMlInferenceMetricsQuery, GetMlInferenceMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMlInferenceMetricsQuery, GetMlInferenceMetricsQueryVariables>(GetMlInferenceMetricsDocument, options);
      }
export function useGetMlInferenceMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMlInferenceMetricsQuery, GetMlInferenceMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMlInferenceMetricsQuery, GetMlInferenceMetricsQueryVariables>(GetMlInferenceMetricsDocument, options);
        }
export type GetMlInferenceMetricsQueryHookResult = ReturnType<typeof useGetMlInferenceMetricsQuery>;
export type GetMlInferenceMetricsLazyQueryHookResult = ReturnType<typeof useGetMlInferenceMetricsLazyQuery>;
export type GetMlInferenceMetricsQueryResult = Apollo.QueryResult<GetMlInferenceMetricsQuery, GetMlInferenceMetricsQueryVariables>;
export const CreateMlInferenceDocument = gql`
    mutation createMLInference($workspaceId: String!, $datasetId: String!, $modelId: String!, $mapId: String, $tags: [String]) {
  createMLInference(
    workspaceId: $workspaceId
    datasetId: $datasetId
    modelId: $modelId
    mapId: $mapId
    tags: $tags
  )
}
    `;
export type CreateMlInferenceMutationFn = Apollo.MutationFunction<CreateMlInferenceMutation, CreateMlInferenceMutationVariables>;

/**
 * __useCreateMlInferenceMutation__
 *
 * To run a mutation, you first call `useCreateMlInferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMlInferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMlInferenceMutation, { data, loading, error }] = useCreateMlInferenceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      modelId: // value for 'modelId'
 *      mapId: // value for 'mapId'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateMlInferenceMutation(baseOptions?: Apollo.MutationHookOptions<CreateMlInferenceMutation, CreateMlInferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMlInferenceMutation, CreateMlInferenceMutationVariables>(CreateMlInferenceDocument, options);
      }
export type CreateMlInferenceMutationHookResult = ReturnType<typeof useCreateMlInferenceMutation>;
export type CreateMlInferenceMutationResult = Apollo.MutationResult<CreateMlInferenceMutation>;
export type CreateMlInferenceMutationOptions = Apollo.BaseMutationOptions<CreateMlInferenceMutation, CreateMlInferenceMutationVariables>;
export const DeleteMlInferenceDocument = gql`
    mutation deleteMLInference($workspaceId: String!, $inferenceId: String!) {
  deleteMLInference(workspaceId: $workspaceId, inferenceId: $inferenceId)
}
    `;
export type DeleteMlInferenceMutationFn = Apollo.MutationFunction<DeleteMlInferenceMutation, DeleteMlInferenceMutationVariables>;

/**
 * __useDeleteMlInferenceMutation__
 *
 * To run a mutation, you first call `useDeleteMlInferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMlInferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMlInferenceMutation, { data, loading, error }] = useDeleteMlInferenceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      inferenceId: // value for 'inferenceId'
 *   },
 * });
 */
export function useDeleteMlInferenceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMlInferenceMutation, DeleteMlInferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMlInferenceMutation, DeleteMlInferenceMutationVariables>(DeleteMlInferenceDocument, options);
      }
export type DeleteMlInferenceMutationHookResult = ReturnType<typeof useDeleteMlInferenceMutation>;
export type DeleteMlInferenceMutationResult = Apollo.MutationResult<DeleteMlInferenceMutation>;
export type DeleteMlInferenceMutationOptions = Apollo.BaseMutationOptions<DeleteMlInferenceMutation, DeleteMlInferenceMutationVariables>;
export const DownloadMlInferenceDocument = gql`
    mutation downloadMLInference($workspaceId: String!, $inferenceId: String!) {
  downloadMLInference(workspaceId: $workspaceId, inferenceId: $inferenceId)
}
    `;
export type DownloadMlInferenceMutationFn = Apollo.MutationFunction<DownloadMlInferenceMutation, DownloadMlInferenceMutationVariables>;

/**
 * __useDownloadMlInferenceMutation__
 *
 * To run a mutation, you first call `useDownloadMlInferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadMlInferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadMlInferenceMutation, { data, loading, error }] = useDownloadMlInferenceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      inferenceId: // value for 'inferenceId'
 *   },
 * });
 */
export function useDownloadMlInferenceMutation(baseOptions?: Apollo.MutationHookOptions<DownloadMlInferenceMutation, DownloadMlInferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadMlInferenceMutation, DownloadMlInferenceMutationVariables>(DownloadMlInferenceDocument, options);
      }
export type DownloadMlInferenceMutationHookResult = ReturnType<typeof useDownloadMlInferenceMutation>;
export type DownloadMlInferenceMutationResult = Apollo.MutationResult<DownloadMlInferenceMutation>;
export type DownloadMlInferenceMutationOptions = Apollo.BaseMutationOptions<DownloadMlInferenceMutation, DownloadMlInferenceMutationVariables>;
export const GetMlArchitecturesDocument = gql`
    query getMLArchitectures {
  getMLArchitectures {
    architectureId
    name
    description
    annotations
    hyperparameters {
      name
      field
      type
      description
      default
      min
      max
      step
      options
    }
  }
}
    `;

/**
 * __useGetMlArchitecturesQuery__
 *
 * To run a query within a React component, call `useGetMlArchitecturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMlArchitecturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMlArchitecturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMlArchitecturesQuery(baseOptions?: Apollo.QueryHookOptions<GetMlArchitecturesQuery, GetMlArchitecturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMlArchitecturesQuery, GetMlArchitecturesQueryVariables>(GetMlArchitecturesDocument, options);
      }
export function useGetMlArchitecturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMlArchitecturesQuery, GetMlArchitecturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMlArchitecturesQuery, GetMlArchitecturesQueryVariables>(GetMlArchitecturesDocument, options);
        }
export type GetMlArchitecturesQueryHookResult = ReturnType<typeof useGetMlArchitecturesQuery>;
export type GetMlArchitecturesLazyQueryHookResult = ReturnType<typeof useGetMlArchitecturesLazyQuery>;
export type GetMlArchitecturesQueryResult = Apollo.QueryResult<GetMlArchitecturesQuery, GetMlArchitecturesQueryVariables>;
export const GetMlModelDocument = gql`
    query getMLModel($workspaceId: String!, $modelId: String!) {
  getMLModels(workspaceId: $workspaceId, modelId: $modelId) {
    architecture
    architectureId
    checkpoints
    dataset
    datasetId
    description
    metrics
    modelId
    name
    parameters
    status
    tags
  }
}
    `;

/**
 * __useGetMlModelQuery__
 *
 * To run a query within a React component, call `useGetMlModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMlModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMlModelQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useGetMlModelQuery(baseOptions: Apollo.QueryHookOptions<GetMlModelQuery, GetMlModelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMlModelQuery, GetMlModelQueryVariables>(GetMlModelDocument, options);
      }
export function useGetMlModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMlModelQuery, GetMlModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMlModelQuery, GetMlModelQueryVariables>(GetMlModelDocument, options);
        }
export type GetMlModelQueryHookResult = ReturnType<typeof useGetMlModelQuery>;
export type GetMlModelLazyQueryHookResult = ReturnType<typeof useGetMlModelLazyQuery>;
export type GetMlModelQueryResult = Apollo.QueryResult<GetMlModelQuery, GetMlModelQueryVariables>;
export const GetMlModelLogDocument = gql`
    query getMLModelLog($workspaceId: String!, $modelId: String!) {
  getMLModelLog(workspaceId: $workspaceId, modelId: $modelId) {
    log
  }
}
    `;

/**
 * __useGetMlModelLogQuery__
 *
 * To run a query within a React component, call `useGetMlModelLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMlModelLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMlModelLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useGetMlModelLogQuery(baseOptions: Apollo.QueryHookOptions<GetMlModelLogQuery, GetMlModelLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMlModelLogQuery, GetMlModelLogQueryVariables>(GetMlModelLogDocument, options);
      }
export function useGetMlModelLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMlModelLogQuery, GetMlModelLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMlModelLogQuery, GetMlModelLogQueryVariables>(GetMlModelLogDocument, options);
        }
export type GetMlModelLogQueryHookResult = ReturnType<typeof useGetMlModelLogQuery>;
export type GetMlModelLogLazyQueryHookResult = ReturnType<typeof useGetMlModelLogLazyQuery>;
export type GetMlModelLogQueryResult = Apollo.QueryResult<GetMlModelLogQuery, GetMlModelLogQueryVariables>;
export const CreateMlModelDocument = gql`
    mutation createMLModel($workspaceId: String!, $datasetId: String!, $architectureId: String!, $name: String, $description: String, $parameters: String, $tags: [String]) {
  createMLModel(
    workspaceId: $workspaceId
    datasetId: $datasetId
    architectureId: $architectureId
    name: $name
    description: $description
    parameters: $parameters
    tags: $tags
  )
}
    `;
export type CreateMlModelMutationFn = Apollo.MutationFunction<CreateMlModelMutation, CreateMlModelMutationVariables>;

/**
 * __useCreateMlModelMutation__
 *
 * To run a mutation, you first call `useCreateMlModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMlModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMlModelMutation, { data, loading, error }] = useCreateMlModelMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      architectureId: // value for 'architectureId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      parameters: // value for 'parameters'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateMlModelMutation(baseOptions?: Apollo.MutationHookOptions<CreateMlModelMutation, CreateMlModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMlModelMutation, CreateMlModelMutationVariables>(CreateMlModelDocument, options);
      }
export type CreateMlModelMutationHookResult = ReturnType<typeof useCreateMlModelMutation>;
export type CreateMlModelMutationResult = Apollo.MutationResult<CreateMlModelMutation>;
export type CreateMlModelMutationOptions = Apollo.BaseMutationOptions<CreateMlModelMutation, CreateMlModelMutationVariables>;
export const DeleteMlModelDocument = gql`
    mutation deleteMLModel($workspaceId: String!, $modelId: String!) {
  deleteMLModel(workspaceId: $workspaceId, modelId: $modelId)
}
    `;
export type DeleteMlModelMutationFn = Apollo.MutationFunction<DeleteMlModelMutation, DeleteMlModelMutationVariables>;

/**
 * __useDeleteMlModelMutation__
 *
 * To run a mutation, you first call `useDeleteMlModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMlModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMlModelMutation, { data, loading, error }] = useDeleteMlModelMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useDeleteMlModelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMlModelMutation, DeleteMlModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMlModelMutation, DeleteMlModelMutationVariables>(DeleteMlModelDocument, options);
      }
export type DeleteMlModelMutationHookResult = ReturnType<typeof useDeleteMlModelMutation>;
export type DeleteMlModelMutationResult = Apollo.MutationResult<DeleteMlModelMutation>;
export type DeleteMlModelMutationOptions = Apollo.BaseMutationOptions<DeleteMlModelMutation, DeleteMlModelMutationVariables>;
export const DownloadMlModelDocument = gql`
    mutation downloadMLModel($workspaceId: String!, $modelId: String!, $checkpoint: String) {
  downloadMLModel(
    workspaceId: $workspaceId
    modelId: $modelId
    checkpoint: $checkpoint
  )
}
    `;
export type DownloadMlModelMutationFn = Apollo.MutationFunction<DownloadMlModelMutation, DownloadMlModelMutationVariables>;

/**
 * __useDownloadMlModelMutation__
 *
 * To run a mutation, you first call `useDownloadMlModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadMlModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadMlModelMutation, { data, loading, error }] = useDownloadMlModelMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *      checkpoint: // value for 'checkpoint'
 *   },
 * });
 */
export function useDownloadMlModelMutation(baseOptions?: Apollo.MutationHookOptions<DownloadMlModelMutation, DownloadMlModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadMlModelMutation, DownloadMlModelMutationVariables>(DownloadMlModelDocument, options);
      }
export type DownloadMlModelMutationHookResult = ReturnType<typeof useDownloadMlModelMutation>;
export type DownloadMlModelMutationResult = Apollo.MutationResult<DownloadMlModelMutation>;
export type DownloadMlModelMutationOptions = Apollo.BaseMutationOptions<DownloadMlModelMutation, DownloadMlModelMutationVariables>;
export const EditMlModelDocument = gql`
    mutation editMLModel($workspaceId: String!, $modelId: String!, $name: String, $description: String, $tags: [String]) {
  editMLModel(
    workspaceId: $workspaceId
    modelId: $modelId
    name: $name
    description: $description
    tags: $tags
  )
}
    `;
export type EditMlModelMutationFn = Apollo.MutationFunction<EditMlModelMutation, EditMlModelMutationVariables>;

/**
 * __useEditMlModelMutation__
 *
 * To run a mutation, you first call `useEditMlModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMlModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMlModelMutation, { data, loading, error }] = useEditMlModelMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditMlModelMutation(baseOptions?: Apollo.MutationHookOptions<EditMlModelMutation, EditMlModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMlModelMutation, EditMlModelMutationVariables>(EditMlModelDocument, options);
      }
export type EditMlModelMutationHookResult = ReturnType<typeof useEditMlModelMutation>;
export type EditMlModelMutationResult = Apollo.MutationResult<EditMlModelMutation>;
export type EditMlModelMutationOptions = Apollo.BaseMutationOptions<EditMlModelMutation, EditMlModelMutationVariables>;
export const UploadMlModelDocument = gql`
    mutation uploadMLModel($workspaceId: String!, $architectureId: String!, $name: String!, $size: Float!, $description: String, $tags: [String]) {
  uploadMLModel(
    workspaceId: $workspaceId
    architectureId: $architectureId
    name: $name
    size: $size
    description: $description
    tags: $tags
  ) {
    key
    modelId
    uploadId
    partSize
    urls
  }
}
    `;
export type UploadMlModelMutationFn = Apollo.MutationFunction<UploadMlModelMutation, UploadMlModelMutationVariables>;

/**
 * __useUploadMlModelMutation__
 *
 * To run a mutation, you first call `useUploadMlModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMlModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMlModelMutation, { data, loading, error }] = useUploadMlModelMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      architectureId: // value for 'architectureId'
 *      name: // value for 'name'
 *      size: // value for 'size'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUploadMlModelMutation(baseOptions?: Apollo.MutationHookOptions<UploadMlModelMutation, UploadMlModelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMlModelMutation, UploadMlModelMutationVariables>(UploadMlModelDocument, options);
      }
export type UploadMlModelMutationHookResult = ReturnType<typeof useUploadMlModelMutation>;
export type UploadMlModelMutationResult = Apollo.MutationResult<UploadMlModelMutation>;
export type UploadMlModelMutationOptions = Apollo.BaseMutationOptions<UploadMlModelMutation, UploadMlModelMutationVariables>;
export const UploadMlModelFinalizerDocument = gql`
    mutation uploadMLModelFinalizer($workspaceId: String!, $key: String!, $uploadId: String, $parts: [MultipartInput]) {
  uploadMLModelFinalizer(
    workspaceId: $workspaceId
    key: $key
    uploadId: $uploadId
    parts: $parts
  )
}
    `;
export type UploadMlModelFinalizerMutationFn = Apollo.MutationFunction<UploadMlModelFinalizerMutation, UploadMlModelFinalizerMutationVariables>;

/**
 * __useUploadMlModelFinalizerMutation__
 *
 * To run a mutation, you first call `useUploadMlModelFinalizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMlModelFinalizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMlModelFinalizerMutation, { data, loading, error }] = useUploadMlModelFinalizerMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      key: // value for 'key'
 *      uploadId: // value for 'uploadId'
 *      parts: // value for 'parts'
 *   },
 * });
 */
export function useUploadMlModelFinalizerMutation(baseOptions?: Apollo.MutationHookOptions<UploadMlModelFinalizerMutation, UploadMlModelFinalizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMlModelFinalizerMutation, UploadMlModelFinalizerMutationVariables>(UploadMlModelFinalizerDocument, options);
      }
export type UploadMlModelFinalizerMutationHookResult = ReturnType<typeof useUploadMlModelFinalizerMutation>;
export type UploadMlModelFinalizerMutationResult = Apollo.MutationResult<UploadMlModelFinalizerMutation>;
export type UploadMlModelFinalizerMutationOptions = Apollo.BaseMutationOptions<UploadMlModelFinalizerMutation, UploadMlModelFinalizerMutationVariables>;
export const EditOrganizationDocument = gql`
    mutation editOrganization($organizationId: String!, $name: String!) {
  editOrganization(organizationId: $organizationId, name: $name)
}
    `;
export type EditOrganizationMutationFn = Apollo.MutationFunction<EditOrganizationMutation, EditOrganizationMutationVariables>;

/**
 * __useEditOrganizationMutation__
 *
 * To run a mutation, you first call `useEditOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOrganizationMutation, { data, loading, error }] = useEditOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEditOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<EditOrganizationMutation, EditOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditOrganizationMutation, EditOrganizationMutationVariables>(EditOrganizationDocument, options);
      }
export type EditOrganizationMutationHookResult = ReturnType<typeof useEditOrganizationMutation>;
export type EditOrganizationMutationResult = Apollo.MutationResult<EditOrganizationMutation>;
export type EditOrganizationMutationOptions = Apollo.BaseMutationOptions<EditOrganizationMutation, EditOrganizationMutationVariables>;
export const DeleteOrganizationDocument = gql`
    mutation deleteOrganization($organizationId: String!) {
  deleteOrganization(organizationId: $organizationId)
}
    `;
export type DeleteOrganizationMutationFn = Apollo.MutationFunction<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;

/**
 * __useDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationMutation, { data, loading, error }] = useDeleteOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(DeleteOrganizationDocument, options);
      }
export type DeleteOrganizationMutationHookResult = ReturnType<typeof useDeleteOrganizationMutation>;
export type DeleteOrganizationMutationResult = Apollo.MutationResult<DeleteOrganizationMutation>;
export type DeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>;
export const GetOrganizationsDocument = gql`
    query getOrganizations($organizationId: String) {
  getOrganizations(organizationId: $organizationId) {
    name
    role
    organizationId
    expirationDate
    expired
    plan
  }
}
    `;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const GetOrganizationSettingsDocument = gql`
    query getOrganizationSettings($organizationId: String!, $setting: String) {
  getOrganizationSettings(organizationId: $organizationId, setting: $setting) {
    organizationId
    setting
    limit
    usage
    units
  }
}
    `;

/**
 * __useGetOrganizationSettingsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationSettingsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      setting: // value for 'setting'
 *   },
 * });
 */
export function useGetOrganizationSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>(GetOrganizationSettingsDocument, options);
      }
export function useGetOrganizationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>(GetOrganizationSettingsDocument, options);
        }
export type GetOrganizationSettingsQueryHookResult = ReturnType<typeof useGetOrganizationSettingsQuery>;
export type GetOrganizationSettingsLazyQueryHookResult = ReturnType<typeof useGetOrganizationSettingsLazyQuery>;
export type GetOrganizationSettingsQueryResult = Apollo.QueryResult<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>;
export const GetDatasetThumbnailsDocument = gql`
    query getDatasetThumbnails($workspaceId: String!, $datasetId: String!) {
  getDatasetThumbnails(workspaceId: $workspaceId, datasetId: $datasetId)
}
    `;

/**
 * __useGetDatasetThumbnailsQuery__
 *
 * To run a query within a React component, call `useGetDatasetThumbnailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetThumbnailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetThumbnailsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetThumbnailsQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetThumbnailsQuery, GetDatasetThumbnailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetThumbnailsQuery, GetDatasetThumbnailsQueryVariables>(GetDatasetThumbnailsDocument, options);
      }
export function useGetDatasetThumbnailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetThumbnailsQuery, GetDatasetThumbnailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetThumbnailsQuery, GetDatasetThumbnailsQueryVariables>(GetDatasetThumbnailsDocument, options);
        }
export type GetDatasetThumbnailsQueryHookResult = ReturnType<typeof useGetDatasetThumbnailsQuery>;
export type GetDatasetThumbnailsLazyQueryHookResult = ReturnType<typeof useGetDatasetThumbnailsLazyQuery>;
export type GetDatasetThumbnailsQueryResult = Apollo.QueryResult<GetDatasetThumbnailsQuery, GetDatasetThumbnailsQueryVariables>;
export const PingPreviewDocument = gql`
    mutation pingPreview($channelId: String!) {
  pingPreview(channelId: $channelId)
}
    `;
export type PingPreviewMutationFn = Apollo.MutationFunction<PingPreviewMutation, PingPreviewMutationVariables>;

/**
 * __usePingPreviewMutation__
 *
 * To run a mutation, you first call `usePingPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePingPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pingPreviewMutation, { data, loading, error }] = usePingPreviewMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function usePingPreviewMutation(baseOptions?: Apollo.MutationHookOptions<PingPreviewMutation, PingPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PingPreviewMutation, PingPreviewMutationVariables>(PingPreviewDocument, options);
      }
export type PingPreviewMutationHookResult = ReturnType<typeof usePingPreviewMutation>;
export type PingPreviewMutationResult = Apollo.MutationResult<PingPreviewMutation>;
export type PingPreviewMutationOptions = Apollo.BaseMutationOptions<PingPreviewMutation, PingPreviewMutationVariables>;
export const CreateLinkedAppDocument = gql`
    mutation createLinkedApp($appId: String!, $token: String!) {
  createLinkedApp(appId: $appId, token: $token)
}
    `;
export type CreateLinkedAppMutationFn = Apollo.MutationFunction<CreateLinkedAppMutation, CreateLinkedAppMutationVariables>;

/**
 * __useCreateLinkedAppMutation__
 *
 * To run a mutation, you first call `useCreateLinkedAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLinkedAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLinkedAppMutation, { data, loading, error }] = useCreateLinkedAppMutation({
 *   variables: {
 *      appId: // value for 'appId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCreateLinkedAppMutation(baseOptions?: Apollo.MutationHookOptions<CreateLinkedAppMutation, CreateLinkedAppMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLinkedAppMutation, CreateLinkedAppMutationVariables>(CreateLinkedAppDocument, options);
      }
export type CreateLinkedAppMutationHookResult = ReturnType<typeof useCreateLinkedAppMutation>;
export type CreateLinkedAppMutationResult = Apollo.MutationResult<CreateLinkedAppMutation>;
export type CreateLinkedAppMutationOptions = Apollo.BaseMutationOptions<CreateLinkedAppMutation, CreateLinkedAppMutationVariables>;
export const DeleteLinkedAppDocument = gql`
    mutation deleteLinkedApp($appId: String!) {
  deleteLinkedApp(appId: $appId)
}
    `;
export type DeleteLinkedAppMutationFn = Apollo.MutationFunction<DeleteLinkedAppMutation, DeleteLinkedAppMutationVariables>;

/**
 * __useDeleteLinkedAppMutation__
 *
 * To run a mutation, you first call `useDeleteLinkedAppMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLinkedAppMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLinkedAppMutation, { data, loading, error }] = useDeleteLinkedAppMutation({
 *   variables: {
 *      appId: // value for 'appId'
 *   },
 * });
 */
export function useDeleteLinkedAppMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLinkedAppMutation, DeleteLinkedAppMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLinkedAppMutation, DeleteLinkedAppMutationVariables>(DeleteLinkedAppDocument, options);
      }
export type DeleteLinkedAppMutationHookResult = ReturnType<typeof useDeleteLinkedAppMutation>;
export type DeleteLinkedAppMutationResult = Apollo.MutationResult<DeleteLinkedAppMutation>;
export type DeleteLinkedAppMutationOptions = Apollo.BaseMutationOptions<DeleteLinkedAppMutation, DeleteLinkedAppMutationVariables>;
export const GetLinkedAppsDocument = gql`
    query getLinkedApps {
  getLinkedApps {
    appId
    name
    linked
    thumbnail
    description
    clientId
    clientSecret
  }
}
    `;

/**
 * __useGetLinkedAppsQuery__
 *
 * To run a query within a React component, call `useGetLinkedAppsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedAppsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkedAppsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLinkedAppsQuery(baseOptions?: Apollo.QueryHookOptions<GetLinkedAppsQuery, GetLinkedAppsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinkedAppsQuery, GetLinkedAppsQueryVariables>(GetLinkedAppsDocument, options);
      }
export function useGetLinkedAppsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinkedAppsQuery, GetLinkedAppsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinkedAppsQuery, GetLinkedAppsQueryVariables>(GetLinkedAppsDocument, options);
        }
export type GetLinkedAppsQueryHookResult = ReturnType<typeof useGetLinkedAppsQuery>;
export type GetLinkedAppsLazyQueryHookResult = ReturnType<typeof useGetLinkedAppsLazyQuery>;
export type GetLinkedAppsQueryResult = Apollo.QueryResult<GetLinkedAppsQuery, GetLinkedAppsQueryVariables>;
export const ValidateContentCodeDocument = gql`
    query validateContentCode($code: String!) {
  validateContentCode(code: $code)
}
    `;

/**
 * __useValidateContentCodeQuery__
 *
 * To run a query within a React component, call `useValidateContentCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateContentCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateContentCodeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useValidateContentCodeQuery(baseOptions: Apollo.QueryHookOptions<ValidateContentCodeQuery, ValidateContentCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateContentCodeQuery, ValidateContentCodeQueryVariables>(ValidateContentCodeDocument, options);
      }
export function useValidateContentCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateContentCodeQuery, ValidateContentCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateContentCodeQuery, ValidateContentCodeQueryVariables>(ValidateContentCodeDocument, options);
        }
export type ValidateContentCodeQueryHookResult = ReturnType<typeof useValidateContentCodeQuery>;
export type ValidateContentCodeLazyQueryHookResult = ReturnType<typeof useValidateContentCodeLazyQuery>;
export type ValidateContentCodeQueryResult = Apollo.QueryResult<ValidateContentCodeQuery, ValidateContentCodeQueryVariables>;
export const CreateUmapDocument = gql`
    mutation createUMAP($datasetIds: [String]!, $name: String, $samples: [Int]!, $seed: String, $tags: [String], $workspaceId: String!) {
  createUMAP(
    datasetIds: $datasetIds
    name: $name
    samples: $samples
    seed: $seed
    tags: $tags
    workspaceId: $workspaceId
  )
}
    `;
export type CreateUmapMutationFn = Apollo.MutationFunction<CreateUmapMutation, CreateUmapMutationVariables>;

/**
 * __useCreateUmapMutation__
 *
 * To run a mutation, you first call `useCreateUmapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUmapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUmapMutation, { data, loading, error }] = useCreateUmapMutation({
 *   variables: {
 *      datasetIds: // value for 'datasetIds'
 *      name: // value for 'name'
 *      samples: // value for 'samples'
 *      seed: // value for 'seed'
 *      tags: // value for 'tags'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useCreateUmapMutation(baseOptions?: Apollo.MutationHookOptions<CreateUmapMutation, CreateUmapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUmapMutation, CreateUmapMutationVariables>(CreateUmapDocument, options);
      }
export type CreateUmapMutationHookResult = ReturnType<typeof useCreateUmapMutation>;
export type CreateUmapMutationResult = Apollo.MutationResult<CreateUmapMutation>;
export type CreateUmapMutationOptions = Apollo.BaseMutationOptions<CreateUmapMutation, CreateUmapMutationVariables>;
export const DeleteUmapDocument = gql`
    mutation deleteUMAP($workspaceId: String!, $umapId: String!) {
  deleteUMAP(workspaceId: $workspaceId, umapId: $umapId)
}
    `;
export type DeleteUmapMutationFn = Apollo.MutationFunction<DeleteUmapMutation, DeleteUmapMutationVariables>;

/**
 * __useDeleteUmapMutation__
 *
 * To run a mutation, you first call `useDeleteUmapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUmapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUmapMutation, { data, loading, error }] = useDeleteUmapMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      umapId: // value for 'umapId'
 *   },
 * });
 */
export function useDeleteUmapMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUmapMutation, DeleteUmapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUmapMutation, DeleteUmapMutationVariables>(DeleteUmapDocument, options);
      }
export type DeleteUmapMutationHookResult = ReturnType<typeof useDeleteUmapMutation>;
export type DeleteUmapMutationResult = Apollo.MutationResult<DeleteUmapMutation>;
export type DeleteUmapMutationOptions = Apollo.BaseMutationOptions<DeleteUmapMutation, DeleteUmapMutationVariables>;
export const EditUmapDocument = gql`
    mutation editUMAP($workspaceId: String!, $umapId: String!, $name: String!, $tags: [String]) {
  editUMAP(workspaceId: $workspaceId, umapId: $umapId, name: $name, tags: $tags)
}
    `;
export type EditUmapMutationFn = Apollo.MutationFunction<EditUmapMutation, EditUmapMutationVariables>;

/**
 * __useEditUmapMutation__
 *
 * To run a mutation, you first call `useEditUmapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditUmapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editUmapMutation, { data, loading, error }] = useEditUmapMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      umapId: // value for 'umapId'
 *      name: // value for 'name'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditUmapMutation(baseOptions?: Apollo.MutationHookOptions<EditUmapMutation, EditUmapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditUmapMutation, EditUmapMutationVariables>(EditUmapDocument, options);
      }
export type EditUmapMutationHookResult = ReturnType<typeof useEditUmapMutation>;
export type EditUmapMutationResult = Apollo.MutationResult<EditUmapMutation>;
export type EditUmapMutationOptions = Apollo.BaseMutationOptions<EditUmapMutation, EditUmapMutationVariables>;
export const GetUmapLogDocument = gql`
    query getUMAPLog($workspaceId: String!, $umapId: String!) {
  getUMAPLog(workspaceId: $workspaceId, umapId: $umapId) {
    umapId
    workspaceId
    state
    log
  }
}
    `;

/**
 * __useGetUmapLogQuery__
 *
 * To run a query within a React component, call `useGetUmapLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUmapLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUmapLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      umapId: // value for 'umapId'
 *   },
 * });
 */
export function useGetUmapLogQuery(baseOptions: Apollo.QueryHookOptions<GetUmapLogQuery, GetUmapLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUmapLogQuery, GetUmapLogQueryVariables>(GetUmapLogDocument, options);
      }
export function useGetUmapLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUmapLogQuery, GetUmapLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUmapLogQuery, GetUmapLogQueryVariables>(GetUmapLogDocument, options);
        }
export type GetUmapLogQueryHookResult = ReturnType<typeof useGetUmapLogQuery>;
export type GetUmapLogLazyQueryHookResult = ReturnType<typeof useGetUmapLogLazyQuery>;
export type GetUmapLogQueryResult = Apollo.QueryResult<GetUmapLogQuery, GetUmapLogQueryVariables>;
export const GetUmapDocument = gql`
    query getUMAP($workspaceId: String!, $umapId: String) {
  getUMAPs(workspaceId: $workspaceId, umapId: $umapId) {
    datasets {
      datasetId
      dataset
    }
    name
    results
    samples
    seed
    status
    tags
    umapId
    workspaceId
  }
}
    `;

/**
 * __useGetUmapQuery__
 *
 * To run a query within a React component, call `useGetUmapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUmapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUmapQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      umapId: // value for 'umapId'
 *   },
 * });
 */
export function useGetUmapQuery(baseOptions: Apollo.QueryHookOptions<GetUmapQuery, GetUmapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUmapQuery, GetUmapQueryVariables>(GetUmapDocument, options);
      }
export function useGetUmapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUmapQuery, GetUmapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUmapQuery, GetUmapQueryVariables>(GetUmapDocument, options);
        }
export type GetUmapQueryHookResult = ReturnType<typeof useGetUmapQuery>;
export type GetUmapLazyQueryHookResult = ReturnType<typeof useGetUmapLazyQuery>;
export type GetUmapQueryResult = Apollo.QueryResult<GetUmapQuery, GetUmapQueryVariables>;
export const RemoveMapOrganizationDocument = gql`
    mutation removeMapOrganization($organizationId: String!, $mapId: String!) {
  removeMapOrganization(organizationId: $organizationId, mapId: $mapId)
}
    `;
export type RemoveMapOrganizationMutationFn = Apollo.MutationFunction<RemoveMapOrganizationMutation, RemoveMapOrganizationMutationVariables>;

/**
 * __useRemoveMapOrganizationMutation__
 *
 * To run a mutation, you first call `useRemoveMapOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMapOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMapOrganizationMutation, { data, loading, error }] = useRemoveMapOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      mapId: // value for 'mapId'
 *   },
 * });
 */
export function useRemoveMapOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMapOrganizationMutation, RemoveMapOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMapOrganizationMutation, RemoveMapOrganizationMutationVariables>(RemoveMapOrganizationDocument, options);
      }
export type RemoveMapOrganizationMutationHookResult = ReturnType<typeof useRemoveMapOrganizationMutation>;
export type RemoveMapOrganizationMutationResult = Apollo.MutationResult<RemoveMapOrganizationMutation>;
export type RemoveMapOrganizationMutationOptions = Apollo.BaseMutationOptions<RemoveMapOrganizationMutation, RemoveMapOrganizationMutationVariables>;
export const GetCurrentUserDocument = gql`
    query getCurrentUser {
  getCurrentUser {
    userId
    email
    name
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const DeleteUserDocument = gql`
    mutation deleteUser($isDeleting: Boolean) {
  deleteUser(isDeleting: $isDeleting) {
    organizationId
    name
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      isDeleting: // value for 'isDeleting'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const GetVolumesDocument = gql`
    query getVolumes($organizationId: String, $volumeId: String, $workspaceId: String, $cursor: String, $limit: Int, $filters: VolumeFilter) {
  getVolumes(
    organizationId: $organizationId
    volumeId: $volumeId
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    name
    size
    volumeId
    updatedAt
    createdAt
    permission
    description
    organization
    organizationId
    tags
  }
}
    `;

/**
 * __useGetVolumesQuery__
 *
 * To run a query within a React component, call `useGetVolumesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolumesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolumesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      volumeId: // value for 'volumeId'
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetVolumesQuery(baseOptions?: Apollo.QueryHookOptions<GetVolumesQuery, GetVolumesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVolumesQuery, GetVolumesQueryVariables>(GetVolumesDocument, options);
      }
export function useGetVolumesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVolumesQuery, GetVolumesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVolumesQuery, GetVolumesQueryVariables>(GetVolumesDocument, options);
        }
export type GetVolumesQueryHookResult = ReturnType<typeof useGetVolumesQuery>;
export type GetVolumesLazyQueryHookResult = ReturnType<typeof useGetVolumesLazyQuery>;
export type GetVolumesQueryResult = Apollo.QueryResult<GetVolumesQuery, GetVolumesQueryVariables>;
export const CreateManagedVolumeDocument = gql`
    mutation createManagedVolume($organizationId: String!, $name: String!, $description: String, $tags: [String]) {
  createManagedVolume(
    organizationId: $organizationId
    name: $name
    description: $description
    tags: $tags
  )
}
    `;
export type CreateManagedVolumeMutationFn = Apollo.MutationFunction<CreateManagedVolumeMutation, CreateManagedVolumeMutationVariables>;

/**
 * __useCreateManagedVolumeMutation__
 *
 * To run a mutation, you first call `useCreateManagedVolumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManagedVolumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManagedVolumeMutation, { data, loading, error }] = useCreateManagedVolumeMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateManagedVolumeMutation(baseOptions?: Apollo.MutationHookOptions<CreateManagedVolumeMutation, CreateManagedVolumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManagedVolumeMutation, CreateManagedVolumeMutationVariables>(CreateManagedVolumeDocument, options);
      }
export type CreateManagedVolumeMutationHookResult = ReturnType<typeof useCreateManagedVolumeMutation>;
export type CreateManagedVolumeMutationResult = Apollo.MutationResult<CreateManagedVolumeMutation>;
export type CreateManagedVolumeMutationOptions = Apollo.BaseMutationOptions<CreateManagedVolumeMutation, CreateManagedVolumeMutationVariables>;
export const DeleteManagedVolumeDocument = gql`
    mutation deleteManagedVolume($volumeId: String!) {
  deleteManagedVolume(volumeId: $volumeId)
}
    `;
export type DeleteManagedVolumeMutationFn = Apollo.MutationFunction<DeleteManagedVolumeMutation, DeleteManagedVolumeMutationVariables>;

/**
 * __useDeleteManagedVolumeMutation__
 *
 * To run a mutation, you first call `useDeleteManagedVolumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManagedVolumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManagedVolumeMutation, { data, loading, error }] = useDeleteManagedVolumeMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *   },
 * });
 */
export function useDeleteManagedVolumeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteManagedVolumeMutation, DeleteManagedVolumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteManagedVolumeMutation, DeleteManagedVolumeMutationVariables>(DeleteManagedVolumeDocument, options);
      }
export type DeleteManagedVolumeMutationHookResult = ReturnType<typeof useDeleteManagedVolumeMutation>;
export type DeleteManagedVolumeMutationResult = Apollo.MutationResult<DeleteManagedVolumeMutation>;
export type DeleteManagedVolumeMutationOptions = Apollo.BaseMutationOptions<DeleteManagedVolumeMutation, DeleteManagedVolumeMutationVariables>;
export const GetVolumeDataDocument = gql`
    query getVolumeData($volumeId: String!, $keys: [String], $dir: String, $cursor: String, $limit: Int) {
  getVolumeData(
    volumeId: $volumeId
    keys: $keys
    dir: $dir
    cursor: $cursor
    limit: $limit
  ) {
    keys {
      url
      updatedAt
      thumbnailUrl
      previewUrl
      size
      key
      hash
      fields {
        algorithm
        bucket
        credential
        date
        key
        policy
        signature
        token
      }
    }
    pageInfo {
      totalItems
      offset
      limit
    }
  }
}
    `;

/**
 * __useGetVolumeDataQuery__
 *
 * To run a query within a React component, call `useGetVolumeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolumeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolumeDataQuery({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      keys: // value for 'keys'
 *      dir: // value for 'dir'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetVolumeDataQuery(baseOptions: Apollo.QueryHookOptions<GetVolumeDataQuery, GetVolumeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVolumeDataQuery, GetVolumeDataQueryVariables>(GetVolumeDataDocument, options);
      }
export function useGetVolumeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVolumeDataQuery, GetVolumeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVolumeDataQuery, GetVolumeDataQueryVariables>(GetVolumeDataDocument, options);
        }
export type GetVolumeDataQueryHookResult = ReturnType<typeof useGetVolumeDataQuery>;
export type GetVolumeDataLazyQueryHookResult = ReturnType<typeof useGetVolumeDataLazyQuery>;
export type GetVolumeDataQueryResult = Apollo.QueryResult<GetVolumeDataQuery, GetVolumeDataQueryVariables>;
export const DeleteVolumeDataDocument = gql`
    mutation deleteVolumeData($volumeId: String!, $keys: [String]) {
  deleteVolumeData(volumeId: $volumeId, keys: $keys)
}
    `;
export type DeleteVolumeDataMutationFn = Apollo.MutationFunction<DeleteVolumeDataMutation, DeleteVolumeDataMutationVariables>;

/**
 * __useDeleteVolumeDataMutation__
 *
 * To run a mutation, you first call `useDeleteVolumeDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVolumeDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVolumeDataMutation, { data, loading, error }] = useDeleteVolumeDataMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function useDeleteVolumeDataMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVolumeDataMutation, DeleteVolumeDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVolumeDataMutation, DeleteVolumeDataMutationVariables>(DeleteVolumeDataDocument, options);
      }
export type DeleteVolumeDataMutationHookResult = ReturnType<typeof useDeleteVolumeDataMutation>;
export type DeleteVolumeDataMutationResult = Apollo.MutationResult<DeleteVolumeDataMutation>;
export type DeleteVolumeDataMutationOptions = Apollo.BaseMutationOptions<DeleteVolumeDataMutation, DeleteVolumeDataMutationVariables>;
export const PutVolumeDataDocument = gql`
    mutation putVolumeData($volumeId: String!, $keys: [String]!) {
  putVolumeData(volumeId: $volumeId, keys: $keys) {
    fields {
      algorithm
      bucket
      credential
      date
      key
      policy
      signature
      token
    }
    hash
    key
    updatedAt
    url
  }
}
    `;
export type PutVolumeDataMutationFn = Apollo.MutationFunction<PutVolumeDataMutation, PutVolumeDataMutationVariables>;

/**
 * __usePutVolumeDataMutation__
 *
 * To run a mutation, you first call `usePutVolumeDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePutVolumeDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [putVolumeDataMutation, { data, loading, error }] = usePutVolumeDataMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function usePutVolumeDataMutation(baseOptions?: Apollo.MutationHookOptions<PutVolumeDataMutation, PutVolumeDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PutVolumeDataMutation, PutVolumeDataMutationVariables>(PutVolumeDataDocument, options);
      }
export type PutVolumeDataMutationHookResult = ReturnType<typeof usePutVolumeDataMutation>;
export type PutVolumeDataMutationResult = Apollo.MutationResult<PutVolumeDataMutation>;
export type PutVolumeDataMutationOptions = Apollo.BaseMutationOptions<PutVolumeDataMutation, PutVolumeDataMutationVariables>;
export const PutVolumeDataThumbnailDocument = gql`
    mutation putVolumeDataThumbnail($volumeId: String!, $key: String!) {
  putVolumeDataThumbnail(volumeId: $volumeId, key: $key) {
    key
    url
  }
}
    `;
export type PutVolumeDataThumbnailMutationFn = Apollo.MutationFunction<PutVolumeDataThumbnailMutation, PutVolumeDataThumbnailMutationVariables>;

/**
 * __usePutVolumeDataThumbnailMutation__
 *
 * To run a mutation, you first call `usePutVolumeDataThumbnailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePutVolumeDataThumbnailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [putVolumeDataThumbnailMutation, { data, loading, error }] = usePutVolumeDataThumbnailMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      key: // value for 'key'
 *   },
 * });
 */
export function usePutVolumeDataThumbnailMutation(baseOptions?: Apollo.MutationHookOptions<PutVolumeDataThumbnailMutation, PutVolumeDataThumbnailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PutVolumeDataThumbnailMutation, PutVolumeDataThumbnailMutationVariables>(PutVolumeDataThumbnailDocument, options);
      }
export type PutVolumeDataThumbnailMutationHookResult = ReturnType<typeof usePutVolumeDataThumbnailMutation>;
export type PutVolumeDataThumbnailMutationResult = Apollo.MutationResult<PutVolumeDataThumbnailMutation>;
export type PutVolumeDataThumbnailMutationOptions = Apollo.BaseMutationOptions<PutVolumeDataThumbnailMutation, PutVolumeDataThumbnailMutationVariables>;
export const EditVolumeDataDocument = gql`
    mutation editVolumeData($volumeId: String!, $source: String!, $key: String!) {
  editVolumeData(volumeId: $volumeId, source: $source, key: $key)
}
    `;
export type EditVolumeDataMutationFn = Apollo.MutationFunction<EditVolumeDataMutation, EditVolumeDataMutationVariables>;

/**
 * __useEditVolumeDataMutation__
 *
 * To run a mutation, you first call `useEditVolumeDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVolumeDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVolumeDataMutation, { data, loading, error }] = useEditVolumeDataMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      source: // value for 'source'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useEditVolumeDataMutation(baseOptions?: Apollo.MutationHookOptions<EditVolumeDataMutation, EditVolumeDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditVolumeDataMutation, EditVolumeDataMutationVariables>(EditVolumeDataDocument, options);
      }
export type EditVolumeDataMutationHookResult = ReturnType<typeof useEditVolumeDataMutation>;
export type EditVolumeDataMutationResult = Apollo.MutationResult<EditVolumeDataMutation>;
export type EditVolumeDataMutationOptions = Apollo.BaseMutationOptions<EditVolumeDataMutation, EditVolumeDataMutationVariables>;
export const RemoveVolumeOrganizationDocument = gql`
    mutation removeVolumeOrganization($organizationId: String!, $volumeId: String!) {
  removeVolumeOrganization(organizationId: $organizationId, volumeId: $volumeId)
}
    `;
export type RemoveVolumeOrganizationMutationFn = Apollo.MutationFunction<RemoveVolumeOrganizationMutation, RemoveVolumeOrganizationMutationVariables>;

/**
 * __useRemoveVolumeOrganizationMutation__
 *
 * To run a mutation, you first call `useRemoveVolumeOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveVolumeOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeVolumeOrganizationMutation, { data, loading, error }] = useRemoveVolumeOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      volumeId: // value for 'volumeId'
 *   },
 * });
 */
export function useRemoveVolumeOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveVolumeOrganizationMutation, RemoveVolumeOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveVolumeOrganizationMutation, RemoveVolumeOrganizationMutationVariables>(RemoveVolumeOrganizationDocument, options);
      }
export type RemoveVolumeOrganizationMutationHookResult = ReturnType<typeof useRemoveVolumeOrganizationMutation>;
export type RemoveVolumeOrganizationMutationResult = Apollo.MutationResult<RemoveVolumeOrganizationMutation>;
export type RemoveVolumeOrganizationMutationOptions = Apollo.BaseMutationOptions<RemoveVolumeOrganizationMutation, RemoveVolumeOrganizationMutationVariables>;
export const EditManagedVolumeDocument = gql`
    mutation editManagedVolume($volumeId: String!, $name: String, $description: String, $permission: String, $tags: [String]) {
  editManagedVolume(
    volumeId: $volumeId
    name: $name
    description: $description
    permission: $permission
    tags: $tags
  )
}
    `;
export type EditManagedVolumeMutationFn = Apollo.MutationFunction<EditManagedVolumeMutation, EditManagedVolumeMutationVariables>;

/**
 * __useEditManagedVolumeMutation__
 *
 * To run a mutation, you first call `useEditManagedVolumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditManagedVolumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editManagedVolumeMutation, { data, loading, error }] = useEditManagedVolumeMutation({
 *   variables: {
 *      volumeId: // value for 'volumeId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      permission: // value for 'permission'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditManagedVolumeMutation(baseOptions?: Apollo.MutationHookOptions<EditManagedVolumeMutation, EditManagedVolumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditManagedVolumeMutation, EditManagedVolumeMutationVariables>(EditManagedVolumeDocument, options);
      }
export type EditManagedVolumeMutationHookResult = ReturnType<typeof useEditManagedVolumeMutation>;
export type EditManagedVolumeMutationResult = Apollo.MutationResult<EditManagedVolumeMutation>;
export type EditManagedVolumeMutationOptions = Apollo.BaseMutationOptions<EditManagedVolumeMutation, EditManagedVolumeMutationVariables>;
export const EditWorkspaceDocument = gql`
    mutation editWorkspace($workspaceId: String!, $name: String, $description: String, $channelIds: [String], $volumeIds: [String], $ganIds: [String], $mapIds: [String], $tags: [String]) {
  editWorkspace(
    workspaceId: $workspaceId
    name: $name
    description: $description
    channelIds: $channelIds
    volumeIds: $volumeIds
    ganIds: $ganIds
    mapIds: $mapIds
    tags: $tags
  )
}
    `;
export type EditWorkspaceMutationFn = Apollo.MutationFunction<EditWorkspaceMutation, EditWorkspaceMutationVariables>;

/**
 * __useEditWorkspaceMutation__
 *
 * To run a mutation, you first call `useEditWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editWorkspaceMutation, { data, loading, error }] = useEditWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      channelIds: // value for 'channelIds'
 *      volumeIds: // value for 'volumeIds'
 *      ganIds: // value for 'ganIds'
 *      mapIds: // value for 'mapIds'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<EditWorkspaceMutation, EditWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditWorkspaceMutation, EditWorkspaceMutationVariables>(EditWorkspaceDocument, options);
      }
export type EditWorkspaceMutationHookResult = ReturnType<typeof useEditWorkspaceMutation>;
export type EditWorkspaceMutationResult = Apollo.MutationResult<EditWorkspaceMutation>;
export type EditWorkspaceMutationOptions = Apollo.BaseMutationOptions<EditWorkspaceMutation, EditWorkspaceMutationVariables>;
export const EditWorkspaceThumbnailDocument = gql`
    mutation editWorkspaceThumbnail($workspaceId: String!, $thumbnail: String!) {
  editWorkspaceThumbnail(workspaceId: $workspaceId, thumbnail: $thumbnail)
}
    `;
export type EditWorkspaceThumbnailMutationFn = Apollo.MutationFunction<EditWorkspaceThumbnailMutation, EditWorkspaceThumbnailMutationVariables>;

/**
 * __useEditWorkspaceThumbnailMutation__
 *
 * To run a mutation, you first call `useEditWorkspaceThumbnailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditWorkspaceThumbnailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editWorkspaceThumbnailMutation, { data, loading, error }] = useEditWorkspaceThumbnailMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      thumbnail: // value for 'thumbnail'
 *   },
 * });
 */
export function useEditWorkspaceThumbnailMutation(baseOptions?: Apollo.MutationHookOptions<EditWorkspaceThumbnailMutation, EditWorkspaceThumbnailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditWorkspaceThumbnailMutation, EditWorkspaceThumbnailMutationVariables>(EditWorkspaceThumbnailDocument, options);
      }
export type EditWorkspaceThumbnailMutationHookResult = ReturnType<typeof useEditWorkspaceThumbnailMutation>;
export type EditWorkspaceThumbnailMutationResult = Apollo.MutationResult<EditWorkspaceThumbnailMutation>;
export type EditWorkspaceThumbnailMutationOptions = Apollo.BaseMutationOptions<EditWorkspaceThumbnailMutation, EditWorkspaceThumbnailMutationVariables>;
export const CreateWorkspaceDocument = gql`
    mutation createWorkspace($organizationId: String!, $name: String!, $description: String, $channelIds: [String]!, $code: String, $volumeIds: [String]!, $tags: [String]) {
  createWorkspace(
    organizationId: $organizationId
    name: $name
    description: $description
    channelIds: $channelIds
    code: $code
    volumeIds: $volumeIds
    tags: $tags
  )
}
    `;
export type CreateWorkspaceMutationFn = Apollo.MutationFunction<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>;

/**
 * __useCreateWorkspaceMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceMutation, { data, loading, error }] = useCreateWorkspaceMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      channelIds: // value for 'channelIds'
 *      code: // value for 'code'
 *      volumeIds: // value for 'volumeIds'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>(CreateWorkspaceDocument, options);
      }
export type CreateWorkspaceMutationHookResult = ReturnType<typeof useCreateWorkspaceMutation>;
export type CreateWorkspaceMutationResult = Apollo.MutationResult<CreateWorkspaceMutation>;
export type CreateWorkspaceMutationOptions = Apollo.BaseMutationOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>;
export const DeleteWorkspaceDocument = gql`
    mutation deleteWorkspace($workspaceId: String!) {
  deleteWorkspace(workspaceId: $workspaceId)
}
    `;
export type DeleteWorkspaceMutationFn = Apollo.MutationFunction<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>;

/**
 * __useDeleteWorkspaceMutation__
 *
 * To run a mutation, you first call `useDeleteWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkspaceMutation, { data, loading, error }] = useDeleteWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>(DeleteWorkspaceDocument, options);
      }
export type DeleteWorkspaceMutationHookResult = ReturnType<typeof useDeleteWorkspaceMutation>;
export type DeleteWorkspaceMutationResult = Apollo.MutationResult<DeleteWorkspaceMutation>;
export type DeleteWorkspaceMutationOptions = Apollo.BaseMutationOptions<DeleteWorkspaceMutation, DeleteWorkspaceMutationVariables>;
export const GetWorkspacesDocument = gql`
    query getWorkspaces($organizationId: String, $workspaceId: String, $limit: Int, $cursor: String, $filters: WorkspaceFilter) {
  getWorkspaces(
    organizationId: $organizationId
    workspaceId: $workspaceId
    limit: $limit
    cursor: $cursor
    filters: $filters
  ) {
    workspaceId
    organizationId
    organization
    name
    createdAt
    updatedAt
    previewThumbnail
    status
    description
    tags
  }
}
    `;

/**
 * __useGetWorkspacesQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspacesQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspacesQuery, GetWorkspacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspacesQuery, GetWorkspacesQueryVariables>(GetWorkspacesDocument, options);
      }
export function useGetWorkspacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspacesQuery, GetWorkspacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspacesQuery, GetWorkspacesQueryVariables>(GetWorkspacesDocument, options);
        }
export type GetWorkspacesQueryHookResult = ReturnType<typeof useGetWorkspacesQuery>;
export type GetWorkspacesLazyQueryHookResult = ReturnType<typeof useGetWorkspacesLazyQuery>;
export type GetWorkspacesQueryResult = Apollo.QueryResult<GetWorkspacesQuery, GetWorkspacesQueryVariables>;
export const GetWorkspaceSettingsDocument = gql`
    query getWorkspaceSettings($workspaceId: String!, $setting: String) {
  getWorkspaceSettings(workspaceId: $workspaceId, setting: $setting) {
    workspaceId
    setting
    limit
    usage
    units
  }
}
    `;

/**
 * __useGetWorkspaceSettingsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSettingsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      setting: // value for 'setting'
 *   },
 * });
 */
export function useGetWorkspaceSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>(GetWorkspaceSettingsDocument, options);
      }
export function useGetWorkspaceSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>(GetWorkspaceSettingsDocument, options);
        }
export type GetWorkspaceSettingsQueryHookResult = ReturnType<typeof useGetWorkspaceSettingsQuery>;
export type GetWorkspaceSettingsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceSettingsLazyQuery>;
export type GetWorkspaceSettingsQueryResult = Apollo.QueryResult<GetWorkspaceSettingsQuery, GetWorkspaceSettingsQueryVariables>;
export const GetRemoteDevelopmentSessionsDocument = gql`
    query getRemoteDevelopmentSessions($organizationId: String) {
  listRemoteDevelopment(organizationId: $organizationId) {
    channel
    channelId
    editorSessionId
    editorUrl
    sshPort
    status {
      state
    }
  }
}
    `;

/**
 * __useGetRemoteDevelopmentSessionsQuery__
 *
 * To run a query within a React component, call `useGetRemoteDevelopmentSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemoteDevelopmentSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemoteDevelopmentSessionsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetRemoteDevelopmentSessionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRemoteDevelopmentSessionsQuery, GetRemoteDevelopmentSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRemoteDevelopmentSessionsQuery, GetRemoteDevelopmentSessionsQueryVariables>(GetRemoteDevelopmentSessionsDocument, options);
      }
export function useGetRemoteDevelopmentSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRemoteDevelopmentSessionsQuery, GetRemoteDevelopmentSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRemoteDevelopmentSessionsQuery, GetRemoteDevelopmentSessionsQueryVariables>(GetRemoteDevelopmentSessionsDocument, options);
        }
export type GetRemoteDevelopmentSessionsQueryHookResult = ReturnType<typeof useGetRemoteDevelopmentSessionsQuery>;
export type GetRemoteDevelopmentSessionsLazyQueryHookResult = ReturnType<typeof useGetRemoteDevelopmentSessionsLazyQuery>;
export type GetRemoteDevelopmentSessionsQueryResult = Apollo.QueryResult<GetRemoteDevelopmentSessionsQuery, GetRemoteDevelopmentSessionsQueryVariables>;
export const CreateRemoteDevelopmentDocument = gql`
    mutation CreateRemoteDevelopment($channelId: String!) {
  createRemoteDevelopment(channelId: $channelId) {
    editorSessionId
    editorUrl
  }
}
    `;
export type CreateRemoteDevelopmentMutationFn = Apollo.MutationFunction<CreateRemoteDevelopmentMutation, CreateRemoteDevelopmentMutationVariables>;

/**
 * __useCreateRemoteDevelopmentMutation__
 *
 * To run a mutation, you first call `useCreateRemoteDevelopmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRemoteDevelopmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRemoteDevelopmentMutation, { data, loading, error }] = useCreateRemoteDevelopmentMutation({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useCreateRemoteDevelopmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateRemoteDevelopmentMutation, CreateRemoteDevelopmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRemoteDevelopmentMutation, CreateRemoteDevelopmentMutationVariables>(CreateRemoteDevelopmentDocument, options);
      }
export type CreateRemoteDevelopmentMutationHookResult = ReturnType<typeof useCreateRemoteDevelopmentMutation>;
export type CreateRemoteDevelopmentMutationResult = Apollo.MutationResult<CreateRemoteDevelopmentMutation>;
export type CreateRemoteDevelopmentMutationOptions = Apollo.BaseMutationOptions<CreateRemoteDevelopmentMutation, CreateRemoteDevelopmentMutationVariables>;
export const DeleteRemoteDevelopmentDocument = gql`
    mutation DeleteRemoteDevelopment($editorSessionId: String!) {
  deleteRemoteDevelopment(editorSessionId: $editorSessionId) {
    editorSessionId
  }
}
    `;
export type DeleteRemoteDevelopmentMutationFn = Apollo.MutationFunction<DeleteRemoteDevelopmentMutation, DeleteRemoteDevelopmentMutationVariables>;

/**
 * __useDeleteRemoteDevelopmentMutation__
 *
 * To run a mutation, you first call `useDeleteRemoteDevelopmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRemoteDevelopmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRemoteDevelopmentMutation, { data, loading, error }] = useDeleteRemoteDevelopmentMutation({
 *   variables: {
 *      editorSessionId: // value for 'editorSessionId'
 *   },
 * });
 */
export function useDeleteRemoteDevelopmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRemoteDevelopmentMutation, DeleteRemoteDevelopmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRemoteDevelopmentMutation, DeleteRemoteDevelopmentMutationVariables>(DeleteRemoteDevelopmentDocument, options);
      }
export type DeleteRemoteDevelopmentMutationHookResult = ReturnType<typeof useDeleteRemoteDevelopmentMutation>;
export type DeleteRemoteDevelopmentMutationResult = Apollo.MutationResult<DeleteRemoteDevelopmentMutation>;
export type DeleteRemoteDevelopmentMutationOptions = Apollo.BaseMutationOptions<DeleteRemoteDevelopmentMutation, DeleteRemoteDevelopmentMutationVariables>;
export const StartRemoteDevelopmentDocument = gql`
    mutation StartRemoteDevelopment($editorSessionId: String!) {
  startRemoteDevelopment(editorSessionId: $editorSessionId) {
    editorSessionId
    editorUrl
  }
}
    `;
export type StartRemoteDevelopmentMutationFn = Apollo.MutationFunction<StartRemoteDevelopmentMutation, StartRemoteDevelopmentMutationVariables>;

/**
 * __useStartRemoteDevelopmentMutation__
 *
 * To run a mutation, you first call `useStartRemoteDevelopmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartRemoteDevelopmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startRemoteDevelopmentMutation, { data, loading, error }] = useStartRemoteDevelopmentMutation({
 *   variables: {
 *      editorSessionId: // value for 'editorSessionId'
 *   },
 * });
 */
export function useStartRemoteDevelopmentMutation(baseOptions?: Apollo.MutationHookOptions<StartRemoteDevelopmentMutation, StartRemoteDevelopmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartRemoteDevelopmentMutation, StartRemoteDevelopmentMutationVariables>(StartRemoteDevelopmentDocument, options);
      }
export type StartRemoteDevelopmentMutationHookResult = ReturnType<typeof useStartRemoteDevelopmentMutation>;
export type StartRemoteDevelopmentMutationResult = Apollo.MutationResult<StartRemoteDevelopmentMutation>;
export type StartRemoteDevelopmentMutationOptions = Apollo.BaseMutationOptions<StartRemoteDevelopmentMutation, StartRemoteDevelopmentMutationVariables>;
export const StopRemoteDevelopmentDocument = gql`
    mutation StopRemoteDevelopment($editorSessionId: String!) {
  stopRemoteDevelopment(editorSessionId: $editorSessionId) {
    editorSessionId
    editorUrl
  }
}
    `;
export type StopRemoteDevelopmentMutationFn = Apollo.MutationFunction<StopRemoteDevelopmentMutation, StopRemoteDevelopmentMutationVariables>;

/**
 * __useStopRemoteDevelopmentMutation__
 *
 * To run a mutation, you first call `useStopRemoteDevelopmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopRemoteDevelopmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopRemoteDevelopmentMutation, { data, loading, error }] = useStopRemoteDevelopmentMutation({
 *   variables: {
 *      editorSessionId: // value for 'editorSessionId'
 *   },
 * });
 */
export function useStopRemoteDevelopmentMutation(baseOptions?: Apollo.MutationHookOptions<StopRemoteDevelopmentMutation, StopRemoteDevelopmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopRemoteDevelopmentMutation, StopRemoteDevelopmentMutationVariables>(StopRemoteDevelopmentDocument, options);
      }
export type StopRemoteDevelopmentMutationHookResult = ReturnType<typeof useStopRemoteDevelopmentMutation>;
export type StopRemoteDevelopmentMutationResult = Apollo.MutationResult<StopRemoteDevelopmentMutation>;
export type StopRemoteDevelopmentMutationOptions = Apollo.BaseMutationOptions<StopRemoteDevelopmentMutation, StopRemoteDevelopmentMutationVariables>;
export const GetOrganizationJobsDocument = gql`
    query GetOrganizationJobs($organizationId: String) {
  getDatasetJobs(organizationId: $organizationId) {
    datasetId
    workspaceId
    name
    runs
    status
    createdAt
    estimatedEndAt
  }
}
    `;

/**
 * __useGetOrganizationJobsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationJobsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationJobsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationJobsQuery, GetOrganizationJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationJobsQuery, GetOrganizationJobsQueryVariables>(GetOrganizationJobsDocument, options);
      }
export function useGetOrganizationJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationJobsQuery, GetOrganizationJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationJobsQuery, GetOrganizationJobsQueryVariables>(GetOrganizationJobsDocument, options);
        }
export type GetOrganizationJobsQueryHookResult = ReturnType<typeof useGetOrganizationJobsQuery>;
export type GetOrganizationJobsLazyQueryHookResult = ReturnType<typeof useGetOrganizationJobsLazyQuery>;
export type GetOrganizationJobsQueryResult = Apollo.QueryResult<GetOrganizationJobsQuery, GetOrganizationJobsQueryVariables>;
export const GetWorkspaceNameDocument = gql`
    query GetWorkspaceName($workspaceId: String) {
  getWorkspaces(workspaceId: $workspaceId) {
    name
    workspaceId
  }
}
    `;

/**
 * __useGetWorkspaceNameQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceNameQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceNameQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkspaceNameQuery, GetWorkspaceNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceNameQuery, GetWorkspaceNameQueryVariables>(GetWorkspaceNameDocument, options);
      }
export function useGetWorkspaceNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceNameQuery, GetWorkspaceNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceNameQuery, GetWorkspaceNameQueryVariables>(GetWorkspaceNameDocument, options);
        }
export type GetWorkspaceNameQueryHookResult = ReturnType<typeof useGetWorkspaceNameQuery>;
export type GetWorkspaceNameLazyQueryHookResult = ReturnType<typeof useGetWorkspaceNameLazyQuery>;
export type GetWorkspaceNameQueryResult = Apollo.QueryResult<GetWorkspaceNameQuery, GetWorkspaceNameQueryVariables>;
export const GetWorkspacesSearchDetailDocument = gql`
    query GetWorkspacesSearchDetail($organizationId: String!, $filters: WorkspaceFilter) {
  getWorkspacesSearchDetail(organizationId: $organizationId, filters: $filters) {
    channels {
      value
      display
    }
    users {
      value
      display
    }
    tags {
      value
      display
    }
  }
}
    `;

/**
 * __useGetWorkspacesSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetWorkspacesSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacesSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacesSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspacesSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspacesSearchDetailQuery, GetWorkspacesSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspacesSearchDetailQuery, GetWorkspacesSearchDetailQueryVariables>(GetWorkspacesSearchDetailDocument, options);
      }
export function useGetWorkspacesSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspacesSearchDetailQuery, GetWorkspacesSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspacesSearchDetailQuery, GetWorkspacesSearchDetailQueryVariables>(GetWorkspacesSearchDetailDocument, options);
        }
export type GetWorkspacesSearchDetailQueryHookResult = ReturnType<typeof useGetWorkspacesSearchDetailQuery>;
export type GetWorkspacesSearchDetailLazyQueryHookResult = ReturnType<typeof useGetWorkspacesSearchDetailLazyQuery>;
export type GetWorkspacesSearchDetailQueryResult = Apollo.QueryResult<GetWorkspacesSearchDetailQuery, GetWorkspacesSearchDetailQueryVariables>;
export const GetChannelsSearchDetailDocument = gql`
    query GetChannelsSearchDetail($organizationId: String, $filters: ChannelFilter, $workspaceId: String) {
  getChannelsSearchDetail(
    organizationId: $organizationId
    filters: $filters
    workspaceId: $workspaceId
  ) {
    users {
      value
      display
    }
    tags {
      value
      display
    }
  }
}
    `;

/**
 * __useGetChannelsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetChannelsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelsSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      filters: // value for 'filters'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetChannelsSearchDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelsSearchDetailQuery, GetChannelsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelsSearchDetailQuery, GetChannelsSearchDetailQueryVariables>(GetChannelsSearchDetailDocument, options);
      }
export function useGetChannelsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelsSearchDetailQuery, GetChannelsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelsSearchDetailQuery, GetChannelsSearchDetailQueryVariables>(GetChannelsSearchDetailDocument, options);
        }
export type GetChannelsSearchDetailQueryHookResult = ReturnType<typeof useGetChannelsSearchDetailQuery>;
export type GetChannelsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetChannelsSearchDetailLazyQuery>;
export type GetChannelsSearchDetailQueryResult = Apollo.QueryResult<GetChannelsSearchDetailQuery, GetChannelsSearchDetailQueryVariables>;
export const GetVolumesSearchDetailDocument = gql`
    query GetVolumesSearchDetail($organizationId: String, $workspaceId: String, $filters: VolumeFilter) {
  getVolumesSearchDetail(
    organizationId: $organizationId
    workspaceId: $workspaceId
    filters: $filters
  ) {
    tags {
      value
      display
    }
    users {
      value
      display
    }
  }
}
    `;

/**
 * __useGetVolumesSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetVolumesSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVolumesSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVolumesSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetVolumesSearchDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetVolumesSearchDetailQuery, GetVolumesSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVolumesSearchDetailQuery, GetVolumesSearchDetailQueryVariables>(GetVolumesSearchDetailDocument, options);
      }
export function useGetVolumesSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVolumesSearchDetailQuery, GetVolumesSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVolumesSearchDetailQuery, GetVolumesSearchDetailQueryVariables>(GetVolumesSearchDetailDocument, options);
        }
export type GetVolumesSearchDetailQueryHookResult = ReturnType<typeof useGetVolumesSearchDetailQuery>;
export type GetVolumesSearchDetailLazyQueryHookResult = ReturnType<typeof useGetVolumesSearchDetailLazyQuery>;
export type GetVolumesSearchDetailQueryResult = Apollo.QueryResult<GetVolumesSearchDetailQuery, GetVolumesSearchDetailQueryVariables>;
export const GetAnnotationMapsSearchDetailDocument = gql`
    query GetAnnotationMapsSearchDetail($organizationId: String, $workspaceId: String, $filters: AnnotationMapFilter) {
  getAnnotationMapsSearchDetail(
    organizationId: $organizationId
    workspaceId: $workspaceId
    filters: $filters
  ) {
    users {
      value
      display
    }
    tags {
      value
      display
    }
  }
}
    `;

/**
 * __useGetAnnotationMapsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetAnnotationMapsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationMapsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationMapsSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetAnnotationMapsSearchDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetAnnotationMapsSearchDetailQuery, GetAnnotationMapsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnotationMapsSearchDetailQuery, GetAnnotationMapsSearchDetailQueryVariables>(GetAnnotationMapsSearchDetailDocument, options);
      }
export function useGetAnnotationMapsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnotationMapsSearchDetailQuery, GetAnnotationMapsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnotationMapsSearchDetailQuery, GetAnnotationMapsSearchDetailQueryVariables>(GetAnnotationMapsSearchDetailDocument, options);
        }
export type GetAnnotationMapsSearchDetailQueryHookResult = ReturnType<typeof useGetAnnotationMapsSearchDetailQuery>;
export type GetAnnotationMapsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetAnnotationMapsSearchDetailLazyQuery>;
export type GetAnnotationMapsSearchDetailQueryResult = Apollo.QueryResult<GetAnnotationMapsSearchDetailQuery, GetAnnotationMapsSearchDetailQueryVariables>;
export const GetGanModelsSearchDetailDocument = gql`
    query GetGANModelsSearchDetail($organizationId: String, $workspaceId: String, $filters: GANModelFilter) {
  getGANModelsSearchDetail(
    organizationId: $organizationId
    workspaceId: $workspaceId
    filters: $filters
  ) {
    users {
      value
      display
    }
    tags {
      value
      display
    }
  }
}
    `;

/**
 * __useGetGanModelsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetGanModelsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGanModelsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGanModelsSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetGanModelsSearchDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetGanModelsSearchDetailQuery, GetGanModelsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGanModelsSearchDetailQuery, GetGanModelsSearchDetailQueryVariables>(GetGanModelsSearchDetailDocument, options);
      }
export function useGetGanModelsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGanModelsSearchDetailQuery, GetGanModelsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGanModelsSearchDetailQuery, GetGanModelsSearchDetailQueryVariables>(GetGanModelsSearchDetailDocument, options);
        }
export type GetGanModelsSearchDetailQueryHookResult = ReturnType<typeof useGetGanModelsSearchDetailQuery>;
export type GetGanModelsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetGanModelsSearchDetailLazyQuery>;
export type GetGanModelsSearchDetailQueryResult = Apollo.QueryResult<GetGanModelsSearchDetailQuery, GetGanModelsSearchDetailQueryVariables>;
export const GetContentCodesDocument = gql`
    query GetContentCodes {
  getContentCodes {
    code
    name
    description
    thumbnail
    link
    featured
    contactUs
    expiresAt
  }
}
    `;

/**
 * __useGetContentCodesQuery__
 *
 * To run a query within a React component, call `useGetContentCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContentCodesQuery(baseOptions?: Apollo.QueryHookOptions<GetContentCodesQuery, GetContentCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentCodesQuery, GetContentCodesQueryVariables>(GetContentCodesDocument, options);
      }
export function useGetContentCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentCodesQuery, GetContentCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentCodesQuery, GetContentCodesQueryVariables>(GetContentCodesDocument, options);
        }
export type GetContentCodesQueryHookResult = ReturnType<typeof useGetContentCodesQuery>;
export type GetContentCodesLazyQueryHookResult = ReturnType<typeof useGetContentCodesLazyQuery>;
export type GetContentCodesQueryResult = Apollo.QueryResult<GetContentCodesQuery, GetContentCodesQueryVariables>;
export const CreateApiKeyDocument = gql`
    mutation CreateAPIKey($name: String!, $scope: String, $organizationId: String, $workspaceId: String, $expiresAt: String) {
  createAPIKey(
    name: $name
    scope: $scope
    organizationId: $organizationId
    workspaceId: $workspaceId
    expiresAt: $expiresAt
  )
}
    `;
export type CreateApiKeyMutationFn = Apollo.MutationFunction<CreateApiKeyMutation, CreateApiKeyMutationVariables>;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *      name: // value for 'name'
 *      scope: // value for 'scope'
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useCreateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, options);
      }
export type CreateApiKeyMutationHookResult = ReturnType<typeof useCreateApiKeyMutation>;
export type CreateApiKeyMutationResult = Apollo.MutationResult<CreateApiKeyMutation>;
export type CreateApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const DeleteApiKeyDocument = gql`
    mutation DeleteAPIKey($name: String!) {
  deleteAPIKey(name: $name)
}
    `;
export type DeleteApiKeyMutationFn = Apollo.MutationFunction<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;

/**
 * __useDeleteApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiKeyMutation, { data, loading, error }] = useDeleteApiKeyMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>(DeleteApiKeyDocument, options);
      }
export type DeleteApiKeyMutationHookResult = ReturnType<typeof useDeleteApiKeyMutation>;
export type DeleteApiKeyMutationResult = Apollo.MutationResult<DeleteApiKeyMutation>;
export type DeleteApiKeyMutationOptions = Apollo.BaseMutationOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;
export const GetApiKeysDocument = gql`
    query GetAPIKeys {
  getAPIKeys {
    createdAt
    expiresAt
    name
    organizationId
    scope
    workspaceId
  }
}
    `;

/**
 * __useGetApiKeysQuery__
 *
 * To run a query within a React component, call `useGetApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApiKeysQuery(baseOptions?: Apollo.QueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
      }
export function useGetApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
        }
export type GetApiKeysQueryHookResult = ReturnType<typeof useGetApiKeysQuery>;
export type GetApiKeysLazyQueryHookResult = ReturnType<typeof useGetApiKeysLazyQuery>;
export type GetApiKeysQueryResult = Apollo.QueryResult<GetApiKeysQuery, GetApiKeysQueryVariables>;
export const CreateSshKeyDocument = gql`
    mutation CreateSSHKey($name: String!, $key: String!) {
  createSSHKey(name: $name, key: $key)
}
    `;
export type CreateSshKeyMutationFn = Apollo.MutationFunction<CreateSshKeyMutation, CreateSshKeyMutationVariables>;

/**
 * __useCreateSshKeyMutation__
 *
 * To run a mutation, you first call `useCreateSshKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSshKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSshKeyMutation, { data, loading, error }] = useCreateSshKeyMutation({
 *   variables: {
 *      name: // value for 'name'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useCreateSshKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateSshKeyMutation, CreateSshKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSshKeyMutation, CreateSshKeyMutationVariables>(CreateSshKeyDocument, options);
      }
export type CreateSshKeyMutationHookResult = ReturnType<typeof useCreateSshKeyMutation>;
export type CreateSshKeyMutationResult = Apollo.MutationResult<CreateSshKeyMutation>;
export type CreateSshKeyMutationOptions = Apollo.BaseMutationOptions<CreateSshKeyMutation, CreateSshKeyMutationVariables>;
export const DeleteSshKeyDocument = gql`
    mutation DeleteSSHKey($name: String!) {
  deleteSSHKey(name: $name)
}
    `;
export type DeleteSshKeyMutationFn = Apollo.MutationFunction<DeleteSshKeyMutation, DeleteSshKeyMutationVariables>;

/**
 * __useDeleteSshKeyMutation__
 *
 * To run a mutation, you first call `useDeleteSshKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSshKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSshKeyMutation, { data, loading, error }] = useDeleteSshKeyMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDeleteSshKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSshKeyMutation, DeleteSshKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSshKeyMutation, DeleteSshKeyMutationVariables>(DeleteSshKeyDocument, options);
      }
export type DeleteSshKeyMutationHookResult = ReturnType<typeof useDeleteSshKeyMutation>;
export type DeleteSshKeyMutationResult = Apollo.MutationResult<DeleteSshKeyMutation>;
export type DeleteSshKeyMutationOptions = Apollo.BaseMutationOptions<DeleteSshKeyMutation, DeleteSshKeyMutationVariables>;
export const GetSshKeysDocument = gql`
    query GetSSHKeys {
  getSSHKeys {
    name
    key
    createdAt
  }
}
    `;

/**
 * __useGetSshKeysQuery__
 *
 * To run a query within a React component, call `useGetSshKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSshKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSshKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSshKeysQuery(baseOptions?: Apollo.QueryHookOptions<GetSshKeysQuery, GetSshKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSshKeysQuery, GetSshKeysQueryVariables>(GetSshKeysDocument, options);
      }
export function useGetSshKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSshKeysQuery, GetSshKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSshKeysQuery, GetSshKeysQueryVariables>(GetSshKeysDocument, options);
        }
export type GetSshKeysQueryHookResult = ReturnType<typeof useGetSshKeysQuery>;
export type GetSshKeysLazyQueryHookResult = ReturnType<typeof useGetSshKeysLazyQuery>;
export type GetSshKeysQueryResult = Apollo.QueryResult<GetSshKeysQuery, GetSshKeysQueryVariables>;
export const GetWorkspaceAnalyticsDocument = gql`
    query GetWorkspaceAnalytics($workspaceId: String!, $cursor: String, $limit: Int, $filters: AnalyticsFilter) {
  getAnalytics(
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    analyticsId
    createdAt
    createdBy
    dataset
    datasetId
    result
    status
    tags
    type
    workspaceId
  }
}
    `;

/**
 * __useGetWorkspaceAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceAnalyticsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspaceAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceAnalyticsQuery, GetWorkspaceAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceAnalyticsQuery, GetWorkspaceAnalyticsQueryVariables>(GetWorkspaceAnalyticsDocument, options);
      }
export function useGetWorkspaceAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceAnalyticsQuery, GetWorkspaceAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceAnalyticsQuery, GetWorkspaceAnalyticsQueryVariables>(GetWorkspaceAnalyticsDocument, options);
        }
export type GetWorkspaceAnalyticsQueryHookResult = ReturnType<typeof useGetWorkspaceAnalyticsQuery>;
export type GetWorkspaceAnalyticsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceAnalyticsLazyQuery>;
export type GetWorkspaceAnalyticsQueryResult = Apollo.QueryResult<GetWorkspaceAnalyticsQuery, GetWorkspaceAnalyticsQueryVariables>;
export const GetAnalyticsSearchDetailDocument = gql`
    query GetAnalyticsSearchDetail($workspaceId: String!, $filters: AnalyticsFilter, $datasetId: String) {
  getAnalyticsSearchDetail(
    workspaceId: $workspaceId
    filters: $filters
    datasetId: $datasetId
  ) {
    status {
      display
      value
    }
    tags {
      value
      display
    }
    users {
      value
      display
    }
  }
}
    `;

/**
 * __useGetAnalyticsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetAnalyticsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticsSearchDetailQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetAnalyticsSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyticsSearchDetailQuery, GetAnalyticsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticsSearchDetailQuery, GetAnalyticsSearchDetailQueryVariables>(GetAnalyticsSearchDetailDocument, options);
      }
export function useGetAnalyticsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticsSearchDetailQuery, GetAnalyticsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticsSearchDetailQuery, GetAnalyticsSearchDetailQueryVariables>(GetAnalyticsSearchDetailDocument, options);
        }
export type GetAnalyticsSearchDetailQueryHookResult = ReturnType<typeof useGetAnalyticsSearchDetailQuery>;
export type GetAnalyticsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetAnalyticsSearchDetailLazyQuery>;
export type GetAnalyticsSearchDetailQueryResult = Apollo.QueryResult<GetAnalyticsSearchDetailQuery, GetAnalyticsSearchDetailQueryVariables>;
export const GetWorkspaceUmapsDocument = gql`
    query GetWorkspaceUmaps($workspaceId: String!, $cursor: String, $limit: Int, $filters: UMAPFilter) {
  getUMAPs(
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    createdAt
    createdBy
    datasets {
      dataset
      datasetId
    }
    name
    results
    samples
    seed
    status
    tags
    umapId
    workspaceId
  }
}
    `;

/**
 * __useGetWorkspaceUmapsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceUmapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceUmapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceUmapsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspaceUmapsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceUmapsQuery, GetWorkspaceUmapsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceUmapsQuery, GetWorkspaceUmapsQueryVariables>(GetWorkspaceUmapsDocument, options);
      }
export function useGetWorkspaceUmapsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceUmapsQuery, GetWorkspaceUmapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceUmapsQuery, GetWorkspaceUmapsQueryVariables>(GetWorkspaceUmapsDocument, options);
        }
export type GetWorkspaceUmapsQueryHookResult = ReturnType<typeof useGetWorkspaceUmapsQuery>;
export type GetWorkspaceUmapsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceUmapsLazyQuery>;
export type GetWorkspaceUmapsQueryResult = Apollo.QueryResult<GetWorkspaceUmapsQuery, GetWorkspaceUmapsQueryVariables>;
export const GetUmapsSearchDetailDocument = gql`
    query GetUmapsSearchDetail($workspaceId: String!, $datasetId: String, $filters: UMAPFilter) {
  getUMAPsSearchDetail(
    workspaceId: $workspaceId
    datasetId: $datasetId
    filters: $filters
  ) {
    users {
      value
      display
    }
    tags {
      value
      display
    }
    status {
      value
      display
    }
  }
}
    `;

/**
 * __useGetUmapsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetUmapsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUmapsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUmapsSearchDetailQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetUmapsSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetUmapsSearchDetailQuery, GetUmapsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUmapsSearchDetailQuery, GetUmapsSearchDetailQueryVariables>(GetUmapsSearchDetailDocument, options);
      }
export function useGetUmapsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUmapsSearchDetailQuery, GetUmapsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUmapsSearchDetailQuery, GetUmapsSearchDetailQueryVariables>(GetUmapsSearchDetailDocument, options);
        }
export type GetUmapsSearchDetailQueryHookResult = ReturnType<typeof useGetUmapsSearchDetailQuery>;
export type GetUmapsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetUmapsSearchDetailLazyQuery>;
export type GetUmapsSearchDetailQueryResult = Apollo.QueryResult<GetUmapsSearchDetailQuery, GetUmapsSearchDetailQueryVariables>;
export const GetWorkspaceMlModelsDocument = gql`
    query GetWorkspaceMLModels($workspaceId: String!, $cursor: String, $limit: Int, $filters: MLModelFilter) {
  getMLModels(
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    architecture
    architectureId
    checkpoints
    classes
    createdBy
    createdAt
    dataset
    datasetId
    description
    map
    mapId
    metrics
    modelId
    name
    parameters
    status
    tags
  }
}
    `;

/**
 * __useGetWorkspaceMlModelsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceMlModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceMlModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceMlModelsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspaceMlModelsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceMlModelsQuery, GetWorkspaceMlModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceMlModelsQuery, GetWorkspaceMlModelsQueryVariables>(GetWorkspaceMlModelsDocument, options);
      }
export function useGetWorkspaceMlModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceMlModelsQuery, GetWorkspaceMlModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceMlModelsQuery, GetWorkspaceMlModelsQueryVariables>(GetWorkspaceMlModelsDocument, options);
        }
export type GetWorkspaceMlModelsQueryHookResult = ReturnType<typeof useGetWorkspaceMlModelsQuery>;
export type GetWorkspaceMlModelsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceMlModelsLazyQuery>;
export type GetWorkspaceMlModelsQueryResult = Apollo.QueryResult<GetWorkspaceMlModelsQuery, GetWorkspaceMlModelsQueryVariables>;
export const GetMlModelsSearchDetailDocument = gql`
    query GetMLModelsSearchDetail($workspaceId: String!, $datasetId: String, $filters: MLModelFilter) {
  getMLModelsSearchDetail(
    workspaceId: $workspaceId
    datasetId: $datasetId
    filters: $filters
  ) {
    users {
      value
      display
    }
    tags {
      value
      display
    }
    status {
      value
      display
    }
    architectures {
      value
      display
    }
  }
}
    `;

/**
 * __useGetMlModelsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetMlModelsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMlModelsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMlModelsSearchDetailQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetMlModelsSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetMlModelsSearchDetailQuery, GetMlModelsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMlModelsSearchDetailQuery, GetMlModelsSearchDetailQueryVariables>(GetMlModelsSearchDetailDocument, options);
      }
export function useGetMlModelsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMlModelsSearchDetailQuery, GetMlModelsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMlModelsSearchDetailQuery, GetMlModelsSearchDetailQueryVariables>(GetMlModelsSearchDetailDocument, options);
        }
export type GetMlModelsSearchDetailQueryHookResult = ReturnType<typeof useGetMlModelsSearchDetailQuery>;
export type GetMlModelsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetMlModelsSearchDetailLazyQuery>;
export type GetMlModelsSearchDetailQueryResult = Apollo.QueryResult<GetMlModelsSearchDetailQuery, GetMlModelsSearchDetailQueryVariables>;
export const GetWorkspaceMlInferencesDocument = gql`
    query GetWorkspaceMLInferences($workspaceId: String!, $cursor: String, $limit: Int, $filters: MLInferenceFilter) {
  getMLInferences(
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    datasetId
    dataset
    map
    mapId
    metrics
    model
    modelId
    status
    inferenceId
    workspaceId
    createdBy
    createdAt
    tags
  }
}
    `;

/**
 * __useGetWorkspaceMlInferencesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceMlInferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceMlInferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceMlInferencesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetWorkspaceMlInferencesQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceMlInferencesQuery, GetWorkspaceMlInferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceMlInferencesQuery, GetWorkspaceMlInferencesQueryVariables>(GetWorkspaceMlInferencesDocument, options);
      }
export function useGetWorkspaceMlInferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceMlInferencesQuery, GetWorkspaceMlInferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceMlInferencesQuery, GetWorkspaceMlInferencesQueryVariables>(GetWorkspaceMlInferencesDocument, options);
        }
export type GetWorkspaceMlInferencesQueryHookResult = ReturnType<typeof useGetWorkspaceMlInferencesQuery>;
export type GetWorkspaceMlInferencesLazyQueryHookResult = ReturnType<typeof useGetWorkspaceMlInferencesLazyQuery>;
export type GetWorkspaceMlInferencesQueryResult = Apollo.QueryResult<GetWorkspaceMlInferencesQuery, GetWorkspaceMlInferencesQueryVariables>;
export const GetMlInferencesSearchDetailDocument = gql`
    query GetMLInferencesSearchDetail($workspaceId: String!, $datasetId: String, $filters: MLInferenceFilter) {
  getMLInferencesSearchDetail(
    workspaceId: $workspaceId
    datasetId: $datasetId
    filters: $filters
  ) {
    users {
      value
      display
    }
    tags {
      value
      display
    }
    status {
      value
      display
    }
    architectures {
      value
      display
    }
  }
}
    `;

/**
 * __useGetMlInferencesSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetMlInferencesSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMlInferencesSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMlInferencesSearchDetailQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetMlInferencesSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetMlInferencesSearchDetailQuery, GetMlInferencesSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMlInferencesSearchDetailQuery, GetMlInferencesSearchDetailQueryVariables>(GetMlInferencesSearchDetailDocument, options);
      }
export function useGetMlInferencesSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMlInferencesSearchDetailQuery, GetMlInferencesSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMlInferencesSearchDetailQuery, GetMlInferencesSearchDetailQueryVariables>(GetMlInferencesSearchDetailDocument, options);
        }
export type GetMlInferencesSearchDetailQueryHookResult = ReturnType<typeof useGetMlInferencesSearchDetailQuery>;
export type GetMlInferencesSearchDetailLazyQueryHookResult = ReturnType<typeof useGetMlInferencesSearchDetailLazyQuery>;
export type GetMlInferencesSearchDetailQueryResult = Apollo.QueryResult<GetMlInferencesSearchDetailQuery, GetMlInferencesSearchDetailQueryVariables>;
export const GetMlModelInferencesDocument = gql`
    query GetMLModelInferences($workspaceId: String!, $modelId: String) {
  getMLInferences(workspaceId: $workspaceId, modelId: $modelId) {
    datasetId
    dataset
    model
    modelId
    status
    inferenceId
    tags
    workspaceId
  }
}
    `;

/**
 * __useGetMlModelInferencesQuery__
 *
 * To run a query within a React component, call `useGetMlModelInferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMlModelInferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMlModelInferencesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useGetMlModelInferencesQuery(baseOptions: Apollo.QueryHookOptions<GetMlModelInferencesQuery, GetMlModelInferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMlModelInferencesQuery, GetMlModelInferencesQueryVariables>(GetMlModelInferencesDocument, options);
      }
export function useGetMlModelInferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMlModelInferencesQuery, GetMlModelInferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMlModelInferencesQuery, GetMlModelInferencesQueryVariables>(GetMlModelInferencesDocument, options);
        }
export type GetMlModelInferencesQueryHookResult = ReturnType<typeof useGetMlModelInferencesQuery>;
export type GetMlModelInferencesLazyQueryHookResult = ReturnType<typeof useGetMlModelInferencesLazyQuery>;
export type GetMlModelInferencesQueryResult = Apollo.QueryResult<GetMlModelInferencesQuery, GetMlModelInferencesQueryVariables>;
export const GetGraphsDocument = gql`
    query GetGraphs($workspaceId: String!, $staged: Boolean, $cursor: String, $limit: Int) {
  getGraphs(
    workspaceId: $workspaceId
    staged: $staged
    cursor: $cursor
    limit: $limit
  ) {
    channel
    createdAt
    createdBy
    description
    graphId
    name
    tags
    thumbnail
    updatedAt
    workspaceId
  }
}
    `;

/**
 * __useGetGraphsQuery__
 *
 * To run a query within a React component, call `useGetGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      staged: // value for 'staged'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetGraphsQuery(baseOptions: Apollo.QueryHookOptions<GetGraphsQuery, GetGraphsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphsQuery, GetGraphsQueryVariables>(GetGraphsDocument, options);
      }
export function useGetGraphsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphsQuery, GetGraphsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphsQuery, GetGraphsQueryVariables>(GetGraphsDocument, options);
        }
export type GetGraphsQueryHookResult = ReturnType<typeof useGetGraphsQuery>;
export type GetGraphsLazyQueryHookResult = ReturnType<typeof useGetGraphsLazyQuery>;
export type GetGraphsQueryResult = Apollo.QueryResult<GetGraphsQuery, GetGraphsQueryVariables>;
export const GetGraphMetadataDocument = gql`
    query GetGraphMetadata($workspaceId: String!, $graphId: String) {
  getGraphs(workspaceId: $workspaceId, graphId: $graphId) {
    channel
    channelId
    description
    graphId
    name
    previewId
    readOnly
    showPreview
    tags
    workspaceId
    updatedAt
  }
}
    `;

/**
 * __useGetGraphMetadataQuery__
 *
 * To run a query within a React component, call `useGetGraphMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphMetadataQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *   },
 * });
 */
export function useGetGraphMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetGraphMetadataQuery, GetGraphMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphMetadataQuery, GetGraphMetadataQueryVariables>(GetGraphMetadataDocument, options);
      }
export function useGetGraphMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphMetadataQuery, GetGraphMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphMetadataQuery, GetGraphMetadataQueryVariables>(GetGraphMetadataDocument, options);
        }
export type GetGraphMetadataQueryHookResult = ReturnType<typeof useGetGraphMetadataQuery>;
export type GetGraphMetadataLazyQueryHookResult = ReturnType<typeof useGetGraphMetadataLazyQuery>;
export type GetGraphMetadataQueryResult = Apollo.QueryResult<GetGraphMetadataQuery, GetGraphMetadataQueryVariables>;
export const GetGraphDataDocument = gql`
    mutation GetGraphData($graphId: String!, $workspaceId: String!) {
  downloadGraph(graphId: $graphId, workspaceId: $workspaceId)
}
    `;
export type GetGraphDataMutationFn = Apollo.MutationFunction<GetGraphDataMutation, GetGraphDataMutationVariables>;

/**
 * __useGetGraphDataMutation__
 *
 * To run a mutation, you first call `useGetGraphDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetGraphDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getGraphDataMutation, { data, loading, error }] = useGetGraphDataMutation({
 *   variables: {
 *      graphId: // value for 'graphId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetGraphDataMutation(baseOptions?: Apollo.MutationHookOptions<GetGraphDataMutation, GetGraphDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetGraphDataMutation, GetGraphDataMutationVariables>(GetGraphDataDocument, options);
      }
export type GetGraphDataMutationHookResult = ReturnType<typeof useGetGraphDataMutation>;
export type GetGraphDataMutationResult = Apollo.MutationResult<GetGraphDataMutation>;
export type GetGraphDataMutationOptions = Apollo.BaseMutationOptions<GetGraphDataMutation, GetGraphDataMutationVariables>;
export const EditGraphDocument = gql`
    mutation EditGraph($graphId: String!, $workspaceId: String!, $description: String, $name: String, $tags: [String]) {
  editGraph(
    graphId: $graphId
    workspaceId: $workspaceId
    description: $description
    name: $name
    tags: $tags
  )
}
    `;
export type EditGraphMutationFn = Apollo.MutationFunction<EditGraphMutation, EditGraphMutationVariables>;

/**
 * __useEditGraphMutation__
 *
 * To run a mutation, you first call `useEditGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editGraphMutation, { data, loading, error }] = useEditGraphMutation({
 *   variables: {
 *      graphId: // value for 'graphId'
 *      workspaceId: // value for 'workspaceId'
 *      description: // value for 'description'
 *      name: // value for 'name'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditGraphMutation(baseOptions?: Apollo.MutationHookOptions<EditGraphMutation, EditGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditGraphMutation, EditGraphMutationVariables>(EditGraphDocument, options);
      }
export type EditGraphMutationHookResult = ReturnType<typeof useEditGraphMutation>;
export type EditGraphMutationResult = Apollo.MutationResult<EditGraphMutation>;
export type EditGraphMutationOptions = Apollo.BaseMutationOptions<EditGraphMutation, EditGraphMutationVariables>;
export const DeleteGraphDocument = gql`
    mutation DeleteGraph($graphId: String!, $workspaceId: String!) {
  deleteGraph(graphId: $graphId, workspaceId: $workspaceId)
}
    `;
export type DeleteGraphMutationFn = Apollo.MutationFunction<DeleteGraphMutation, DeleteGraphMutationVariables>;

/**
 * __useDeleteGraphMutation__
 *
 * To run a mutation, you first call `useDeleteGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGraphMutation, { data, loading, error }] = useDeleteGraphMutation({
 *   variables: {
 *      graphId: // value for 'graphId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDeleteGraphMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGraphMutation, DeleteGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGraphMutation, DeleteGraphMutationVariables>(DeleteGraphDocument, options);
      }
export type DeleteGraphMutationHookResult = ReturnType<typeof useDeleteGraphMutation>;
export type DeleteGraphMutationResult = Apollo.MutationResult<DeleteGraphMutation>;
export type DeleteGraphMutationOptions = Apollo.BaseMutationOptions<DeleteGraphMutation, DeleteGraphMutationVariables>;
export const DownloadGraphDocument = gql`
    mutation DownloadGraph($graphId: String!, $workspaceId: String!) {
  downloadGraph(graphId: $graphId, workspaceId: $workspaceId)
}
    `;
export type DownloadGraphMutationFn = Apollo.MutationFunction<DownloadGraphMutation, DownloadGraphMutationVariables>;

/**
 * __useDownloadGraphMutation__
 *
 * To run a mutation, you first call `useDownloadGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadGraphMutation, { data, loading, error }] = useDownloadGraphMutation({
 *   variables: {
 *      graphId: // value for 'graphId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useDownloadGraphMutation(baseOptions?: Apollo.MutationHookOptions<DownloadGraphMutation, DownloadGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadGraphMutation, DownloadGraphMutationVariables>(DownloadGraphDocument, options);
      }
export type DownloadGraphMutationHookResult = ReturnType<typeof useDownloadGraphMutation>;
export type DownloadGraphMutationResult = Apollo.MutationResult<DownloadGraphMutation>;
export type DownloadGraphMutationOptions = Apollo.BaseMutationOptions<DownloadGraphMutation, DownloadGraphMutationVariables>;
export const DuplicateGraphDocument = gql`
    mutation DuplicateGraph($graphId: String!, $workspaceId: String!, $name: String, $description: String, $tags: [String]) {
  duplicateGraph(
    graphId: $graphId
    workspaceId: $workspaceId
    name: $name
    description: $description
    tags: $tags
  )
}
    `;
export type DuplicateGraphMutationFn = Apollo.MutationFunction<DuplicateGraphMutation, DuplicateGraphMutationVariables>;

/**
 * __useDuplicateGraphMutation__
 *
 * To run a mutation, you first call `useDuplicateGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateGraphMutation, { data, loading, error }] = useDuplicateGraphMutation({
 *   variables: {
 *      graphId: // value for 'graphId'
 *      workspaceId: // value for 'workspaceId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useDuplicateGraphMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateGraphMutation, DuplicateGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateGraphMutation, DuplicateGraphMutationVariables>(DuplicateGraphDocument, options);
      }
export type DuplicateGraphMutationHookResult = ReturnType<typeof useDuplicateGraphMutation>;
export type DuplicateGraphMutationResult = Apollo.MutationResult<DuplicateGraphMutation>;
export type DuplicateGraphMutationOptions = Apollo.BaseMutationOptions<DuplicateGraphMutation, DuplicateGraphMutationVariables>;
export const ValidateGraphDocument = gql`
    mutation ValidateGraph($workspaceId: String!, $graphId: String!) {
  validateGraph(workspaceId: $workspaceId, graphId: $graphId) {
    node
    input
    errorMessage
    type
  }
}
    `;
export type ValidateGraphMutationFn = Apollo.MutationFunction<ValidateGraphMutation, ValidateGraphMutationVariables>;

/**
 * __useValidateGraphMutation__
 *
 * To run a mutation, you first call `useValidateGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateGraphMutation, { data, loading, error }] = useValidateGraphMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *   },
 * });
 */
export function useValidateGraphMutation(baseOptions?: Apollo.MutationHookOptions<ValidateGraphMutation, ValidateGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateGraphMutation, ValidateGraphMutationVariables>(ValidateGraphDocument, options);
      }
export type ValidateGraphMutationHookResult = ReturnType<typeof useValidateGraphMutation>;
export type ValidateGraphMutationResult = Apollo.MutationResult<ValidateGraphMutation>;
export type ValidateGraphMutationOptions = Apollo.BaseMutationOptions<ValidateGraphMutation, ValidateGraphMutationVariables>;
export const SaveGraphDocument = gql`
    mutation SaveGraph($graphId: String!, $workspaceId: String!, $graph: String) {
  editGraph(graphId: $graphId, workspaceId: $workspaceId, graph: $graph)
}
    `;
export type SaveGraphMutationFn = Apollo.MutationFunction<SaveGraphMutation, SaveGraphMutationVariables>;

/**
 * __useSaveGraphMutation__
 *
 * To run a mutation, you first call `useSaveGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGraphMutation, { data, loading, error }] = useSaveGraphMutation({
 *   variables: {
 *      graphId: // value for 'graphId'
 *      workspaceId: // value for 'workspaceId'
 *      graph: // value for 'graph'
 *   },
 * });
 */
export function useSaveGraphMutation(baseOptions?: Apollo.MutationHookOptions<SaveGraphMutation, SaveGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveGraphMutation, SaveGraphMutationVariables>(SaveGraphDocument, options);
      }
export type SaveGraphMutationHookResult = ReturnType<typeof useSaveGraphMutation>;
export type SaveGraphMutationResult = Apollo.MutationResult<SaveGraphMutation>;
export type SaveGraphMutationOptions = Apollo.BaseMutationOptions<SaveGraphMutation, SaveGraphMutationVariables>;
export const CreateGraphDocument = gql`
    mutation CreateGraph($workspaceId: String!, $channelId: String!, $graph: String!, $name: String!, $description: String, $staged: Boolean, $tags: [String]) {
  createGraph(
    workspaceId: $workspaceId
    channelId: $channelId
    graph: $graph
    name: $name
    description: $description
    staged: $staged
    tags: $tags
  )
}
    `;
export type CreateGraphMutationFn = Apollo.MutationFunction<CreateGraphMutation, CreateGraphMutationVariables>;

/**
 * __useCreateGraphMutation__
 *
 * To run a mutation, you first call `useCreateGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGraphMutation, { data, loading, error }] = useCreateGraphMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      channelId: // value for 'channelId'
 *      graph: // value for 'graph'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      staged: // value for 'staged'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateGraphMutation(baseOptions?: Apollo.MutationHookOptions<CreateGraphMutation, CreateGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGraphMutation, CreateGraphMutationVariables>(CreateGraphDocument, options);
      }
export type CreateGraphMutationHookResult = ReturnType<typeof useCreateGraphMutation>;
export type CreateGraphMutationResult = Apollo.MutationResult<CreateGraphMutation>;
export type CreateGraphMutationOptions = Apollo.BaseMutationOptions<CreateGraphMutation, CreateGraphMutationVariables>;
export const CreatePreviewDocument = gql`
    mutation CreatePreview($workspaceId: String!, $graphId: String!) {
  createPreview(workspaceId: $workspaceId, graphId: $graphId)
}
    `;
export type CreatePreviewMutationFn = Apollo.MutationFunction<CreatePreviewMutation, CreatePreviewMutationVariables>;

/**
 * __useCreatePreviewMutation__
 *
 * To run a mutation, you first call `useCreatePreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPreviewMutation, { data, loading, error }] = useCreatePreviewMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *   },
 * });
 */
export function useCreatePreviewMutation(baseOptions?: Apollo.MutationHookOptions<CreatePreviewMutation, CreatePreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePreviewMutation, CreatePreviewMutationVariables>(CreatePreviewDocument, options);
      }
export type CreatePreviewMutationHookResult = ReturnType<typeof useCreatePreviewMutation>;
export type CreatePreviewMutationResult = Apollo.MutationResult<CreatePreviewMutation>;
export type CreatePreviewMutationOptions = Apollo.BaseMutationOptions<CreatePreviewMutation, CreatePreviewMutationVariables>;
export const DeletePreviewDocument = gql`
    mutation DeletePreview($workspaceId: String!, $previewId: String!) {
  deletePreview(workspaceId: $workspaceId, previewId: $previewId)
}
    `;
export type DeletePreviewMutationFn = Apollo.MutationFunction<DeletePreviewMutation, DeletePreviewMutationVariables>;

/**
 * __useDeletePreviewMutation__
 *
 * To run a mutation, you first call `useDeletePreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePreviewMutation, { data, loading, error }] = useDeletePreviewMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      previewId: // value for 'previewId'
 *   },
 * });
 */
export function useDeletePreviewMutation(baseOptions?: Apollo.MutationHookOptions<DeletePreviewMutation, DeletePreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePreviewMutation, DeletePreviewMutationVariables>(DeletePreviewDocument, options);
      }
export type DeletePreviewMutationHookResult = ReturnType<typeof useDeletePreviewMutation>;
export type DeletePreviewMutationResult = Apollo.MutationResult<DeletePreviewMutation>;
export type DeletePreviewMutationOptions = Apollo.BaseMutationOptions<DeletePreviewMutation, DeletePreviewMutationVariables>;
export const GetPreviewDocument = gql`
    query GetPreview($workspaceId: String!, $previewId: String!) {
  getPreview(workspaceId: $workspaceId, previewId: $previewId) {
    status
    previewId
    thumbnail
    updatedAt
    workspaceId
  }
}
    `;

/**
 * __useGetPreviewQuery__
 *
 * To run a query within a React component, call `useGetPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      previewId: // value for 'previewId'
 *   },
 * });
 */
export function useGetPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetPreviewQuery, GetPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviewQuery, GetPreviewQueryVariables>(GetPreviewDocument, options);
      }
export function useGetPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviewQuery, GetPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviewQuery, GetPreviewQueryVariables>(GetPreviewDocument, options);
        }
export type GetPreviewQueryHookResult = ReturnType<typeof useGetPreviewQuery>;
export type GetPreviewLazyQueryHookResult = ReturnType<typeof useGetPreviewLazyQuery>;
export type GetPreviewQueryResult = Apollo.QueryResult<GetPreviewQuery, GetPreviewQueryVariables>;
export const GetGraphLastUpdatedDocument = gql`
    query GetGraphLastUpdated($workspaceId: String!, $graphId: String) {
  getGraphs(workspaceId: $workspaceId, graphId: $graphId) {
    updatedAt
  }
}
    `;

/**
 * __useGetGraphLastUpdatedQuery__
 *
 * To run a query within a React component, call `useGetGraphLastUpdatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphLastUpdatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphLastUpdatedQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      graphId: // value for 'graphId'
 *   },
 * });
 */
export function useGetGraphLastUpdatedQuery(baseOptions: Apollo.QueryHookOptions<GetGraphLastUpdatedQuery, GetGraphLastUpdatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphLastUpdatedQuery, GetGraphLastUpdatedQueryVariables>(GetGraphLastUpdatedDocument, options);
      }
export function useGetGraphLastUpdatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphLastUpdatedQuery, GetGraphLastUpdatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphLastUpdatedQuery, GetGraphLastUpdatedQueryVariables>(GetGraphLastUpdatedDocument, options);
        }
export type GetGraphLastUpdatedQueryHookResult = ReturnType<typeof useGetGraphLastUpdatedQuery>;
export type GetGraphLastUpdatedLazyQueryHookResult = ReturnType<typeof useGetGraphLastUpdatedLazyQuery>;
export type GetGraphLastUpdatedQueryResult = Apollo.QueryResult<GetGraphLastUpdatedQuery, GetGraphLastUpdatedQueryVariables>;
export const GetChannelSchemaDocument = gql`
    query GetChannelSchema($channelId: String) {
  getChannelSchema(channelId: $channelId)
}
    `;

/**
 * __useGetChannelSchemaQuery__
 *
 * To run a query within a React component, call `useGetChannelSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelSchemaQuery({
 *   variables: {
 *      channelId: // value for 'channelId'
 *   },
 * });
 */
export function useGetChannelSchemaQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelSchemaQuery, GetChannelSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelSchemaQuery, GetChannelSchemaQueryVariables>(GetChannelSchemaDocument, options);
      }
export function useGetChannelSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelSchemaQuery, GetChannelSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelSchemaQuery, GetChannelSchemaQueryVariables>(GetChannelSchemaDocument, options);
        }
export type GetChannelSchemaQueryHookResult = ReturnType<typeof useGetChannelSchemaQuery>;
export type GetChannelSchemaLazyQueryHookResult = ReturnType<typeof useGetChannelSchemaLazyQuery>;
export type GetChannelSchemaQueryResult = Apollo.QueryResult<GetChannelSchemaQuery, GetChannelSchemaQueryVariables>;
export const GetPreviewLogDocument = gql`
    query GetPreviewLog($workspaceId: String!, $previewId: String!) {
  getPreviewLog(workspaceId: $workspaceId, previewId: $previewId) {
    log
    previewId
    status
  }
}
    `;

/**
 * __useGetPreviewLogQuery__
 *
 * To run a query within a React component, call `useGetPreviewLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviewLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviewLogQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      previewId: // value for 'previewId'
 *   },
 * });
 */
export function useGetPreviewLogQuery(baseOptions: Apollo.QueryHookOptions<GetPreviewLogQuery, GetPreviewLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviewLogQuery, GetPreviewLogQueryVariables>(GetPreviewLogDocument, options);
      }
export function useGetPreviewLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviewLogQuery, GetPreviewLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviewLogQuery, GetPreviewLogQueryVariables>(GetPreviewLogDocument, options);
        }
export type GetPreviewLogQueryHookResult = ReturnType<typeof useGetPreviewLogQuery>;
export type GetPreviewLogLazyQueryHookResult = ReturnType<typeof useGetPreviewLogLazyQuery>;
export type GetPreviewLogQueryResult = Apollo.QueryResult<GetPreviewLogQuery, GetPreviewLogQueryVariables>;
export const GetGraphsWithFiltersDocument = gql`
    query GetGraphsWithFilters($workspaceId: String!, $filters: GraphFilter, $staged: Boolean, $cursor: String, $limit: Int) {
  getGraphs(
    workspaceId: $workspaceId
    filters: $filters
    staged: $staged
    cursor: $cursor
    limit: $limit
  ) {
    channel
    createdAt
    createdBy
    description
    graphId
    name
    tags
    thumbnail
    updatedAt
    workspaceId
  }
}
    `;

/**
 * __useGetGraphsWithFiltersQuery__
 *
 * To run a query within a React component, call `useGetGraphsWithFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphsWithFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphsWithFiltersQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *      staged: // value for 'staged'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetGraphsWithFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetGraphsWithFiltersQuery, GetGraphsWithFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphsWithFiltersQuery, GetGraphsWithFiltersQueryVariables>(GetGraphsWithFiltersDocument, options);
      }
export function useGetGraphsWithFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphsWithFiltersQuery, GetGraphsWithFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphsWithFiltersQuery, GetGraphsWithFiltersQueryVariables>(GetGraphsWithFiltersDocument, options);
        }
export type GetGraphsWithFiltersQueryHookResult = ReturnType<typeof useGetGraphsWithFiltersQuery>;
export type GetGraphsWithFiltersLazyQueryHookResult = ReturnType<typeof useGetGraphsWithFiltersLazyQuery>;
export type GetGraphsWithFiltersQueryResult = Apollo.QueryResult<GetGraphsWithFiltersQuery, GetGraphsWithFiltersQueryVariables>;
export const GetGraphsSearchDetailDocument = gql`
    query GetGraphsSearchDetail($workspaceId: String!, $staged: Boolean, $filters: GraphFilter) {
  getGraphsSearchDetail(
    workspaceId: $workspaceId
    staged: $staged
    filters: $filters
  ) {
    tags {
      value
      display
    }
    channels {
      value
      display
    }
    users {
      value
      display
    }
  }
}
    `;

/**
 * __useGetGraphsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetGraphsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGraphsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGraphsSearchDetailQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      staged: // value for 'staged'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetGraphsSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetGraphsSearchDetailQuery, GetGraphsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGraphsSearchDetailQuery, GetGraphsSearchDetailQueryVariables>(GetGraphsSearchDetailDocument, options);
      }
export function useGetGraphsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGraphsSearchDetailQuery, GetGraphsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGraphsSearchDetailQuery, GetGraphsSearchDetailQueryVariables>(GetGraphsSearchDetailDocument, options);
        }
export type GetGraphsSearchDetailQueryHookResult = ReturnType<typeof useGetGraphsSearchDetailQuery>;
export type GetGraphsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetGraphsSearchDetailLazyQuery>;
export type GetGraphsSearchDetailQueryResult = Apollo.QueryResult<GetGraphsSearchDetailQuery, GetGraphsSearchDetailQueryVariables>;
export const EditStagedGraphDocument = gql`
    mutation EditStagedGraph($graphId: String!, $workspaceId: String!, $name: String, $description: String, $tags: [String]) {
  editGraph(
    graphId: $graphId
    workspaceId: $workspaceId
    name: $name
    description: $description
    tags: $tags
  )
}
    `;
export type EditStagedGraphMutationFn = Apollo.MutationFunction<EditStagedGraphMutation, EditStagedGraphMutationVariables>;

/**
 * __useEditStagedGraphMutation__
 *
 * To run a mutation, you first call `useEditStagedGraphMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditStagedGraphMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editStagedGraphMutation, { data, loading, error }] = useEditStagedGraphMutation({
 *   variables: {
 *      graphId: // value for 'graphId'
 *      workspaceId: // value for 'workspaceId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditStagedGraphMutation(baseOptions?: Apollo.MutationHookOptions<EditStagedGraphMutation, EditStagedGraphMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditStagedGraphMutation, EditStagedGraphMutationVariables>(EditStagedGraphDocument, options);
      }
export type EditStagedGraphMutationHookResult = ReturnType<typeof useEditStagedGraphMutation>;
export type EditStagedGraphMutationResult = Apollo.MutationResult<EditStagedGraphMutation>;
export type EditStagedGraphMutationOptions = Apollo.BaseMutationOptions<EditStagedGraphMutation, EditStagedGraphMutationVariables>;
export const GetJobsDocument = gql`
    query GetJobs($workspaceId: String!, $cursor: String, $limit: Int, $filters: DatasetJobFilter) {
  getDatasetJobs(
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    name
    datasetId
    status
    priority
    graphId
    channelId
    workspaceId
    averageRuntime
    instancesQueued
    instancesRunning
    instancesStarting
    runsSuccess
    runsTimeout
    seed
    runsRunning
    runsFailed
    runsCancelled
    runs
    runsStarting
    runsQueued
    updatedAt
    estimatedEndAt
    createdBy
    createdAt
    channel
  }
}
    `;

/**
 * __useGetJobsQuery__
 *
 * To run a query within a React component, call `useGetJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetJobsQuery(baseOptions: Apollo.QueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
      }
export function useGetJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
        }
export type GetJobsQueryHookResult = ReturnType<typeof useGetJobsQuery>;
export type GetJobsLazyQueryHookResult = ReturnType<typeof useGetJobsLazyQuery>;
export type GetJobsQueryResult = Apollo.QueryResult<GetJobsQuery, GetJobsQueryVariables>;
export const GetStagedGraphsDocument = gql`
    query GetStagedGraphs($workspaceId: String!, $staged: Boolean, $cursor: String, $limit: Int, $filters: GraphFilter) {
  getGraphs(
    workspaceId: $workspaceId
    staged: $staged
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    channel
    channelId
    createdAt
    createdBy
    description
    graphId
    name
    tags
    thumbnail
    workspaceId
    updatedAt
  }
}
    `;

/**
 * __useGetStagedGraphsQuery__
 *
 * To run a query within a React component, call `useGetStagedGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStagedGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStagedGraphsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      staged: // value for 'staged'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetStagedGraphsQuery(baseOptions: Apollo.QueryHookOptions<GetStagedGraphsQuery, GetStagedGraphsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStagedGraphsQuery, GetStagedGraphsQueryVariables>(GetStagedGraphsDocument, options);
      }
export function useGetStagedGraphsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStagedGraphsQuery, GetStagedGraphsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStagedGraphsQuery, GetStagedGraphsQueryVariables>(GetStagedGraphsDocument, options);
        }
export type GetStagedGraphsQueryHookResult = ReturnType<typeof useGetStagedGraphsQuery>;
export type GetStagedGraphsLazyQueryHookResult = ReturnType<typeof useGetStagedGraphsLazyQuery>;
export type GetStagedGraphsQueryResult = Apollo.QueryResult<GetStagedGraphsQuery, GetStagedGraphsQueryVariables>;
export const CreateDatasetDocument = gql`
    mutation CreateDataset($graphId: String!, $name: String!, $runs: Int, $workspaceId: String!, $seed: Int, $priority: Int, $description: String, $tags: [String]) {
  createDataset(
    graphId: $graphId
    name: $name
    runs: $runs
    workspaceId: $workspaceId
    seed: $seed
    priority: $priority
    description: $description
    tags: $tags
  )
}
    `;
export type CreateDatasetMutationFn = Apollo.MutationFunction<CreateDatasetMutation, CreateDatasetMutationVariables>;

/**
 * __useCreateDatasetMutation__
 *
 * To run a mutation, you first call `useCreateDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDatasetMutation, { data, loading, error }] = useCreateDatasetMutation({
 *   variables: {
 *      graphId: // value for 'graphId'
 *      name: // value for 'name'
 *      runs: // value for 'runs'
 *      workspaceId: // value for 'workspaceId'
 *      seed: // value for 'seed'
 *      priority: // value for 'priority'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateDatasetMutation(baseOptions?: Apollo.MutationHookOptions<CreateDatasetMutation, CreateDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDatasetMutation, CreateDatasetMutationVariables>(CreateDatasetDocument, options);
      }
export type CreateDatasetMutationHookResult = ReturnType<typeof useCreateDatasetMutation>;
export type CreateDatasetMutationResult = Apollo.MutationResult<CreateDatasetMutation>;
export type CreateDatasetMutationOptions = Apollo.BaseMutationOptions<CreateDatasetMutation, CreateDatasetMutationVariables>;
export const ClearWorkspaceJobsDocument = gql`
    mutation ClearWorkspaceJobs($workspaceId: String) {
  clearDatasetJobs(workspaceId: $workspaceId)
}
    `;
export type ClearWorkspaceJobsMutationFn = Apollo.MutationFunction<ClearWorkspaceJobsMutation, ClearWorkspaceJobsMutationVariables>;

/**
 * __useClearWorkspaceJobsMutation__
 *
 * To run a mutation, you first call `useClearWorkspaceJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearWorkspaceJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearWorkspaceJobsMutation, { data, loading, error }] = useClearWorkspaceJobsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useClearWorkspaceJobsMutation(baseOptions?: Apollo.MutationHookOptions<ClearWorkspaceJobsMutation, ClearWorkspaceJobsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearWorkspaceJobsMutation, ClearWorkspaceJobsMutationVariables>(ClearWorkspaceJobsDocument, options);
      }
export type ClearWorkspaceJobsMutationHookResult = ReturnType<typeof useClearWorkspaceJobsMutation>;
export type ClearWorkspaceJobsMutationResult = Apollo.MutationResult<ClearWorkspaceJobsMutation>;
export type ClearWorkspaceJobsMutationOptions = Apollo.BaseMutationOptions<ClearWorkspaceJobsMutation, ClearWorkspaceJobsMutationVariables>;
export const HideDatasetDocument = gql`
    mutation HideDataset($workspaceId: String!, $datasetId: String!, $showJob: Boolean) {
  editDataset(workspaceId: $workspaceId, datasetId: $datasetId, showJob: $showJob)
}
    `;
export type HideDatasetMutationFn = Apollo.MutationFunction<HideDatasetMutation, HideDatasetMutationVariables>;

/**
 * __useHideDatasetMutation__
 *
 * To run a mutation, you first call `useHideDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideDatasetMutation, { data, loading, error }] = useHideDatasetMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      showJob: // value for 'showJob'
 *   },
 * });
 */
export function useHideDatasetMutation(baseOptions?: Apollo.MutationHookOptions<HideDatasetMutation, HideDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HideDatasetMutation, HideDatasetMutationVariables>(HideDatasetDocument, options);
      }
export type HideDatasetMutationHookResult = ReturnType<typeof useHideDatasetMutation>;
export type HideDatasetMutationResult = Apollo.MutationResult<HideDatasetMutation>;
export type HideDatasetMutationOptions = Apollo.BaseMutationOptions<HideDatasetMutation, HideDatasetMutationVariables>;
export const GetDatasetJobsSearchDetailDocument = gql`
    query GetDatasetJobsSearchDetail($organizationId: String, $workspaceId: String, $filters: DatasetJobFilter) {
  getDatasetJobsSearchDetail(
    organizationId: $organizationId
    workspaceId: $workspaceId
    filters: $filters
  ) {
    tags {
      value
      display
    }
    users {
      value
      display
    }
    channels {
      value
      display
    }
    type {
      value
      display
    }
  }
}
    `;

/**
 * __useGetDatasetJobsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetDatasetJobsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetJobsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetJobsSearchDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetDatasetJobsSearchDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetDatasetJobsSearchDetailQuery, GetDatasetJobsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetJobsSearchDetailQuery, GetDatasetJobsSearchDetailQueryVariables>(GetDatasetJobsSearchDetailDocument, options);
      }
export function useGetDatasetJobsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetJobsSearchDetailQuery, GetDatasetJobsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetJobsSearchDetailQuery, GetDatasetJobsSearchDetailQueryVariables>(GetDatasetJobsSearchDetailDocument, options);
        }
export type GetDatasetJobsSearchDetailQueryHookResult = ReturnType<typeof useGetDatasetJobsSearchDetailQuery>;
export type GetDatasetJobsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetDatasetJobsSearchDetailLazyQuery>;
export type GetDatasetJobsSearchDetailQueryResult = Apollo.QueryResult<GetDatasetJobsSearchDetailQuery, GetDatasetJobsSearchDetailQueryVariables>;
export const GetRecentJobsDocument = gql`
    query GetRecentJobs($workspaceId: String!) {
  getDatasetJobs(workspaceId: $workspaceId, limit: 15) {
    createdAt
    datasetId
    estimatedEndAt
    name
    status
  }
}
    `;

/**
 * __useGetRecentJobsQuery__
 *
 * To run a query within a React component, call `useGetRecentJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentJobsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetRecentJobsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentJobsQuery, GetRecentJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentJobsQuery, GetRecentJobsQueryVariables>(GetRecentJobsDocument, options);
      }
export function useGetRecentJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentJobsQuery, GetRecentJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentJobsQuery, GetRecentJobsQueryVariables>(GetRecentJobsDocument, options);
        }
export type GetRecentJobsQueryHookResult = ReturnType<typeof useGetRecentJobsQuery>;
export type GetRecentJobsLazyQueryHookResult = ReturnType<typeof useGetRecentJobsLazyQuery>;
export type GetRecentJobsQueryResult = Apollo.QueryResult<GetRecentJobsQuery, GetRecentJobsQueryVariables>;
export const GetRecentGraphsDocument = gql`
    query getRecentGraphs($workspaceId: String!, $staged: Boolean) {
  getGraphs(workspaceId: $workspaceId, staged: $staged, limit: 15) {
    channel
    channelId
    createdAt
    createdBy
    description
    graphId
    name
    tags
    thumbnail
    updatedAt
    workspaceId
  }
}
    `;

/**
 * __useGetRecentGraphsQuery__
 *
 * To run a query within a React component, call `useGetRecentGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentGraphsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      staged: // value for 'staged'
 *   },
 * });
 */
export function useGetRecentGraphsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentGraphsQuery, GetRecentGraphsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentGraphsQuery, GetRecentGraphsQueryVariables>(GetRecentGraphsDocument, options);
      }
export function useGetRecentGraphsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentGraphsQuery, GetRecentGraphsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentGraphsQuery, GetRecentGraphsQueryVariables>(GetRecentGraphsDocument, options);
        }
export type GetRecentGraphsQueryHookResult = ReturnType<typeof useGetRecentGraphsQuery>;
export type GetRecentGraphsLazyQueryHookResult = ReturnType<typeof useGetRecentGraphsLazyQuery>;
export type GetRecentGraphsQueryResult = Apollo.QueryResult<GetRecentGraphsQuery, GetRecentGraphsQueryVariables>;
export const GetRecentDatasetsDocument = gql`
    query getRecentDatasets($workspaceId: String!) {
  getDatasets(workspaceId: $workspaceId, limit: 30) {
    createdAt
    datasetId
    name
    runs
  }
}
    `;

/**
 * __useGetRecentDatasetsQuery__
 *
 * To run a query within a React component, call `useGetRecentDatasetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentDatasetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentDatasetsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetRecentDatasetsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentDatasetsQuery, GetRecentDatasetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentDatasetsQuery, GetRecentDatasetsQueryVariables>(GetRecentDatasetsDocument, options);
      }
export function useGetRecentDatasetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentDatasetsQuery, GetRecentDatasetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentDatasetsQuery, GetRecentDatasetsQueryVariables>(GetRecentDatasetsDocument, options);
        }
export type GetRecentDatasetsQueryHookResult = ReturnType<typeof useGetRecentDatasetsQuery>;
export type GetRecentDatasetsLazyQueryHookResult = ReturnType<typeof useGetRecentDatasetsLazyQuery>;
export type GetRecentDatasetsQueryResult = Apollo.QueryResult<GetRecentDatasetsQuery, GetRecentDatasetsQueryVariables>;
export const GetDatasetImageFilenamesDocument = gql`
    query GetDatasetImageFilenames($workspaceId: String!, $datasetId: String!, $path: String, $cursor: String, $limit: Int) {
  getDatasetFiles(
    workspaceId: $workspaceId
    datasetId: $datasetId
    path: $path
    cursor: $cursor
    limit: $limit
  )
}
    `;

/**
 * __useGetDatasetImageFilenamesQuery__
 *
 * To run a query within a React component, call `useGetDatasetImageFilenamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetImageFilenamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetImageFilenamesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      path: // value for 'path'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDatasetImageFilenamesQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetImageFilenamesQuery, GetDatasetImageFilenamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetImageFilenamesQuery, GetDatasetImageFilenamesQueryVariables>(GetDatasetImageFilenamesDocument, options);
      }
export function useGetDatasetImageFilenamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetImageFilenamesQuery, GetDatasetImageFilenamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetImageFilenamesQuery, GetDatasetImageFilenamesQueryVariables>(GetDatasetImageFilenamesDocument, options);
        }
export type GetDatasetImageFilenamesQueryHookResult = ReturnType<typeof useGetDatasetImageFilenamesQuery>;
export type GetDatasetImageFilenamesLazyQueryHookResult = ReturnType<typeof useGetDatasetImageFilenamesLazyQuery>;
export type GetDatasetImageFilenamesQueryResult = Apollo.QueryResult<GetDatasetImageFilenamesQuery, GetDatasetImageFilenamesQueryVariables>;
export const GetImageInferenceDocument = gql`
    query getImageInference($workspaceId: String!, $inferenceId: String!, $filename: String!) {
  getImageInference(
    workspaceId: $workspaceId
    inferenceId: $inferenceId
    filename: $filename
  ) {
    image
    inferences {
      bbox
      class
      className
      confidence
    }
  }
}
    `;

/**
 * __useGetImageInferenceQuery__
 *
 * To run a query within a React component, call `useGetImageInferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageInferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageInferenceQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      inferenceId: // value for 'inferenceId'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGetImageInferenceQuery(baseOptions: Apollo.QueryHookOptions<GetImageInferenceQuery, GetImageInferenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImageInferenceQuery, GetImageInferenceQueryVariables>(GetImageInferenceDocument, options);
      }
export function useGetImageInferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImageInferenceQuery, GetImageInferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImageInferenceQuery, GetImageInferenceQueryVariables>(GetImageInferenceDocument, options);
        }
export type GetImageInferenceQueryHookResult = ReturnType<typeof useGetImageInferenceQuery>;
export type GetImageInferenceLazyQueryHookResult = ReturnType<typeof useGetImageInferenceLazyQuery>;
export type GetImageInferenceQueryResult = Apollo.QueryResult<GetImageInferenceQuery, GetImageInferenceQueryVariables>;
export const GetImageAnnotationDocument = gql`
    query getImageAnnotation($workspaceId: String!, $datasetId: String!, $filename: String!) {
  getImageAnnotation(
    workspaceId: $workspaceId
    datasetId: $datasetId
    filename: $filename
  ) {
    data
    datasetId
    filename
  }
}
    `;

/**
 * __useGetImageAnnotationQuery__
 *
 * To run a query within a React component, call `useGetImageAnnotationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageAnnotationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageAnnotationQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGetImageAnnotationQuery(baseOptions: Apollo.QueryHookOptions<GetImageAnnotationQuery, GetImageAnnotationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImageAnnotationQuery, GetImageAnnotationQueryVariables>(GetImageAnnotationDocument, options);
      }
export function useGetImageAnnotationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImageAnnotationQuery, GetImageAnnotationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImageAnnotationQuery, GetImageAnnotationQueryVariables>(GetImageAnnotationDocument, options);
        }
export type GetImageAnnotationQueryHookResult = ReturnType<typeof useGetImageAnnotationQuery>;
export type GetImageAnnotationLazyQueryHookResult = ReturnType<typeof useGetImageAnnotationLazyQuery>;
export type GetImageAnnotationQueryResult = Apollo.QueryResult<GetImageAnnotationQuery, GetImageAnnotationQueryVariables>;
export const EditGanDatasetDocument = gql`
    mutation EditGanDataset($datasetId: String!, $workspaceId: String!, $description: String, $name: String, $tags: [String]) {
  editDataset(
    datasetId: $datasetId
    workspaceId: $workspaceId
    description: $description
    name: $name
    tags: $tags
  )
}
    `;
export type EditGanDatasetMutationFn = Apollo.MutationFunction<EditGanDatasetMutation, EditGanDatasetMutationVariables>;

/**
 * __useEditGanDatasetMutation__
 *
 * To run a mutation, you first call `useEditGanDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditGanDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editGanDatasetMutation, { data, loading, error }] = useEditGanDatasetMutation({
 *   variables: {
 *      datasetId: // value for 'datasetId'
 *      workspaceId: // value for 'workspaceId'
 *      description: // value for 'description'
 *      name: // value for 'name'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditGanDatasetMutation(baseOptions?: Apollo.MutationHookOptions<EditGanDatasetMutation, EditGanDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditGanDatasetMutation, EditGanDatasetMutationVariables>(EditGanDatasetDocument, options);
      }
export type EditGanDatasetMutationHookResult = ReturnType<typeof useEditGanDatasetMutation>;
export type EditGanDatasetMutationResult = Apollo.MutationResult<EditGanDatasetMutation>;
export type EditGanDatasetMutationOptions = Apollo.BaseMutationOptions<EditGanDatasetMutation, EditGanDatasetMutationVariables>;
export const EditDatasetDocument = gql`
    mutation EditDataset($datasetId: String!, $workspaceId: String!, $description: String, $name: String, $tags: [String]) {
  editDataset(
    datasetId: $datasetId
    workspaceId: $workspaceId
    description: $description
    name: $name
    tags: $tags
  )
}
    `;
export type EditDatasetMutationFn = Apollo.MutationFunction<EditDatasetMutation, EditDatasetMutationVariables>;

/**
 * __useEditDatasetMutation__
 *
 * To run a mutation, you first call `useEditDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editDatasetMutation, { data, loading, error }] = useEditDatasetMutation({
 *   variables: {
 *      datasetId: // value for 'datasetId'
 *      workspaceId: // value for 'workspaceId'
 *      description: // value for 'description'
 *      name: // value for 'name'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEditDatasetMutation(baseOptions?: Apollo.MutationHookOptions<EditDatasetMutation, EditDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditDatasetMutation, EditDatasetMutationVariables>(EditDatasetDocument, options);
      }
export type EditDatasetMutationHookResult = ReturnType<typeof useEditDatasetMutation>;
export type EditDatasetMutationResult = Apollo.MutationResult<EditDatasetMutation>;
export type EditDatasetMutationOptions = Apollo.BaseMutationOptions<EditDatasetMutation, EditDatasetMutationVariables>;
export const GetDatasetDetailsAnalyticsDocument = gql`
    query GetDatasetDetailsAnalytics($workspaceId: String!, $datasetId: String) {
  getAnalytics(workspaceId: $workspaceId, datasetId: $datasetId) {
    analyticsId
    datasetId
    status
    tags
    type
    workspaceId
  }
}
    `;

/**
 * __useGetDatasetDetailsAnalyticsQuery__
 *
 * To run a query within a React component, call `useGetDatasetDetailsAnalyticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetDetailsAnalyticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetDetailsAnalyticsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetDetailsAnalyticsQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetDetailsAnalyticsQuery, GetDatasetDetailsAnalyticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetDetailsAnalyticsQuery, GetDatasetDetailsAnalyticsQueryVariables>(GetDatasetDetailsAnalyticsDocument, options);
      }
export function useGetDatasetDetailsAnalyticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetDetailsAnalyticsQuery, GetDatasetDetailsAnalyticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetDetailsAnalyticsQuery, GetDatasetDetailsAnalyticsQueryVariables>(GetDatasetDetailsAnalyticsDocument, options);
        }
export type GetDatasetDetailsAnalyticsQueryHookResult = ReturnType<typeof useGetDatasetDetailsAnalyticsQuery>;
export type GetDatasetDetailsAnalyticsLazyQueryHookResult = ReturnType<typeof useGetDatasetDetailsAnalyticsLazyQuery>;
export type GetDatasetDetailsAnalyticsQueryResult = Apollo.QueryResult<GetDatasetDetailsAnalyticsQuery, GetDatasetDetailsAnalyticsQueryVariables>;
export const GetAnnotationsDocument = gql`
    query GetAnnotations($workspaceId: String!, $datasetId: String) {
  getAnnotations(workspaceId: $workspaceId, datasetId: $datasetId) {
    annotationId
    datasetId
    format
    map
    status
    tags
    updatedAt
    workspaceId
  }
}
    `;

/**
 * __useGetAnnotationsQuery__
 *
 * To run a query within a React component, call `useGetAnnotationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnotationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnotationsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetAnnotationsQuery(baseOptions: Apollo.QueryHookOptions<GetAnnotationsQuery, GetAnnotationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnotationsQuery, GetAnnotationsQueryVariables>(GetAnnotationsDocument, options);
      }
export function useGetAnnotationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnotationsQuery, GetAnnotationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnotationsQuery, GetAnnotationsQueryVariables>(GetAnnotationsDocument, options);
        }
export type GetAnnotationsQueryHookResult = ReturnType<typeof useGetAnnotationsQuery>;
export type GetAnnotationsLazyQueryHookResult = ReturnType<typeof useGetAnnotationsLazyQuery>;
export type GetAnnotationsQueryResult = Apollo.QueryResult<GetAnnotationsQuery, GetAnnotationsQueryVariables>;
export const GetDatasetDetailsGanDatasetsDocument = gql`
    query GetDatasetDetailsGANDatasets($workspaceId: String!, $datasetId: String) {
  getGANDatasets(workspaceId: $workspaceId, datasetId: $datasetId) {
    datasetId
    description
    model
    name
    status
    tags
    updatedAt
    workspaceId
  }
}
    `;

/**
 * __useGetDatasetDetailsGanDatasetsQuery__
 *
 * To run a query within a React component, call `useGetDatasetDetailsGanDatasetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetDetailsGanDatasetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetDetailsGanDatasetsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetDetailsGanDatasetsQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetDetailsGanDatasetsQuery, GetDatasetDetailsGanDatasetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetDetailsGanDatasetsQuery, GetDatasetDetailsGanDatasetsQueryVariables>(GetDatasetDetailsGanDatasetsDocument, options);
      }
export function useGetDatasetDetailsGanDatasetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetDetailsGanDatasetsQuery, GetDatasetDetailsGanDatasetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetDetailsGanDatasetsQuery, GetDatasetDetailsGanDatasetsQueryVariables>(GetDatasetDetailsGanDatasetsDocument, options);
        }
export type GetDatasetDetailsGanDatasetsQueryHookResult = ReturnType<typeof useGetDatasetDetailsGanDatasetsQuery>;
export type GetDatasetDetailsGanDatasetsLazyQueryHookResult = ReturnType<typeof useGetDatasetDetailsGanDatasetsLazyQuery>;
export type GetDatasetDetailsGanDatasetsQueryResult = Apollo.QueryResult<GetDatasetDetailsGanDatasetsQuery, GetDatasetDetailsGanDatasetsQueryVariables>;
export const GetDatasetDetailsUmapsDocument = gql`
    query GetDatasetDetailsUmaps($workspaceId: String!, $datasetId: String) {
  getUMAPs(workspaceId: $workspaceId, datasetId: $datasetId) {
    name
    status
    tags
    umapId
  }
}
    `;

/**
 * __useGetDatasetDetailsUmapsQuery__
 *
 * To run a query within a React component, call `useGetDatasetDetailsUmapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetDetailsUmapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetDetailsUmapsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetDetailsUmapsQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetDetailsUmapsQuery, GetDatasetDetailsUmapsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetDetailsUmapsQuery, GetDatasetDetailsUmapsQueryVariables>(GetDatasetDetailsUmapsDocument, options);
      }
export function useGetDatasetDetailsUmapsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetDetailsUmapsQuery, GetDatasetDetailsUmapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetDetailsUmapsQuery, GetDatasetDetailsUmapsQueryVariables>(GetDatasetDetailsUmapsDocument, options);
        }
export type GetDatasetDetailsUmapsQueryHookResult = ReturnType<typeof useGetDatasetDetailsUmapsQuery>;
export type GetDatasetDetailsUmapsLazyQueryHookResult = ReturnType<typeof useGetDatasetDetailsUmapsLazyQuery>;
export type GetDatasetDetailsUmapsQueryResult = Apollo.QueryResult<GetDatasetDetailsUmapsQuery, GetDatasetDetailsUmapsQueryVariables>;
export const GetDatasetsDocument = gql`
    query GetDatasets($workspaceId: String!, $cursor: String, $limit: Int) {
  getDatasets(workspaceId: $workspaceId, cursor: $cursor, limit: $limit) {
    channel
    classes
    createdAt
    createdBy
    datasetId
    description
    files
    graphId
    name
    runs
    seed
    size
    status
    tags
  }
}
    `;

/**
 * __useGetDatasetsQuery__
 *
 * To run a query within a React component, call `useGetDatasetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetDatasetsQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetsQuery, GetDatasetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetsQuery, GetDatasetsQueryVariables>(GetDatasetsDocument, options);
      }
export function useGetDatasetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetsQuery, GetDatasetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetsQuery, GetDatasetsQueryVariables>(GetDatasetsDocument, options);
        }
export type GetDatasetsQueryHookResult = ReturnType<typeof useGetDatasetsQuery>;
export type GetDatasetsLazyQueryHookResult = ReturnType<typeof useGetDatasetsLazyQuery>;
export type GetDatasetsQueryResult = Apollo.QueryResult<GetDatasetsQuery, GetDatasetsQueryVariables>;
export const GetDatasetInferencesDocument = gql`
    query GetDatasetInferences($workspaceId: String!, $datasetId: String) {
  getMLInferences(workspaceId: $workspaceId, datasetId: $datasetId) {
    inferenceId
    dataset
    datasetId
    modelId
    model
    status
    tags
    workspaceId
  }
}
    `;

/**
 * __useGetDatasetInferencesQuery__
 *
 * To run a query within a React component, call `useGetDatasetInferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetInferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetInferencesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetInferencesQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetInferencesQuery, GetDatasetInferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetInferencesQuery, GetDatasetInferencesQueryVariables>(GetDatasetInferencesDocument, options);
      }
export function useGetDatasetInferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetInferencesQuery, GetDatasetInferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetInferencesQuery, GetDatasetInferencesQueryVariables>(GetDatasetInferencesDocument, options);
        }
export type GetDatasetInferencesQueryHookResult = ReturnType<typeof useGetDatasetInferencesQuery>;
export type GetDatasetInferencesLazyQueryHookResult = ReturnType<typeof useGetDatasetInferencesLazyQuery>;
export type GetDatasetInferencesQueryResult = Apollo.QueryResult<GetDatasetInferencesQuery, GetDatasetInferencesQueryVariables>;
export const GetDatasetModelsDocument = gql`
    query GetDatasetModels($workspaceId: String!, $datasetId: String) {
  getMLModels(workspaceId: $workspaceId, datasetId: $datasetId) {
    modelId
    name
    status
    tags
    workspaceId
  }
}
    `;

/**
 * __useGetDatasetModelsQuery__
 *
 * To run a query within a React component, call `useGetDatasetModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetModelsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      datasetId: // value for 'datasetId'
 *   },
 * });
 */
export function useGetDatasetModelsQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetModelsQuery, GetDatasetModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetModelsQuery, GetDatasetModelsQueryVariables>(GetDatasetModelsDocument, options);
      }
export function useGetDatasetModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetModelsQuery, GetDatasetModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetModelsQuery, GetDatasetModelsQueryVariables>(GetDatasetModelsDocument, options);
        }
export type GetDatasetModelsQueryHookResult = ReturnType<typeof useGetDatasetModelsQuery>;
export type GetDatasetModelsLazyQueryHookResult = ReturnType<typeof useGetDatasetModelsLazyQuery>;
export type GetDatasetModelsQueryResult = Apollo.QueryResult<GetDatasetModelsQuery, GetDatasetModelsQueryVariables>;
export const GetDatasetsWithFilterDocument = gql`
    query GetDatasetsWithFilter($workspaceId: String!, $cursor: String, $limit: Int, $filters: DatasetFilter) {
  getDatasets(
    workspaceId: $workspaceId
    cursor: $cursor
    limit: $limit
    filters: $filters
  ) {
    channel
    channelId
    classes
    createdAt
    createdBy
    datasetId
    description
    files
    graphId
    name
    runs
    seed
    size
    source
    status
    tags
    type
  }
}
    `;

/**
 * __useGetDatasetsWithFilterQuery__
 *
 * To run a query within a React component, call `useGetDatasetsWithFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetsWithFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetsWithFilterQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetDatasetsWithFilterQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetsWithFilterQuery, GetDatasetsWithFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetsWithFilterQuery, GetDatasetsWithFilterQueryVariables>(GetDatasetsWithFilterDocument, options);
      }
export function useGetDatasetsWithFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetsWithFilterQuery, GetDatasetsWithFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetsWithFilterQuery, GetDatasetsWithFilterQueryVariables>(GetDatasetsWithFilterDocument, options);
        }
export type GetDatasetsWithFilterQueryHookResult = ReturnType<typeof useGetDatasetsWithFilterQuery>;
export type GetDatasetsWithFilterLazyQueryHookResult = ReturnType<typeof useGetDatasetsWithFilterLazyQuery>;
export type GetDatasetsWithFilterQueryResult = Apollo.QueryResult<GetDatasetsWithFilterQuery, GetDatasetsWithFilterQueryVariables>;
export const GetDatasetsSearchDetailDocument = gql`
    query GetDatasetsSearchDetail($workspaceId: String!, $filters: DatasetFilter) {
  getDatasetsSearchDetail(workspaceId: $workspaceId, filters: $filters) {
    channels {
      value
      display
    }
    tags {
      value
      display
    }
    type {
      value
      display
    }
    users {
      value
      display
    }
  }
}
    `;

/**
 * __useGetDatasetsSearchDetailQuery__
 *
 * To run a query within a React component, call `useGetDatasetsSearchDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatasetsSearchDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatasetsSearchDetailQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetDatasetsSearchDetailQuery(baseOptions: Apollo.QueryHookOptions<GetDatasetsSearchDetailQuery, GetDatasetsSearchDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatasetsSearchDetailQuery, GetDatasetsSearchDetailQueryVariables>(GetDatasetsSearchDetailDocument, options);
      }
export function useGetDatasetsSearchDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDatasetsSearchDetailQuery, GetDatasetsSearchDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatasetsSearchDetailQuery, GetDatasetsSearchDetailQueryVariables>(GetDatasetsSearchDetailDocument, options);
        }
export type GetDatasetsSearchDetailQueryHookResult = ReturnType<typeof useGetDatasetsSearchDetailQuery>;
export type GetDatasetsSearchDetailLazyQueryHookResult = ReturnType<typeof useGetDatasetsSearchDetailLazyQuery>;
export type GetDatasetsSearchDetailQueryResult = Apollo.QueryResult<GetDatasetsSearchDetailQuery, GetDatasetsSearchDetailQueryVariables>;
export const CreateMixedDatasetDocument = gql`
    mutation CreateMixedDataset($workspaceId: String!, $name: String!, $parameters: String!, $seed: Int, $tags: [String]) {
  createMixedDataset(
    workspaceId: $workspaceId
    name: $name
    parameters: $parameters
    seed: $seed
    tags: $tags
  )
}
    `;
export type CreateMixedDatasetMutationFn = Apollo.MutationFunction<CreateMixedDatasetMutation, CreateMixedDatasetMutationVariables>;

/**
 * __useCreateMixedDatasetMutation__
 *
 * To run a mutation, you first call `useCreateMixedDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMixedDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMixedDatasetMutation, { data, loading, error }] = useCreateMixedDatasetMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      name: // value for 'name'
 *      parameters: // value for 'parameters'
 *      seed: // value for 'seed'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCreateMixedDatasetMutation(baseOptions?: Apollo.MutationHookOptions<CreateMixedDatasetMutation, CreateMixedDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMixedDatasetMutation, CreateMixedDatasetMutationVariables>(CreateMixedDatasetDocument, options);
      }
export type CreateMixedDatasetMutationHookResult = ReturnType<typeof useCreateMixedDatasetMutation>;
export type CreateMixedDatasetMutationResult = Apollo.MutationResult<CreateMixedDatasetMutation>;
export type CreateMixedDatasetMutationOptions = Apollo.BaseMutationOptions<CreateMixedDatasetMutation, CreateMixedDatasetMutationVariables>;